function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { pvId as e, Monitor as t } from "@payment/link-monitor";

function n() {
  return "2.2.3";
}

function r(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function o(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function i(e, t, n) {
  return t && o(e.prototype, t), n && o(e, n), e;
}

function _a2(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function s(e, t, n, r, o, i, a) {
  try {
    var s = e[i](a),
        c = s.value;
  } catch (e) {
    return void n(e);
  }

  s.done ? t(c) : Promise.resolve(c).then(r, o);
}

function c(e) {
  return function () {
    var t = this,
        n = arguments;
    return new Promise(function (r, o) {
      var i = e.apply(t, n);

      function a(e) {
        s(i, r, o, a, c, "next", e);
      }

      function c(e) {
        s(i, r, o, a, c, "throw", e);
      }

      a(void 0);
    });
  };
}

function u(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}

var l = u(function (e) {
  var t = function (e) {
    var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        s = o.toStringTag || "@@toStringTag";

    function c(e, t, n) {
      return Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }

    try {
      c({}, "");
    } catch (e) {
      c = function c(e, t, n) {
        return e[t] = n;
      };
    }

    function u(e, t, n, r) {
      var o = t && t.prototype instanceof y ? t : y,
          i = Object.create(o.prototype),
          a = new E(r || []);
      return i._invoke = function (e, t, n) {
        var r = p;
        return function (o, i) {
          if (r === f) throw new Error("Generator is already running");

          if (r === h) {
            if ("throw" === o) throw i;
            return D();
          }

          for (n.method = o, n.arg = i;;) {
            var a = n.delegate;

            if (a) {
              var s = O(a, n);

              if (s) {
                if (s === v) continue;
                return s;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (r === p) throw r = h, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = f;
            var c = l(e, t, n);

            if ("normal" === c.type) {
              if (r = n.done ? h : d, c.arg === v) continue;
              return {
                value: c.arg,
                done: n.done
              };
            }

            "throw" === c.type && (r = h, n.method = "throw", n.arg = c.arg);
          }
        };
      }(e, n, a), i;
    }

    function l(e, t, n) {
      try {
        return {
          type: "normal",
          arg: e.call(t, n)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = u;
    var p = "suspendedStart",
        d = "suspendedYield",
        f = "executing",
        h = "completed",
        v = {};

    function y() {}

    function m() {}

    function g() {}

    var _ = {};
    c(_, i, function () {
      return this;
    });
    var b = Object.getPrototypeOf,
        w = b && b(b(R([])));
    w && w !== n && r.call(w, i) && (_ = w);
    var C = g.prototype = y.prototype = Object.create(_);

    function x(e) {
      ["next", "throw", "return"].forEach(function (t) {
        c(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }

    function k(e, t) {
      function n(o, i, a, s) {
        var c = l(e[o], e, i);

        if ("throw" !== c.type) {
          var u = c.arg,
              p = u.value;
          return p && "object" == _typeof(p) && r.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
            n("next", e, a, s);
          }, function (e) {
            n("throw", e, a, s);
          }) : t.resolve(p).then(function (e) {
            u.value = e, a(u);
          }, function (e) {
            return n("throw", e, a, s);
          });
        }

        s(c.arg);
      }

      var o;

      this._invoke = function (e, r) {
        function i() {
          return new t(function (t, o) {
            n(e, r, t, o);
          });
        }

        return o = o ? o.then(i, i) : i();
      };
    }

    function O(e, n) {
      var r = e.iterator[n.method];

      if (r === t) {
        if (n.delegate = null, "throw" === n.method) {
          if (e.iterator["return"] && (n.method = "return", n.arg = t, O(e, n), "throw" === n.method)) return v;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var o = l(r, e.iterator, n.arg);
      if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, v;
      var i = o.arg;
      return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, v) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
    }

    function P(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function I(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function E(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(P, this), this.reset(!0);
    }

    function R(e) {
      if (e) {
        var n = e[i];
        if (n) return n.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var o = -1,
              a = function n() {
            for (; ++o < e.length;) {
              if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
            }

            return n.value = t, n.done = !0, n;
          };

          return a.next = a;
        }
      }

      return {
        next: D
      };
    }

    function D() {
      return {
        value: t,
        done: !0
      };
    }

    return m.prototype = g, c(C, "constructor", g), c(g, "constructor", m), m.displayName = c(g, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, c(e, s, "GeneratorFunction")), e.prototype = Object.create(C), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, x(k.prototype), c(k.prototype, a, function () {
      return this;
    }), e.AsyncIterator = k, e.async = function (t, n, r, o, i) {
      void 0 === i && (i = Promise);
      var a = new k(u(t, n, r, o), i);
      return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
        return e.done ? e.value : a.next();
      });
    }, x(C), c(C, s, "Generator"), c(C, i, function () {
      return this;
    }), c(C, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (e) {
      var t = [];

      for (var n in e) {
        t.push(n);
      }

      return t.reverse(), function n() {
        for (; t.length;) {
          var r = t.pop();
          if (r in e) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, e.values = R, E.prototype = {
      constructor: E,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(I), !e) for (var n in this) {
          "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var n = this;

        function o(r, o) {
          return s.type = "throw", s.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i],
              s = a.completion;
          if ("root" === a.tryLoc) return o("end");

          if (a.tryLoc <= this.prev) {
            var c = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");

            if (c && u) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (c) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var o = this.tryEntries[n];

          if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), v;
        }
      },
      "catch": function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];

          if (n.tryLoc === e) {
            var r = n.completion;

            if ("throw" === r.type) {
              var o = r.arg;
              I(n);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, n, r) {
        return this.delegate = {
          iterator: R(e),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = t), v;
      }
    }, e;
  }(e.exports);

  try {
    regeneratorRuntime = t;
  } catch (e) {
    "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
  }
});

function p(e, t) {
  if (null == e) return {};

  var n,
      r,
      o = function (e, t) {
    if (null == e) return {};
    var n,
        r,
        o = {},
        i = Object.keys(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
    }

    return o;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (r = 0; r < i.length; r++) {
      n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
  }

  return o;
}

function d(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function f(e, t) {
  return (f = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function h(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && f(e, t);
}

var v,
    y,
    m,
    g = function (e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
}(u(function (e) {
  function t(n) {
    return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? (e.exports = t = function t(e) {
      return _typeof(e);
    }, e.exports["default"] = e.exports, e.exports.__esModule = !0) : (e.exports = t = function t(e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, e.exports["default"] = e.exports, e.exports.__esModule = !0), t(n);
  }

  e.exports = t, e.exports["default"] = e.exports, e.exports.__esModule = !0;
}));

function _(e, t) {
  return !t || "object" !== g(t) && "function" != typeof t ? d(e) : t;
}

function b(e) {
  return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function w() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function C(e, t, n) {
  return (C = w() ? Reflect.construct : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var o = new (Function.bind.apply(e, r))();
    return n && f(o, n.prototype), o;
  }).apply(null, arguments);
}

function x(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (x = function x(e) {
    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
    var n;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }

    function r() {
      return C(e, arguments, b(this).constructor);
    }

    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), f(r, e);
  })(e);
}

function k(e) {
  return (k = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function O(e, t) {
  var n = {};
  return t.forEach(function (t) {
    e.hasOwnProperty(t) && (n[t] = e[t]);
  }), n;
}

function P(e) {
  return "[object Object]" === Object.prototype.toString.call(e);
}

function I(e) {
  return !e || !!e.nodeType || "object" !== k(e) ? e : JSON.parse(JSON.stringify(e));
}

function E(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

!function (e) {
  e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.NotInit = "1029", e.DeviceNotSupportPaymentMethod = "1100", e.LoadChannelJsFail = "1101", e.InitResultError = "1102", e.HTTPSRequired = "1105", e.NotInUserGesture = "1106", e.UnknownChannelClientError = "1107", e.FrequentRequest = "1904", e.NetworkError = "2905", e.InvalidChannelClient = "4110", e.InvalidNextAction = "4111", e.CreatePayClientFail = "4108", e.ValidateMerchantFail = "4109", e.AbnormalTrade = "4205", e.NotSupportApi = "4206", e.CancelPayClient = "4550";
}(v || (v = {})), function (e) {
  e.AbnormalTrade = "交易异常（交易状态未知）", e.NetworkError = "Payment failed due to network error", e.NotSupportBrowser = "浏览器版本过低不兼容，支付失败", e.DeviceNotSupportPaymentMethod = "当前设备环境不支持该支付方式", e.ValidateMerchantFail = "网站域名末报备渠道", e.CreatePayClientFail = "拉起渠道支付表单失败", e.CancelPayClient = "用户取消支付表单", e.LoadChannelJsFail = "加载渠道 js 出错", e.InitResultError = "支付方式配置错误", e.HTTPSRequired = "当前环境为非 https", e.NotInUserGesture = "创建实例时已脱离用户手势，无法创建", e.UnknownChannelClientError = "其他创建实例未识别到的错误", e.FrequentRequest = "接口请求频繁", e.InvalidChannelClient = "创建渠道实例失败", e.InvalidNextAction = "nextAction 入参出错";
}(y || (y = {})), function (e) {
  e.Fatal = "fatal", e.Error = "error";
}(m || (m = {}));

var R = function (e) {
  h(n, x(Error));
  var t = E(n);

  function n(e) {
    var o,
        i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : v.InnerSDKError,
        s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "UnknownError",
        c = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : m.Error;
    return r(this, n), _a2(d(o = t.call(this, e)), "code", void 0), _a2(d(o), "data", void 0), _a2(d(o), "errorLevel", void 0), o.name = s, o.code = i, o.errorLevel = c, o;
  }

  return i(n, [{
    key: "setAPIErrorData",
    value: function value(e) {
      this.data = n.handleAPIErrorData(e);
    }
  }], [{
    key: "handleAPIErrorData",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        code: v.NetworkError,
        msg: y.NetworkError
      },
          n = {};
      return !P(e) || void 0 === e.code && void 0 === e.msg ? (n.code = t.code, n.msg = t.msg) : (n.code = e.code, n.msg = e.msg), void 0 === (null == e ? void 0 : e.channelCode) && void 0 === (null == e ? void 0 : e.channelMsg) || (n.channelCode = e.channelCode, n.channelMsg = e.channelMsg), n;
    }
  }]), n;
}(),
    D = function (t) {
  h(o, R);
  var n = E(o);

  function o(t) {
    var i,
        s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : v.InnerSDKError,
        c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
        u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : m.Error;
    return r(this, o), _a2(d(i = n.call(this, t, s, c, u)), "pvId", void 0), _a2(d(i), "statusCode", void 0), i.pvId = e, i;
  }

  return o;
}();

function S(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function j(e) {
  return function (e) {
    if (Array.isArray(e)) return S(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return S(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? S(e, t) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function L(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function B(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function T(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function N(e, t, n) {
  return t && T(e.prototype, t), n && T(e, n), e;
}

function A(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function M(e) {
  return (M = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function F(e, t, n) {
  return (F = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
    var r = function (e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = M(e));) {
        ;
      }

      return e;
    }(e, t);

    if (r) {
      var o = Object.getOwnPropertyDescriptor(r, t);
      return o.get ? o.get.call(n) : o.value;
    }
  })(e, t, n || e);
}

function H(e, t) {
  return (H = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function W(e) {
  return (W = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function V(e, t) {
  return !t || "object" !== W(t) && "function" != typeof t ? A(e) : t;
}

var U = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    z = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    q = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    G = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function Z(e) {
  return (e && e.message || "No error message").split("\n").filter(function (e) {
    return !!e;
  })[0];
}

function X(e) {
  try {
    var t = function (e) {
      if (!e.stack) return null;

      for (var t, n, r = [], o = e.stack.split("\n"), i = 0; i < o.length; ++i) {
        if (t = U.exec(o[i])) n = {
          filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr("address at ".length) : t[2],
          "function": t[1] || "?",
          lineno: t[3] ? +t[3] : null,
          colno: t[4] ? +t[4] : null
        };else if (t = q.exec(o[i])) n = {
          filename: t[2],
          "function": t[1] || "?",
          lineno: +t[3],
          colno: t[4] ? +t[4] : null
        };else {
          if (!(t = z.exec(o[i]))) continue;
          0 !== i || t[5] || void 0 === e.columnNumber || (r[0].column = e.columnNumber + 1), n = {
            filename: t[3],
            "function": t[1] || "?",
            lineno: t[4] ? +t[4] : null,
            colno: t[5] ? +t[5] : null
          };
        }
        !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
      }

      return r.length ? {
        value: Z(e),
        type: e.name,
        stacktrace: {
          frames: r.reverse()
        }
      } : null;
    }(e);

    if (t) return t;
  } catch (e) {}

  return {
    value: Z(e),
    type: e && e.name,
    stacktrace: {
      frames: []
    }
  };
}

var K = Object.assign || function (e) {
  for (var t = arguments.length, n = 1; n < t; n++) {
    var r = arguments[n];

    for (var o in r) {
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
  }

  return e;
},
    $ = function () {
  function e(t) {
    if (B(this, e), t.dsn) {
      var n = G.exec(t.dsn),
          r = n ? n.slice(1) : [],
          o = r[5].split("/"),
          i = o.slice(0, -1).join("/");
      this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (i ? "/" + i : "") + "/api/" + o.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
    }

    this.environment = t.environment;
  }

  return N(e, [{
    key: "prepare",
    value: function value(e) {
      return K(this.getRequestBlank(), {
        exception: {
          values: [X(e)]
        }
      });
    }
  }, {
    key: "report",
    value: function value(e) {
      this.send(this.prepare(e));
    }
  }, {
    key: "send",
    value: function value(e) {
      if (this.apiUrl) {
        var t = new XMLHttpRequest();
        t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
      }
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return {
        platform: "javascript",
        sdk: {
          name: "micro-sentry.javascript.browser",
          version: "0.0.0"
        },
        timestamp: Date.now() / 1e3,
        request: {
          url: window.location.toString(),
          headers: {
            "User-Agent": window.navigator.userAgent
          }
        },
        environment: this.environment
      };
    }
  }]), e;
}();

function Y(e, t) {
  return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
}

var J = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && H(e, t);
  }(n, $);

  var t = function (e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = M(e);

      if (t) {
        var o = M(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);

      return V(this, n);
    };
  }(n);

  function n(e) {
    var r;
    B(this, n), (r = t.call(this, e)).options = e, r.destroyed = !1, r._state = {};
    var o = r.options || {},
        i = o.plugins,
        a = void 0 === i ? [] : i,
        s = o.beforeSend,
        c = void 0 === s ? function (e) {
      return e;
    } : s,
        u = o.beforeBreadcrumb,
        l = void 0 === u ? function (e) {
      return e;
    } : u,
        p = o.blacklistUrls,
        d = void 0 === p ? [] : p,
        f = o.ignoreErrors,
        h = void 0 === f ? [] : f,
        v = o.release,
        y = void 0 === v ? void 0 : v;
    return r.plugins = a.map(function (e) {
      return new e(A(r));
    }), r.beforeSend = c, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = h, r.release = y, r;
  }

  return N(n, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "clearState",
    value: function value() {
      this._state = {};
    }
  }, {
    key: "setTags",
    value: function value(e) {
      return this.setKeyState("tags", Object.assign({}, e)), this;
    }
  }, {
    key: "setTag",
    value: function value(e, t) {
      return this.extendState({
        tags: L({}, e, t)
      }), this;
    }
  }, {
    key: "setExtra",
    value: function value(e, t) {
      return this.extendState({
        extra: L({}, e, t)
      }), this;
    }
  }, {
    key: "setExtras",
    value: function value(e) {
      return this.setKeyState("extra", Object.assign({}, e)), this;
    }
  }, {
    key: "setUser",
    value: function value(e) {
      return this.setKeyState("user", Object.assign({}, e)), this;
    }
  }, {
    key: "clone",
    value: function value() {
      var e = new n(Object.assign(Object.assign({}, this.options), {
        plugins: []
      }));
      return e.extendState(this.state), e;
    }
  }, {
    key: "withScope",
    value: function value(e) {
      var t = this.clone();
      e(t), t.destroy(), this.setBreadcrumbs(void 0);
    }
  }, {
    key: "addBreadcrumb",
    value: function value(e) {
      this.extendState({
        breadcrumbs: [Object.assign({
          timestamp: Date.now() / 1e3
        }, this.beforeBreadcrumb(e))]
      });
    }
  }, {
    key: "setBreadcrumbs",
    value: function value(e) {
      this.setKeyState("breadcrumbs", e);
    }
  }, {
    key: "captureMessage",
    value: function value(e, t) {
      this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
        message: e,
        level: t
      }));
    }
  }, {
    key: "destroy",
    value: function value() {
      this.destroyed = !0, this.plugins.forEach(function (e) {
        e.destroy && e.destroy();
      });
    }
  }, {
    key: "isIgnoredError",
    value: function value(e) {
      var t = this;
      return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
        return t.ignoreErrors.some(function (t) {
          return Y(e, t);
        });
      });
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return Object.assign(Object.assign({}, F(M(n.prototype), "getRequestBlank", this).call(this)), this.state);
    }
  }, {
    key: "send",
    value: function value(e) {
      this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (F(M(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
        release: this.release
      }, e))), this.setBreadcrumbs(void 0));
    }
  }, {
    key: "getPossibleEventMessages",
    value: function value(e) {
      if (e.message) return [e.message];
      if (e.exception) try {
        var t = e.exception.values && e.exception.values[0] || {},
            n = t.type,
            r = void 0 === n ? "" : n,
            o = t.value,
            i = void 0 === o ? "" : o;
        return ["".concat(i), "".concat(r, ": ").concat(i)];
      } catch (e) {
        return [];
      }
      return [];
    }
  }, {
    key: "isDeniedUrl",
    value: function value(e) {
      if (!this.blacklistUrls.length) return !1;
      var t = this.getEventFilterUrl(e);
      return !!t && this.blacklistUrls.some(function (e) {
        return Y(t, e);
      });
    }
  }, {
    key: "getEventFilterUrl",
    value: function value(e) {
      try {
        if (e.exception) {
          var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
          return t && t[t.length - 1].filename || null;
        }

        return null;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "extendState",
    value: function value(e) {
      var t = this;
      this._state = Object.keys(e).reduce(function (n, r) {
        var o = t.state[r],
            i = Array.isArray(o) ? o : null,
            a = e[r],
            s = Array.isArray(a) ? a : null;
        return Object.assign(Object.assign({}, n), L({}, r, i || s ? [].concat(j(i || []), j(s || [])) : Object.assign(Object.assign({}, "string" != typeof o ? o : {}), "string" != typeof a ? a : {})));
      }, {});
    }
  }, {
    key: "setKeyState",
    value: function value(e, t) {
      this._state[e] = t;
    }
  }]), n;
}();

function Q(e, t, n) {
  var r = e[t],
      o = n(r);
  if ("function" == typeof o) try {
    o.prototype = o.prototype || {}, Object.defineProperties(o, {
      __original__: {
        enumerable: !1,
        value: r
      }
    });
  } catch (e) {}
  e[t] = o;
}

function ee(e) {
  if (!e) return {};
  var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t) return {};
  var n = t[6] || "",
      r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    relative: t[5] + n + r
  };
}

function te() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
}

function ne() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
}

function re(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}

function oe(e) {
  var t = e,
      n = [];
  if (!t || !t.tagName) return "";
  n.push(t.tagName.toLowerCase()), t.id && n.push("#".concat(t.id));
  var r = t.className;

  if (r && "string" == typeof r) {
    var o = r.split(/\s+/);
    n.concat(o.map(function (e) {
      return ".".concat(e);
    }));
  }

  return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
    var r = t.getAttribute(e);
    r && n.push("[".concat(e, '="').concat(r, '"]'));
  }), n.join("");
}

function ie(e) {
  try {
    for (var t, n = e, r = [], o = 0, i = 0, a = " > ".length; n && o++ < 5 && !("html" === (t = oe(n)) || o > 1 && i + r.length * a + t.length >= 80);) {
      r.push(t), i += t.length, n = n.parentNode;
    }

    return r.reverse().join(" > ");
  } catch (e) {
    return "<unknown>";
  }
}

function ae(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
  return Array.isArray(e) ? e.map(function (e) {
    try {
      return String(e);
    } catch (e) {
      return "";
    }
  }).filter(function (e) {
    return "" !== e;
  }).join(t) : "";
}

function se(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ce(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? se(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : se(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

!function () {
  function e(t) {
    B(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
  }

  N(e, [{
    key: "initXHR",
    value: function value() {
      if ("XMLHttpRequest" in window) {
        var e = this,
            t = XMLHttpRequest.prototype;
        Q(t, "open", function (t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }

            var i = this,
                a = r[1];
            i.__sentry_xhr__ = {
              method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
              url: r[1]
            }, "string" == typeof a && "POST" === i.__sentry_xhr__.method && a.match(/sentry_key/) && (i.__sentry_own_request__ = !0);

            var s = function s() {
              if (4 === i.readyState) {
                try {
                  i.__sentry_xhr__ && (i.__sentry_xhr__.status_code = i.status);
                } catch (e) {}

                e.xhrBreadcrumb({
                  args: r,
                  endTimestamp: Date.now(),
                  startTimestamp: Date.now(),
                  xhr: i
                });
              }
            };

            return "onreadystatechange" in i && "function" == typeof i.onreadystatechange ? Q(i, "onreadystatechange", function (e) {
              return function () {
                s();

                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                  n[r] = arguments[r];
                }

                e.apply(i, n);
              };
            }) : i.addEventListener("readystatechange", s), t.apply(i, r);
          };
        }), Q(t, "send", function (t) {
          return function () {
            for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
              r[o] = arguments[o];
            }

            return e.xhrBreadcrumb({
              args: r,
              startTimestamp: Date.now(),
              xhr: this
            }), t.apply(this, r);
          };
        });
      }
    }
  }, {
    key: "initHistory",
    value: function value() {
      var e = this,
          t = window.onpopstate;

      function n(t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
            r[o] = arguments[o];
          }

          var i = r.length > 2 ? r[2] : void 0;

          if (i) {
            var a = e.lastHref,
                s = String(i);
            e.lastHref = s, e.historyBreadcrumb({
              from: a,
              to: s
            });
          }

          return t.apply(this, r);
        };
      }

      window.onpopstate = function () {
        var n = window.location.href,
            r = e.lastHref;

        if (e.lastHref = n, e.historyBreadcrumb({
          from: r,
          to: n
        }), t) {
          for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) {
            i[a] = arguments[a];
          }

          return t.apply(this, i);
        }
      }, Q(window.history, "pushState", n), Q(window.history, "replaceState", n);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.subscriptions.forEach(function (e) {
        return e();
      });
    }
  }, {
    key: "initDOM",
    value: function value() {
      var e = this,
          t = function t(_t2) {
        return e.prepareDomEvent("click", _t2);
      },
          n = function n(t) {
        return e.prepareDomEvent("keypress", t);
      };

      window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
        window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", n, !1);
      });
    }
  }, {
    key: "prepareDomEvent",
    value: function value(e, t) {
      var n;

      try {
        n = t.target ? ie(t.target) : ie(t);
      } catch (e) {
        n = "<unknown>";
      }

      0 !== n.length && this.client.addBreadcrumb({
        category: "ui.".concat(e),
        message: n
      });
    }
  }, {
    key: "initFetch",
    value: function value() {
      var e = this;
      (function () {
        if (!function () {
          if (!("fetch" in window)) return !1;

          try {
            return new Headers(), new Request(""), new Response(), !0;
          } catch (e) {
            return !1;
          }
        }()) return !1;
        if (re(window.fetch)) return !0;
        var e = !1,
            t = window.document;
        if (t && "function" == typeof t.createElement) try {
          var n = t.createElement("iframe");
          n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = re(n.contentWindow.fetch)), t.head.removeChild(n);
        } catch (e) {}
        return e;
      })() && Q(window, "fetch", function (t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
            r[o] = arguments[o];
          }

          var i = {
            args: r,
            fetchData: {
              method: te(r),
              url: ne(r)
            },
            startTimestamp: Date.now()
          };
          return e.fetchBreadcrumb(Object.assign({}, i)), t.apply(window, r).then(function (t) {
            return e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
              endTimestamp: Date.now(),
              response: t
            })), t;
          }, function (t) {
            throw e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
              endTimestamp: Date.now(),
              error: t
            })), t;
          });
        };
      });
    }
  }, {
    key: "fetchBreadcrumb",
    value: function value(e) {
      e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
        category: "fetch",
        data: e.fetchData,
        level: "error",
        type: "http"
      }) : this.client.addBreadcrumb({
        category: "fetch",
        data: Object.assign(Object.assign({}, e.fetchData), {
          status_code: e.response.status
        }),
        type: "http"
      })));
    }
  }, {
    key: "xhrBreadcrumb",
    value: function value(e) {
      if (e.endTimestamp) {
        if (e.xhr.__sentry_own_request__) return;
        this.client.addBreadcrumb({
          category: "xhr",
          data: e.xhr.__sentry_xhr__,
          type: "http"
        });
      }
    }
  }, {
    key: "initConsole",
    value: function value() {
      var e = this;
      ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
        t in window.console && Q(window.console, t, function (n) {
          return function () {
            for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
              o[i] = arguments[i];
            }

            var a = {
              category: "console",
              data: {
                arguments: o.map(function (e) {
                  try {
                    return JSON.stringify(e), e;
                  } catch (t) {
                    return Object.prototype.toString.call(e);
                  }
                }),
                logger: "console"
              },
              level: t,
              message: ae(o, " ")
            };

            if ("assert" === t) {
              if (!1 !== o[0]) return;
              a.message = "Assertion failed: ".concat(ae(o.slice(1), " ") || "console.assert"), a.data.arguments = o.slice(1);
            }

            e.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window.console, o);
          };
        });
      });
    }
  }, {
    key: "historyBreadcrumb",
    value: function value(e) {
      var t = e.from,
          n = e.to,
          r = ee(window.location.href),
          o = ee(t),
          i = ee(n);
      o.path || (o = r), r.protocol === i.protocol && r.host === i.host && (n = i.relative), r.protocol === o.protocol && r.host === o.host && (t = o.relative), this.client.addBreadcrumb({
        category: "navigation",
        data: {
          from: t,
          to: n
        }
      });
    }
  }]);
}();
var ue = new J({
  dsn: "https://08c0eb817b5a4ac5b5b0de28a29a1932@sentry-new.myshopline.com/304",
  release: "2.2.3",
  environment: "production",
  beforeSend: function beforeSend(e) {
    return e;
  }
});

function le(e, t) {
  var n = JSON.stringify(ce(ce({}, e || {}), {}, {
    originErrorMessage: null == t ? void 0 : t.message,
    originErrorData: t ? JSON.stringify(t) : void 0,
    errorLevel: (null == t ? void 0 : t.errorLevel) || (null == e ? void 0 : e.errorLevel) || m.Error
  })),
      r = new Error(n);
  if (null != t && t.stack) try {
    r.stack = t.stack;
  } catch (e) {
    ue.report(e), ue.report(t);
  }
  ue.report(r);
}

function pe(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function de(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? pe(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pe(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

ue.setTag("pvId", e);

var fe = new t("webpaymentsdk", {
  performance: !1
}),
    he = function () {
  function e() {
    r(this, e);
  }

  return i(e, null, [{
    key: "init",
    value: function value(e) {
      fe.init({
        consumer: e.clientId,
        version: "2.2.3",
        projectName: "webpaymentsdk",
        merchantId: e.merchantId,
        channelId: e.channelId,
        paymentMethod: e.paymentMethod,
        countryCode: e.countryCode,
        currency: e.currency,
        environment: "production"
      });
    }
  }, {
    key: "reportError",
    value: function value(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      t instanceof D || le(Object.assign({
        eventName: n
      }, e.formatReportData(r)), t);
    }
  }, {
    key: "handleError",
    value: function value(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default_error",
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (e.reportData(n, r), e.reportError(t, n, r), t instanceof D) throw t;
      var o,
          i,
          a,
          s,
          c = "".concat(n, " ").concat(t.message || "sdk inner error"),
          u = new D(c);
      throw u.statusCode = t.statusCode, u.name = t.name || "Error", u.code = t.code || u.code, u.errorLevel = t.errorLevel || m.Error, u.data = {
        code: (null == r ? void 0 : r.code) || (null === (o = t.data) || void 0 === o ? void 0 : o.code) || u.code || v.InnerSDKError,
        msg: (null == r ? void 0 : r.msg) || (null === (i = t.data) || void 0 === i ? void 0 : i.msg) || c,
        channelCode: (null == r ? void 0 : r.channelCode) || (null === (a = t.data) || void 0 === a ? void 0 : a.channelCode),
        channelMsg: (null == r ? void 0 : r.channelMsg) || (null === (s = t.data) || void 0 === s ? void 0 : s.channelMsg)
      }, u;
    }
  }, {
    key: "formatReportData",
    value: function value(e) {
      if (!e) return {};

      if (e.plugins) {
        var t = de({}, e);
        return delete t.plugins, t;
      }

      return e;
    }
  }, {
    key: "reportData",
    value: function value(t, n) {
      try {
        fe.report(t, n ? {
          extraData: JSON.stringify(e.formatReportData(n))
        } : {});
      } catch (r) {
        e.reportError(r, "".concat(t, "_report_data_error"), n);
      }
    }
  }, {
    key: "reportErrorData",
    value: function value(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m.Error;
      e.reportData(t, n), le(Object.assign({
        eventName: t,
        errorLevel: r
      }, e.formatReportData(n)));
    }
  }]), e;
}(),
    ve = function e(t) {
  var n = this;
  r(this, e), _a2(this, "originData", void 0), _a2(this, "addReportData", function (e) {
    fe.init(e), Object.assign(n.originData, he.formatReportData(e));
  }), _a2(this, "reportData", function (e, t) {
    return he.reportData(e, t);
  }), _a2(this, "reportErrorData", function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m.Error;
    he.reportErrorData(e, Object.assign({
      originData: n.originData
    }, t), r);
  }), _a2(this, "reportError", function (e, t, r) {
    he.reportError(e, t, de(de({}, r || {}), {}, {
      originData: n.originData
    }));
  }), _a2(this, "handleError", function (e, t, r) {
    he.handleError(e, t, de(de({}, r), {}, {
      originData: n.originData
    }));
  }), this.originData = he.formatReportData(t);
},
    ye = ["body"];

function me(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ge(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? me(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : me(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var _e,
    be = ["/payment-sdk/assets/i18n/"],
    we = new (function () {
  function t() {
    var e = this;
    r(this, t), _a2(this, "options", {}), _a2(this, "pvIdBlackList", be), _a2(this, "serialize", function (e) {
      var t = Object.prototype.toString.call(e);
      return e && "[object Object]" === t ? Object.keys(e).map(function (t) {
        return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
      }).join("&") : "";
    }), _a2(this, "isInPvIdBlackList", function (t) {
      if (!t) return !0;

      for (var n = 0; n < e.pvIdBlackList.length; n++) {
        var r = e.pvIdBlackList[n];
        if (t.indexOf(r) > -1) return !0;
      }

      return !1;
    });
  }

  return i(t, [{
    key: "create",
    value: function value(e) {
      this.options = e;
    }
  }, {
    key: "get",
    value: function value(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      t = this.buildUrl(t, n.params);
      var r = {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8"
      };
      return this.isInPvIdBlackList(t) || (r["x-pvid"] = e), this.http(t, ge(ge(ge({
        method: "GET"
      }, this.options), n), {}, {
        headers: ge(ge({}, r), n.headers)
      }));
    }
  }, {
    key: "post",
    value: function value(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          o = {
        Accept: "application/json"
      },
          i = n || r.data;
      return "form" === r.requestType ? (o["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8", i = this.serialize(i)) : (o["Content-Type"] = "application/json;charset=UTF-8", i = i ? JSON.stringify(i) : null), this.isInPvIdBlackList(t) || (o["x-pvid"] = e), this.http(t, ge(ge(ge({
        method: "POST",
        body: i
      }, this.options), r), {}, {
        headers: ge(ge({}, o), r.headers)
      }));
    }
  }, {
    key: "http",
    value: function value(e, t) {
      var n = this;
      return new Promise(function (r, o) {
        var i = new XMLHttpRequest(),
            a = !1,
            s = t.body,
            c = p(t, ye),
            u = n.options.baseUrl && !/^(https?\:)?(\/\/)/.test(e) ? "".concat(n.options.baseUrl).concat(e) : e;

        if (i.open(t.method, u), Object.keys(t.headers).forEach(function (e) {
          i.setRequestHeader(e, t.headers[e]);
        }), i.onreadystatechange = function () {
          if (4 === i.readyState) {
            var e = {
              options: c,
              statusCode: i.status,
              url: u
            },
                t = "";

            try {
              t = JSON.parse(i.responseText);
            } catch (e) {
              t = i.responseText;
            }

            if (/^(2|3)\d{2}$/.test(i.status.toString())) {
              try {
                r(ge({
                  data: t
                }, e));
              } catch (n) {
                r(ge({
                  data: t
                }, e));
              }

              return;
            }

            o(ge({
              data: t
            }, e));
          }
        }, i.send(s), i.onabort = function (t) {
          a = !0, he.reportErrorData("xhr_onabort", {
            url: e,
            readyState: t.target.readyState,
            status: t.target.status,
            statusText: t.target.statusText,
            timeout: t.target.timeout,
            withCredentials: t.target.withCredentials
          });
        }, i.onerror = function (t) {
          he.reportErrorData("xhr_onerror", {
            url: e,
            readyState: t.target.readyState,
            status: t.target.status,
            statusText: t.target.statusText,
            timeout: t.target.timeout,
            withCredentials: t.target.withCredentials
          });
        }, i.ontimeout = function (t) {
          he.reportErrorData("xhr_ontimeout", {
            url: e,
            readyState: t.target.readyState,
            status: t.target.status,
            statusText: t.target.statusText,
            timeout: t.target.timeout,
            withCredentials: t.target.withCredentials
          });
        }, t.timeout) {
          if (a) return;
          setTimeout(function () {
            i.abort();
            var t = new Error("XMLHttpRequest timeout");
            t.code = "ETIMEDOUT", he.reportErrorData("xhr_timeout", {
              url: e
            }), o(t);
          }, t.timeout);
        }
      });
    }
  }, {
    key: "buildUrl",
    value: function value(e, t) {
      var n = Object.prototype.toString.call(t);
      if (!t || "[object Object]" !== n) return e;
      var r = Object.keys(t);
      return (e = decodeURIComponent(e).indexOf("?") > -1 ? "".concat(e, "&") : "".concat(e, "?")) + r.map(function (e) {
        return "".concat(e, "=").concat(t[e]);
      }).join("&");
    }
  }]), t;
}())(),
    Ce = {
  Android: ["(?:(?:Orca-)?Android|Adr)[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "Android|Silk-Accelerated=[a-z]{4,5}", "(?:TwitterAndroid).*[ /](?:[a-z]+ )?(\\d+[\\.\\d]*)", "FB4A.*FBSV/(\\d+[\\.\\d]*);", "BeyondPod|AntennaPod|Podkicker|DoggCatcher|Player FM|okhttp|Podcatcher Deluxe"],
  Linux: ["Arch ?Linux(?:[ /\\-](\\d+[\\.\\d]+))?", "VectorLinux(?: package)?(?:[ /\\-](\\d+[\\.\\d]+))?", "Linux(?:OS)?[^a-z]"],
  iOS: ["CFNetwork/889", "CFNetwork/887", "CFNetwork/811", "CFNetwork/808\\.3", "CFNetwork/808\\.2", "CFNetwork/808\\.1", "CFNetwork/808\\.0", "CFNetwork/808", "CFNetwork/758\\.4\\.3", "CFNetwork/758\\.3\\.15", "CFNetwork/758\\.2\\.[78]", "CFNetwork/758\\.1\\.6", "CFNetwork/758\\.0\\.2", "CFNetwork/711\\.5\\.6", "CFNetwork/711\\.4\\.6", "CFNetwork/711\\.3\\.18", "CFNetwork/711\\.2\\.23", "CFNetwork/711\\.1\\.1[26]", "CFNetwork/711\\.0\\.6", "CFNetwork/672\\.1", "CFNetwork/672\\.0", "CFNetwork/609\\.1", "CFNetwork/60[29]", "CFNetwork/548\\.1", "CFNetwork/548\\.0", "CFNetwork/485\\.13", "CFNetwork/485\\.12", "CFNetwork/485\\.10", "CFNetwork/485\\.2", "CFNetwork/467\\.12", "CFNetwork/459", "(?:CPU OS|iPh(?:one)?[ _]OS|iOS)[ _/](\\d+(?:[_\\.]\\d+)*)", "FBIOS.*FBSV/(\\d+[\\.\\d]*);", "(?:Apple-)?(?:iPhone|iPad|iPod)(?:.*Mac OS X.*Version/(\\d+\\.\\d+)|; Opera)?", "Podcasts/(?:[\\d\\.]+)|Instacast(?:HD)?/(?:\\d\\.[\\d\\.abc]+)|Pocket Casts, iOS|Overcast|Castro|Podcat|i[cC]atcher|RSSRadio/", "iTunes-(iPod|iPad|iPhone)/(?:[\\d\\.]+)"],
  MacOS: ["CFNetwork/887.*(x86_64)", "CFNetwork/811.*(x86_64)", "CFNetwork/807", "CFNetwork/760", "CFNetwork/720", "CFNetwork/673", "CFNetwork/596", "CFNetwork/520", "CFNetwork/454", "CFNetwork/(?:438|422|339|330|221|220|217)", "CFNetwork/12[89]", "CFNetwork/1\\.2", "CFNetwork/1\\.1", "Mac[ +]OS[ +]X(?:[ /](?:Version )?(\\d+(?:[_\\.]\\d+)+))?", "Mac (\\d+(?:[_\\.]\\d+)+)", "Darwin|Macintosh|Mac_PowerPC|PPC|Mac PowerPC|iMac|MacBook"],
  Windows: ["CYGWIN_NT-10.0|Windows NT 10.0|Windows 10", "CYGWIN_NT-6.4|Windows NT 6.4|Windows 10", "CYGWIN_NT-6.3|Windows NT 6.3|Windows 8.1", "CYGWIN_NT-6.2|Windows NT 6.2|Windows 8", "CYGWIN_NT-6.1|Windows NT 6.1|Windows 7", "CYGWIN_NT-6.0|Windows NT 6.0|Windows Vista", "CYGWIN_NT-5.2|Windows NT 5.2|Windows Server 2003 / XP x64", "CYGWIN_NT-5.1|Windows NT 5.1|Windows XP", "CYGWIN_NT-5.0|Windows NT 5.0|Windows 2000", "CYGWIN_NT-4.0|Windows NT 4.0|WinNT|Windows NT", "CYGWIN_ME-4.90|Win 9x 4.90|Windows ME", "CYGWIN_98-4.10|Win98|Windows 98", "CYGWIN_95-4.0|Win32|Win95|Windows 95|Windows_95", "Windows 3.1", "Windows"]
},
    xe = (_e = {}, {
  set: function set(e, t) {
    _e[e] = t;
  },
  get: function get(e) {
    if (_e.hasOwnProperty(e)) return _e[e];
  }
}),
    ke = function ke(e, t) {
  try {
    var n = function (e) {
      var t = xe.get(e);
      if (t) return t.value;
      var n = RegExp("(?:^|[^A-Z0-9-_]|[^A-Z0-9-]_|sprd-)(?:".concat(e, ")"), "i");
      return xe.set(e, {
        value: n
      }), n;
    }(e).exec(t);

    return n ? n.slice(1) : null;
  } catch (e) {
    return null;
  }
};

function Oe(e, t) {
  var _n2 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

  if (!_n2) {
    if (Array.isArray(e) || (_n2 = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return Pe(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Pe(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      _n2 && (e = _n2);

      var r = 0,
          o = function o() {};

      return {
        s: o,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: o
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var i,
      a = !0,
      s = !1;
  return {
    s: function s() {
      _n2 = _n2.call(e);
    },
    n: function n() {
      var e = _n2.next();

      return a = e.done, e;
    },
    e: function e(_e3) {
      s = !0, i = _e3;
    },
    f: function f() {
      try {
        a || null == _n2["return"] || _n2["return"]();
      } finally {
        if (s) throw i;
      }
    }
  };
}

function Pe(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

var Ie = function e() {
  r(this, e), _a2(this, "parse", function (e) {
    for (var t = null, n = 0, r = Object.keys(Ce); n < r.length; n++) {
      var o,
          i = r[n],
          a = Oe(Ce[i]);

      try {
        for (a.s(); !(o = a.n()).done;) {
          var s = o.value;
          if (ke(s, e)) return t = i;
        }
      } catch (e) {
        a.e(e);
      } finally {
        a.f();
      }
    }

    return t;
  }), _a2(this, "getVersion", function (e, t) {
    switch (t) {
      case "MacOS":
        return e.replace(/^.*Mac OS X ([\d_]+).*$/, "$1").replace(/_/g, ".");

      case "iOS":
        return e.replace(/^.*OS ([\d_]+) like.*$/, "$1").replace(/_/g, ".");

      case "Windows":
        return e.replace(/^.*Windows NT ([\d.]+);.*$/, "$1");

      case "Android":
        return e.replace(/^.*Android ([\d.]+);.*$/, "$1");
    }

    return "";
  });
},
    Ee = function Ee(e) {
  var t = null == e ? void 0 : e.parentNode;
  t && t.removeChild(e);
};

function Re() {
  var e = new Ie().parse(navigator.userAgent) || "Other";
  return e ? "Linux" === e || "Windows" === e || "MacOS" === e ? "PC" : "iOS" === e || "Android" === e || "HarmonyOS" === e ? "Mobile" : "Other" : "Other";
}

var De,
    Se,
    je,
    Le = "https://h.online-metrix.net/fp/tags.js",
    Be = "cybs_script",
    Te = function () {
  var e;
  return function () {
    var t = c(l.mark(function t() {
      var n,
          r,
          o,
          i,
          a,
          s,
          c,
          u = arguments;
      return l.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (n = u.length > 0 && void 0 !== u[0] ? u[0] : "", !e) {
                t.next = 5;
                break;
              }

              return t.next = 4, e;

            case 4:
              return t.abrupt("return", t.sent);

            case 5:
              return r = window.screen, o = r.width, i = r.height, a = "".concat(n, "/v1/api/cashier/paysession"), s = {
                screenHeight: o.toString(),
                screenWidth: i.toString()
              }, c = we.get(a, {
                params: s
              }).then(function (e) {
                return e.data.paySession;
              })["catch"](function (t) {
                return e = void 0, he.handleError(t, "get_paysession_error", {
                  url: a,
                  request: {
                    params: s
                  },
                  response: {
                    error: t
                  }
                });
              }), e = c, t.abrupt("return", c);

            case 11:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }));
    return function () {
      return t.apply(this, arguments);
    };
  }();
}(),
    Ne = function () {
  function e(t, n) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "host", void 0), this.env = t, this.host = n || this.env.host;
  }

  return i(e, [{
    key: "init",
    value: function value() {
      var e = this;
      return Te(this.host).then(function (t) {
        document.querySelector("#".concat(Be)) || e.appendCybsScript(t);
        var n = new Ie().parse(navigator.userAgent) || "Other";
        return t.label = e.env.cybsLabel, t.deviceType = Re(), t.deviceOS = n, t;
      });
    }
  }, {
    key: "appendCybsScript",
    value: function value(e) {
      var t = this.env.cybsMerchantId + e.sessionId,
          n = "".concat(Le, "?org_id=").concat(this.env.cybsOrgId, "&session_id=").concat(t);
      this.appendScript(n);
    }
  }, {
    key: "appendScript",
    value: function value(e, t) {
      var n = document.getElementsByTagName("head")[0],
          r = document.createElement("script");
      r.type = "text/javascript", r.src = e, r.id = Be, Ee(document.querySelector("#".concat(Be))), r.onload = r.onreadystatechange = function () {
        this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (t && t(), r.onload = r.onreadystatechange = null);
      }, n.appendChild(r);
    }
  }]), e;
}();

function Ae(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Me(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ae(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ae(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

!function (e) {
  e.Dev = "stg", e.Test = "stg", e.Prev = "prev", e.Prod = "prod";
}(Se || (Se = {})), function (e) {
  e.Dev1 = "dev1", e.Prev1 = "prev1", e.Prev2 = "prev2", e.Prev3 = "prev3", e.Prev4 = "prev4", e.Prod = "prod";
}(je || (je = {}));
var Fe,
    He,
    We,
    Ve,
    Ue,
    ze,
    qe = je.Prod,
    Ge = Object.freeze((_a2(De = {}, je.Dev1, {
  env: je.Dev1,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-dev1.myshopline.com",
  slI18nEnv: Se.Dev,
  imageHost: "https://cdn.myshopline.com/pay/fe-dev"
}), _a2(De, je.Prev1, {
  env: je.Prev1,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-prev1.myshopline.com",
  slI18nEnv: Se.Prev,
  imageHost: "https://cdn.myshopline.com/pay/fe-dev"
}), _a2(De, je.Prev2, {
  env: je.Prev2,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-prev2.myshopline.com",
  slI18nEnv: Se.Prev,
  imageHost: "https://cdn.myshopline.com/pay/fe-dev"
}), _a2(De, je.Prev3, {
  env: je.Prev3,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-prev3.myshopline.com",
  slI18nEnv: Se.Prev,
  imageHost: "https://cdn.myshopline.com/pay/fe-dev"
}), _a2(De, je.Prev4, {
  env: je.Prev4,
  cybsOrgId: "1snn5n9w",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers-prev4.myshopline.com",
  slI18nEnv: Se.Prev,
  imageHost: "https://cdn.myshopline.com/pay/fe-dev"
}), _a2(De, je.Prod, {
  env: je.Prod,
  cybsOrgId: "k8vif92e",
  cybsMerchantId: "yyrisk",
  cybsLabel: "cybs",
  host: "https://cashiers.myshopline.com",
  slI18nEnv: Se.Prod,
  imageHost: "https://cdn.myshopline.com/pay/fe-prod"
}), De));

function Ze(e) {
  return Me({}, Ge[e || qe]);
}

function Xe(e) {
  return e && !/^https?/.test(e) ? "https://".concat(e) : e;
}

!function (e) {
  e.CreditCard = "CreditCard", e.FPX = "FPX", e.PaynowQrCode = "PaynowQrCode", e.AlipayQrCode = "AlipayQrCode", e.AlipayWap = "AlipayWap", e.Paypal = "Paypal", e.BankTransfer = "BankTransfer", e.Cash = "Cash", e.ChannelCashier = "ChannelCashier", e.VirtualAccount = "VirtualAccount", e.AtomeBNPL = "AtomeBNPL", e.ChaileaseBNPL = "ChaileaseBNPL", e.WeChatPay = "WeChatPay", e.ApplePay = "ApplePay";
}(Fe || (Fe = {})), function (e) {
  e.WorldPay = "WorldPay", e.Useepay = "Useepay";
}(He || (He = {})), function (e) {
  e.Oceanpay = "Oceanpay", e.Xendit = "Xendit", e.Stripe = "Stripe", e.AsiaBill = "AsiaBill", e.Useepay = "Useepay", e.Wintopay = "Wintopay", e.Onekpay = "Onekpay";
}(We || (We = {})), function (e) {
  e.FirstName = "firstName", e.Number = "number", e.Cvc = "cvc", e.ExpDate = "expDate";
}(Ve || (Ve = {})), function (e) {
  e.CARD_BINDING_VALIDATE_PAY = "CARD_BINDING_VALIDATE_PAY", e.CARD_BINDING_PAY = "CARD_BINDING_PAY", e.QUICK_PAYMENT = "QUICK_PAYMENT", e.REGULAR_PAYMENT = "REGULAR_PAYMENT";
}(Ue || (Ue = {})), function (e) {
  e.Redirect = "Redirect", e.ExchangeTicket = "ExchangeTicket", e.Confirm = "Confirm", e.QrCode = "QrCode", e.WorldPayChallenge = "WorldPayChallenge", e.WorldPayGather = "WorldPayGather", e.UseepayGather = "UseepayGather", e.UseepayChallenge = "UseepayChallenge", e.CreatePayClient = "CreatePayClient";
}(ze || (ze = {}));

var Ke,
    $e = function $e(e) {
  try {
    var t;
    return Ge[e] ? e = (t = Ze(e)).host : t = function (e) {
      var t;

      for (var n in Ge) {
        if (e && -1 !== e.indexOf(n)) {
          t = n;
          break;
        }
      }

      return Me({}, Ge[t = t || qe]);
    }(e = Xe(e)), he.reportData("init_risk_start"), new Ne(t, e).init().then(function (e) {
      he.reportData("init_risk_end", {
        sessionId: e.sessionId
      });
    });
  } catch (t) {
    he.handleError(t, "init_risk_error", {
      envName: e
    });
  }
},
    Ye = function () {
  function e() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    r(this, e), _a2(this, "options", {}), this.options = t;
  }

  return i(e, [{
    key: "afterInit",
    value: function value(e, t) {}
  }, {
    key: "beforeRender",
    value: function value(e) {}
  }, {
    key: "render",
    value: function value(e) {}
  }, {
    key: "validate",
    value: function value() {
      return !0;
    }
  }, {
    key: "extendPaySession",
    value: function value() {
      return {};
    }
  }, {
    key: "beforeConfirm",
    value: function value() {}
  }, {
    key: "extendConfirmParams",
    value: function value() {
      return {};
    }
  }, {
    key: "afterConfirm",
    value: function value() {}
  }, {
    key: "handlePayAction",
    value: function value(e) {}
  }, {
    key: "destroy",
    value: function value(e) {}
  }]), e;
}();

function Je(e, t, n, r, o, i, a) {
  try {
    var s = e[i](a),
        c = s.value;
  } catch (e) {
    return void n(e);
  }

  s.done ? t(c) : Promise.resolve(c).then(r, o);
}

function Qe(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function et(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function tt(e, t, n) {
  return t && et(e.prototype, t), n && et(e, n), e;
}

function nt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

_a2(Ye, "info", {
  channelId: "",
  paymentMethod: ""
}), function (e) {
  e.PCI = "pci";
}(Ke || (Ke = {}));
var rt = {
  exports: {}
};
!function (e) {
  var t = function (e) {
    var t,
        n = Object.prototype,
        r = n.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        s = o.toStringTag || "@@toStringTag";

    function c(e, t, n) {
      return Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }

    try {
      c({}, "");
    } catch (e) {
      c = function c(e, t, n) {
        return e[t] = n;
      };
    }

    function u(e, t, n, r) {
      var o = t && t.prototype instanceof y ? t : y,
          i = Object.create(o.prototype),
          a = new E(r || []);
      return i._invoke = function (e, t, n) {
        var r = p;
        return function (o, i) {
          if (r === f) throw new Error("Generator is already running");

          if (r === h) {
            if ("throw" === o) throw i;
            return D();
          }

          for (n.method = o, n.arg = i;;) {
            var a = n.delegate;

            if (a) {
              var s = O(a, n);

              if (s) {
                if (s === v) continue;
                return s;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (r === p) throw r = h, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            r = f;
            var c = l(e, t, n);

            if ("normal" === c.type) {
              if (r = n.done ? h : d, c.arg === v) continue;
              return {
                value: c.arg,
                done: n.done
              };
            }

            "throw" === c.type && (r = h, n.method = "throw", n.arg = c.arg);
          }
        };
      }(e, n, a), i;
    }

    function l(e, t, n) {
      try {
        return {
          type: "normal",
          arg: e.call(t, n)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = u;
    var p = "suspendedStart",
        d = "suspendedYield",
        f = "executing",
        h = "completed",
        v = {};

    function y() {}

    function m() {}

    function g() {}

    var _ = {};

    _[i] = function () {
      return this;
    };

    var b = Object.getPrototypeOf,
        w = b && b(b(R([])));
    w && w !== n && r.call(w, i) && (_ = w);
    var C = g.prototype = y.prototype = Object.create(_);

    function x(e) {
      ["next", "throw", "return"].forEach(function (t) {
        c(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }

    function k(e, t) {
      function n(o, i, a, s) {
        var c = l(e[o], e, i);

        if ("throw" !== c.type) {
          var u = c.arg,
              p = u.value;
          return p && "object" == _typeof(p) && r.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
            n("next", e, a, s);
          }, function (e) {
            n("throw", e, a, s);
          }) : t.resolve(p).then(function (e) {
            u.value = e, a(u);
          }, function (e) {
            return n("throw", e, a, s);
          });
        }

        s(c.arg);
      }

      var o;

      this._invoke = function (e, r) {
        function i() {
          return new t(function (t, o) {
            n(e, r, t, o);
          });
        }

        return o = o ? o.then(i, i) : i();
      };
    }

    function O(e, n) {
      var r = e.iterator[n.method];

      if (r === t) {
        if (n.delegate = null, "throw" === n.method) {
          if (e.iterator["return"] && (n.method = "return", n.arg = t, O(e, n), "throw" === n.method)) return v;
          n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var o = l(r, e.iterator, n.arg);
      if ("throw" === o.type) return n.method = "throw", n.arg = o.arg, n.delegate = null, v;
      var i = o.arg;
      return i ? i.done ? (n[e.resultName] = i.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, v) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, v);
    }

    function P(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function I(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function E(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(P, this), this.reset(!0);
    }

    function R(e) {
      if (e) {
        var n = e[i];
        if (n) return n.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var o = -1,
              a = function n() {
            for (; ++o < e.length;) {
              if (r.call(e, o)) return n.value = e[o], n.done = !1, n;
            }

            return n.value = t, n.done = !0, n;
          };

          return a.next = a;
        }
      }

      return {
        next: D
      };
    }

    function D() {
      return {
        value: t,
        done: !0
      };
    }

    return m.prototype = C.constructor = g, g.constructor = m, m.displayName = c(g, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, c(e, s, "GeneratorFunction")), e.prototype = Object.create(C), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, x(k.prototype), k.prototype[a] = function () {
      return this;
    }, e.AsyncIterator = k, e.async = function (t, n, r, o, i) {
      void 0 === i && (i = Promise);
      var a = new k(u(t, n, r, o), i);
      return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
        return e.done ? e.value : a.next();
      });
    }, x(C), c(C, s, "Generator"), C[i] = function () {
      return this;
    }, C.toString = function () {
      return "[object Generator]";
    }, e.keys = function (e) {
      var t = [];

      for (var n in e) {
        t.push(n);
      }

      return t.reverse(), function n() {
        for (; t.length;) {
          var r = t.pop();
          if (r in e) return n.value = r, n.done = !1, n;
        }

        return n.done = !0, n;
      };
    }, e.values = R, E.prototype = {
      constructor: E,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(I), !e) for (var n in this) {
          "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var n = this;

        function o(r, o) {
          return s.type = "throw", s.arg = e, n.next = r, o && (n.method = "next", n.arg = t), !!o;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var a = this.tryEntries[i],
              s = a.completion;
          if ("root" === a.tryLoc) return o("end");

          if (a.tryLoc <= this.prev) {
            var c = r.call(a, "catchLoc"),
                u = r.call(a, "finallyLoc");

            if (c && u) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            } else if (c) {
              if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < a.finallyLoc) return o(a.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var o = this.tryEntries[n];

          if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];
          if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), I(n), v;
        }
      },
      "catch": function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var n = this.tryEntries[t];

          if (n.tryLoc === e) {
            var r = n.completion;

            if ("throw" === r.type) {
              var o = r.arg;
              I(n);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, n, r) {
        return this.delegate = {
          iterator: R(e),
          resultName: n,
          nextLoc: r
        }, "next" === this.method && (this.arg = t), v;
      }
    }, e;
  }(rt.exports);

  try {
    regeneratorRuntime = t;
  } catch (e) {
    Function("r", "regeneratorRuntime = r")(t);
  }
}();

var ot,
    it,
    at,
    st,
    ct = rt.exports,
    ut = function () {
  function e() {
    Qe(this, e), nt(this, "uuid", void 0), nt(this, "iframeHost", "*");
  }

  return tt(e, [{
    key: "setUuid",
    value: function value(e) {
      this.uuid = e;
    }
  }, {
    key: "setIframeHost",
    value: function value(e) {
      this.iframeHost = e || "https://cashiers.myshopline.com";
    }
  }, {
    key: "setAttr",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "setAttr",
        uuid: this.uuid,
        attr: e
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "setInitData",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "initData",
        uuid: this.uuid,
        pvId: e.pvId,
        extraConfig: e.extraConfig,
        parentUrl: e.parentUrl
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "setStyle",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.iframeHost,
          o = {
        eventType: "setStyle",
        uuid: this.uuid,
        type: t,
        name: n,
        style: e
      };
      this.postToChild(n + this.uuid, o, r);
    }
  }, {
    key: "postInput",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          o = {
        eventType: "input",
        name: e,
        uuid: this.uuid,
        isEmpty: t,
        isValid: n
      };
      this.postToParent(o, r);
    }
  }, {
    key: "postFocus",
    value: function value(e, t, n, r) {
      var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "*",
          i = {
        eventType: "focus",
        name: e,
        uuid: this.uuid,
        isEmpty: t,
        isFocus: n,
        isValid: r
      };
      this.postToParent(i, o);
    }
  }, {
    key: "postFocusToNumber",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "focus",
        name: e,
        uuid: this.uuid,
        isFocus: t
      };
      this.postToIframe("number".concat(this.uuid), r, n);
    }
  }, {
    key: "postPasteToNumber",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "paste",
        name: e,
        uuid: this.uuid
      };
      this.postToIframe("number".concat(this.uuid), n, t);
    }
  }, {
    key: "brandChange",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "brandChange",
        uuid: this.uuid,
        brand: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "postValue",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          o = {
        eventType: "input",
        name: e,
        uuid: this.uuid,
        value: t
      };
      this.postToIframe(n + this.uuid, o, r);
    }
  }, {
    key: "postFilling",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "*",
          o = {
        eventType: "filling",
        name: e,
        uuid: this.uuid,
        value: t
      };
      this.postToIframe(n + this.uuid, o, r);
    }
  }, {
    key: "getValidate",
    value: function value(e) {
      var t = e.hasCardName,
          n = e.targetName,
          r = e.origin,
          o = void 0 === r ? this.iframeHost : r,
          i = e.validateItems,
          a = {
        eventType: "getValidate",
        uuid: this.uuid,
        hasCardName: t,
        validateItems: i
      };
      this.postToChild(n + this.uuid, a, o);
    }
  }, {
    key: "postValidate",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "validate",
        uuid: this.uuid,
        isValid: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "getCardBrand",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.iframeHost,
          n = {
        eventType: "getCardBrand",
        uuid: this.uuid
      };
      this.postToChild(e + this.uuid, n, t);
    }
  }, {
    key: "postCardBrand",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "getCardBrand",
        uuid: this.uuid,
        brand: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "getCurrentCardBinValue",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.iframeHost,
          n = {
        eventType: "getCurrentCardBinValue",
        uuid: this.uuid
      };
      this.postToChild(e + this.uuid, n, t);
    }
  }, {
    key: "postCardBinValue",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "getCurrentCardBinValue",
        uuid: this.uuid,
        value: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "getBeforePayData",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "getBeforePayData",
        nextAction: e,
        uuid: this.uuid
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "postBeforePayData",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "getBeforePayData",
        uuid: this.uuid,
        value: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "setCardBinOptions",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "setCardBinOptions",
        cardBinOptions: e,
        uuid: this.uuid
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "postCardBinOptionsResolve",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "*",
          t = {
        eventType: "setCardBinOptions",
        uuid: this.uuid
      };
      this.postToParent(t, e);
    }
  }, {
    key: "getCardToken",
    value: function value(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this.iframeHost,
          o = {
        eventType: "getCardToken",
        options: e,
        hasCardName: t,
        uuid: this.uuid
      };
      this.postToChild(n + this.uuid, o, r);
    }
  }, {
    key: "getCurrentCardInfo",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.iframeHost,
          n = {
        eventType: "getCurrentCardInfo",
        uuid: this.uuid
      };
      this.postToChild(e + this.uuid, n, t);
    }
  }, {
    key: "postCardInfoResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "cardInfoResult",
        uuid: this.uuid,
        status: e,
        value: t
      };
      this.postToParent(r, n);
    }
  }, {
    key: "postCardTokenResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "cardTokenResult",
        uuid: this.uuid,
        status: e,
        value: t
      };
      this.postToParent(r, n);
    }
  }, {
    key: "cardBinValueChange",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "cardBinValueChange",
        uuid: this.uuid,
        value: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "cardBinVerifyChange",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "cardBinVerifyChange",
        uuid: this.uuid,
        value: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "getCardBinVerifyResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.iframeHost,
          r = {
        eventType: "getCardBinVerifyResult",
        readCache: e,
        uuid: this.uuid
      };
      this.postToChild(t + this.uuid, r, n);
    }
  }, {
    key: "postCardBinVerifyResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "cardBinVerifyResult",
        uuid: this.uuid,
        status: e,
        value: t
      };
      this.postToParent(r, n);
    }
  }, {
    key: "pay",
    value: function value(e, t, n, r) {
      var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.iframeHost,
          i = {
        eventType: "pay",
        uuid: this.uuid,
        nextAction: e,
        hasCardName: t,
        requestParams: n
      };
      this.postToChild(r + this.uuid, i, o);
    }
  }, {
    key: "payResult",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "*",
          r = {
        eventType: "payResult",
        uuid: this.uuid,
        status: e,
        value: t
      };
      this.postToParent(r, n);
    }
  }, {
    key: "loadFinished",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "*",
          n = {
        eventType: "loadFinished",
        uuid: this.uuid,
        name: e
      };
      this.postToParent(n, t);
    }
  }, {
    key: "postToChild",
    value: function value(e, t, n) {
      var r;
      (null === (r = window.frames[e]) || void 0 === r ? void 0 : r.postMessage) && window.frames[e].postMessage(t, n);
    }
  }, {
    key: "postToParent",
    value: function value(e, t) {
      window.parent.postMessage(e, t);
    }
  }, {
    key: "postToIframe",
    value: function value(e, t, n) {
      var r;
      (null === (r = window.parent.frames[e]) || void 0 === r ? void 0 : r.postMessage) && window.parent.frames[e].postMessage(t, n);
    }
  }]), e;
}();

function lt(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function pt(e, t) {
  return (pt = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function dt(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && pt(e, t);
}

function ft(e) {
  return (ft = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function ht(e, t) {
  return !t || "object" !== ft(t) && "function" != typeof t ? lt(e) : t;
}

function vt(e) {
  return (vt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function yt() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function mt(e, t, n) {
  return (mt = yt() ? Reflect.construct : function (e, t, n) {
    var r = [null];
    r.push.apply(r, t);
    var o = new (Function.bind.apply(e, r))();
    return n && pt(o, n.prototype), o;
  }).apply(null, arguments);
}

function gt(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (gt = function gt(e) {
    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
    var n;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }

    function r() {
      return mt(e, arguments, vt(this).constructor);
    }

    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), pt(r, e);
  })(e);
}

function _t(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = vt(e);

    if (t) {
      var o = vt(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return ht(this, n);
  };
}

!function (e) {
  e.NotSupportBrowser = "1026", e.InnerSDKError = "1027", e.RenderFail = "1028", e.NetworkError = "2905", e.FrequentRequest = "1904", e.AbnormalTrade = "4205";
}(ot || (ot = {})), function (e) {
  e.AbnormalTrade = "交易异常（交易状态未知）", e.NetworkError = "Payment failed due to network error";
}(it || (it = {})), function (e) {
  e.Fatal = "fatal", e.Error = "error";
}(at || (at = {})), function (e) {
  e.IframeError = "PciIframeError", e.NoDom = "NoDomError";
}(st || (st = {}));

var bt,
    wt,
    Ct,
    xt = function (e) {
  dt(n, gt(Error));

  var t = _t(n);

  function n(e) {
    var r,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ot.InnerSDKError,
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "SilenceError",
        a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : at.Error;
    return Qe(this, n), nt(lt(r = t.call(this, e)), "code", void 0), nt(lt(r), "data", void 0), nt(lt(r), "errorLevel", void 0), r.name = i, r.code = o, r.errorLevel = a, r;
  }

  return n;
}(),
    kt = function (e) {
  dt(n, gt(Error));

  var t = _t(n);

  function n(e) {
    var r,
        o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "UnknownError",
        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ot.InnerSDKError,
        a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : at.Error;
    return Qe(this, n), nt(lt(r = t.call(this, e)), "code", void 0), nt(lt(r), "isReported", !1), nt(lt(r), "data", void 0), nt(lt(r), "errorLevel", void 0), r.name = o, r.code = i, r.errorLevel = a, r;
  }

  return tt(n, [{
    key: "setIsReported",
    value: function value() {
      this.isReported = !0;
    }
  }]), n;
}(),
    Ot = function () {
  function t(e) {
    Qe(this, t), nt(this, "uuid", void 0), nt(this, "parentDom", void 0), this.uuid = e;
  }

  return tt(t, [{
    key: "setParentDom",
    value: function value(e) {
      this.parentDom = e;
    }
  }, {
    key: "mountIframe",
    value: function value(e, t, n, r) {
      var o = this.parentDom.querySelector(e);
      if (!o) throw new kt("Can't find the related dom node to mount the iframe", st.NoDom);
      var i = document.createElement("iframe");
      i.onload = r, i.src = n, i.name = t, i.id = t, i.style.width = "100%", i.style.height = "100%", i.style.border = "none", o.innerHTML = "", o.appendChild(i);
    }
  }, {
    key: "unmountDom",
    value: function value(e) {
      var t = this.parentDom.querySelector(e);
      t && (t.innerHTML = "");
    }
  }, {
    key: "renderIframe",
    value: function value(t, n, r, o) {
      var i = this,
          a = t ? "".concat(t, "/pci-sdk") : "https://cashiers.myshopline.com/pci-sdk";
      n.forEach(function (t) {
        var n = "".concat(a, "/iframe.html?name=").concat(t);
        i.mountIframe('[data-pci="'.concat(t, '"]'), "".concat(t).concat(i.uuid), n, function () {
          var n = r.placeholder,
              i = r.extraConfig;
          o.setInitData({
            pvId: e,
            extraConfig: i,
            parentUrl: window.location.href
          }, t), n && n[t] && o.setAttr({
            placeholder: n[t]
          }, t);
        });
      });
    }
  }]), t;
}();

function Pt(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function It(e) {
  return function (e) {
    if (Array.isArray(e)) return Pt(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return Pt(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Pt(e, t) : void 0;
    }
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function Et(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function Rt(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function Dt(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function St(e, t, n) {
  return t && Dt(e.prototype, t), n && Dt(e, n), e;
}

function jt(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function Lt(e) {
  return (Lt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function Bt(e, t, n) {
  return (Bt = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
    var r = function (e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Lt(e));) {
        ;
      }

      return e;
    }(e, t);

    if (r) {
      var o = Object.getOwnPropertyDescriptor(r, t);
      return o.get ? o.get.call(n) : o.value;
    }
  })(e, t, n || e);
}

function Tt(e, t) {
  return (Tt = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function Nt(e) {
  return (Nt = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

function At(e, t) {
  return !t || "object" !== Nt(t) && "function" != typeof t ? jt(e) : t;
}

!function (e) {
  e.Redirect = "Redirect", e.Confirm = "Confirm", e.QrCode = "QrCode", e.WorldPayGather = "WorldPayGather";
}(bt || (bt = {})), function (e) {
  e.Success = "success", e.Fail = "fail";
}(wt || (wt = {})), function (e) {
  e.Number = "number", e.Cvc = "cvc", e.FirstName = "firstName", e.ExpDate = "expDate";
}(Ct || (Ct = {}));
var Mt = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    Ft = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    Ht = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    Wt = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function Vt(e) {
  return (e && e.message || "No error message").split("\n").filter(function (e) {
    return !!e;
  })[0];
}

function Ut(e) {
  try {
    var t = function (e) {
      if (!e.stack) return null;

      for (var t, n, r = [], o = e.stack.split("\n"), i = 0; i < o.length; ++i) {
        if (t = Mt.exec(o[i])) n = {
          filename: t[2] && 0 === t[2].indexOf("address at ") ? t[2].substr("address at ".length) : t[2],
          "function": t[1] || "?",
          lineno: t[3] ? +t[3] : null,
          colno: t[4] ? +t[4] : null
        };else if (t = Ht.exec(o[i])) n = {
          filename: t[2],
          "function": t[1] || "?",
          lineno: +t[3],
          colno: t[4] ? +t[4] : null
        };else {
          if (!(t = Ft.exec(o[i]))) continue;
          0 !== i || t[5] || void 0 === e.columnNumber || (r[0].column = e.columnNumber + 1), n = {
            filename: t[3],
            "function": t[1] || "?",
            lineno: t[4] ? +t[4] : null,
            colno: t[5] ? +t[5] : null
          };
        }
        !n["function"] && n.lineno && (n["function"] = "?"), r.push(n);
      }

      return r.length ? {
        value: Vt(e),
        type: e.name,
        stacktrace: {
          frames: r.reverse()
        }
      } : null;
    }(e);

    if (t) return t;
  } catch (e) {}

  return {
    value: Vt(e),
    type: e && e.name,
    stacktrace: {
      frames: []
    }
  };
}

var zt = Object.assign || function (e) {
  for (var t = arguments.length, n = 1; n < t; n++) {
    var r = arguments[n];

    for (var o in r) {
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
  }

  return e;
},
    qt = function () {
  function e(t) {
    if (Rt(this, e), t.dsn) {
      var n = Wt.exec(t.dsn),
          r = n ? n.slice(1) : [],
          o = r[5].split("/"),
          i = o.slice(0, -1).join("/");
      this.apiUrl = r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (i ? "/" + i : "") + "/api/" + o.pop() + "/store/", this.authHeader = "Sentry sentry_version=7,sentry_key=" + r[1] + (r[2] ? ",sentry_secret=" + r[2] : "");
    }

    this.environment = t.environment;
  }

  return St(e, [{
    key: "prepare",
    value: function value(e) {
      return zt(this.getRequestBlank(), {
        exception: {
          values: [Ut(e)]
        }
      });
    }
  }, {
    key: "report",
    value: function value(e) {
      this.send(this.prepare(e));
    }
  }, {
    key: "send",
    value: function value(e) {
      if (this.apiUrl) {
        var t = new XMLHttpRequest();
        t.open("POST", this.apiUrl, !0), t.setRequestHeader("Content-type", "application/json"), t.setRequestHeader("X-Sentry-Auth", this.authHeader || ""), t.send(JSON.stringify(e));
      }
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return {
        platform: "javascript",
        sdk: {
          name: "micro-sentry.javascript.browser",
          version: "0.0.0"
        },
        timestamp: Date.now() / 1e3,
        request: {
          url: window.location.toString(),
          headers: {
            "User-Agent": window.navigator.userAgent
          }
        },
        environment: this.environment
      };
    }
  }]), e;
}();

function Gt(e, t) {
  return "[object RegExp]" === Object.prototype.toString.call(t) ? t.test(e) : "string" == typeof t && -1 !== e.indexOf(t);
}

var Zt = function (e) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && Tt(e, t);
  }(n, qt);

  var t = function (e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = Lt(e);

      if (t) {
        var o = Lt(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);

      return At(this, n);
    };
  }(n);

  function n(e) {
    var r;
    Rt(this, n), (r = t.call(this, e)).options = e, r.destroyed = !1, r._state = {};
    var o = r.options || {},
        i = o.plugins,
        a = void 0 === i ? [] : i,
        s = o.beforeSend,
        c = void 0 === s ? function (e) {
      return e;
    } : s,
        u = o.beforeBreadcrumb,
        l = void 0 === u ? function (e) {
      return e;
    } : u,
        p = o.blacklistUrls,
        d = void 0 === p ? [] : p,
        f = o.ignoreErrors,
        h = void 0 === f ? [] : f,
        v = o.release,
        y = void 0 === v ? void 0 : v;
    return r.plugins = a.map(function (e) {
      return new e(jt(r));
    }), r.beforeSend = c, r.beforeBreadcrumb = l, r.blacklistUrls = d, r.ignoreErrors = h, r.release = y, r;
  }

  return St(n, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "clearState",
    value: function value() {
      this._state = {};
    }
  }, {
    key: "setTags",
    value: function value(e) {
      return this.setKeyState("tags", Object.assign({}, e)), this;
    }
  }, {
    key: "setTag",
    value: function value(e, t) {
      return this.extendState({
        tags: Et({}, e, t)
      }), this;
    }
  }, {
    key: "setExtra",
    value: function value(e, t) {
      return this.extendState({
        extra: Et({}, e, t)
      }), this;
    }
  }, {
    key: "setExtras",
    value: function value(e) {
      return this.setKeyState("extra", Object.assign({}, e)), this;
    }
  }, {
    key: "setUser",
    value: function value(e) {
      return this.setKeyState("user", Object.assign({}, e)), this;
    }
  }, {
    key: "clone",
    value: function value() {
      var e = new n(Object.assign(Object.assign({}, this.options), {
        plugins: []
      }));
      return e.extendState(this.state), e;
    }
  }, {
    key: "withScope",
    value: function value(e) {
      var t = this.clone();
      e(t), t.destroy(), this.setBreadcrumbs(void 0);
    }
  }, {
    key: "addBreadcrumb",
    value: function value(e) {
      this.extendState({
        breadcrumbs: [Object.assign({
          timestamp: Date.now() / 1e3
        }, this.beforeBreadcrumb(e))]
      });
    }
  }, {
    key: "setBreadcrumbs",
    value: function value(e) {
      this.setKeyState("breadcrumbs", e);
    }
  }, {
    key: "captureMessage",
    value: function value(e, t) {
      this.send(Object.assign(Object.assign({}, this.getRequestBlank()), {
        message: e,
        level: t
      }));
    }
  }, {
    key: "destroy",
    value: function value() {
      this.destroyed = !0, this.plugins.forEach(function (e) {
        e.destroy && e.destroy();
      });
    }
  }, {
    key: "isIgnoredError",
    value: function value(e) {
      var t = this;
      return !!this.ignoreErrors.length && this.getPossibleEventMessages(e).some(function (e) {
        return t.ignoreErrors.some(function (t) {
          return Gt(e, t);
        });
      });
    }
  }, {
    key: "getRequestBlank",
    value: function value() {
      return Object.assign(Object.assign({}, Bt(Lt(n.prototype), "getRequestBlank", this).call(this)), this.state);
    }
  }, {
    key: "send",
    value: function value(e) {
      this.destroyed || this.isDeniedUrl(e) || this.isIgnoredError(e) || (Bt(Lt(n.prototype), "send", this).call(this, this.beforeSend(Object.assign({
        release: this.release
      }, e))), this.setBreadcrumbs(void 0));
    }
  }, {
    key: "getPossibleEventMessages",
    value: function value(e) {
      if (e.message) return [e.message];
      if (e.exception) try {
        var t = e.exception.values && e.exception.values[0] || {},
            n = t.type,
            r = void 0 === n ? "" : n,
            o = t.value,
            i = void 0 === o ? "" : o;
        return ["".concat(i), "".concat(r, ": ").concat(i)];
      } catch (e) {
        return [];
      }
      return [];
    }
  }, {
    key: "isDeniedUrl",
    value: function value(e) {
      if (!this.blacklistUrls.length) return !1;
      var t = this.getEventFilterUrl(e);
      return !!t && this.blacklistUrls.some(function (e) {
        return Gt(t, e);
      });
    }
  }, {
    key: "getEventFilterUrl",
    value: function value(e) {
      try {
        if (e.exception) {
          var t = e.exception.values && e.exception.values[0].stacktrace && e.exception.values[0].stacktrace.frames;
          return t && t[t.length - 1].filename || null;
        }

        return null;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "extendState",
    value: function value(e) {
      var t = this;
      this._state = Object.keys(e).reduce(function (n, r) {
        var o = t.state[r],
            i = Array.isArray(o) ? o : null,
            a = e[r],
            s = Array.isArray(a) ? a : null;
        return Object.assign(Object.assign({}, n), Et({}, r, i || s ? [].concat(It(i || []), It(s || [])) : Object.assign(Object.assign({}, "string" != typeof o ? o : {}), "string" != typeof a ? a : {})));
      }, {});
    }
  }, {
    key: "setKeyState",
    value: function value(e, t) {
      this._state[e] = t;
    }
  }]), n;
}();

function Xt(e, t, n) {
  var r = e[t],
      o = n(r);
  if ("function" == typeof o) try {
    o.prototype = o.prototype || {}, Object.defineProperties(o, {
      __original__: {
        enumerable: !1,
        value: r
      }
    });
  } catch (e) {}
  e[t] = o;
}

function Kt(e) {
  if (!e) return {};
  var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t) return {};
  var n = t[6] || "",
      r = t[8] || "";
  return {
    host: t[4],
    path: t[5],
    protocol: t[2],
    relative: t[5] + n + r
  };
}

function $t() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "Request" in window && e[0] instanceof Request && e[0].method ? String(e[0].method).toUpperCase() : e[1] && e[1].method ? String(e[1].method).toUpperCase() : "GET";
}

function Yt() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return "string" == typeof e[0] ? e[0] : "Request" in window && e[0] instanceof Request ? e[0].url : String(e[0]);
}

function Jt(e) {
  return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}

function Qt(e) {
  var t = e,
      n = [];
  if (!t || !t.tagName) return "";
  n.push(t.tagName.toLowerCase()), t.id && n.push("#".concat(t.id));
  var r = t.className;

  if (r && "string" == typeof r) {
    var o = r.split(/\s+/);
    n.concat(o.map(function (e) {
      return ".".concat(e);
    }));
  }

  return ["type", "name", "title", "alt", "automation-id"].forEach(function (e) {
    var r = t.getAttribute(e);
    r && n.push("[".concat(e, '="').concat(r, '"]'));
  }), n.join("");
}

function en(e) {
  try {
    for (var t, n = e, r = [], o = 0, i = 0, a = " > ".length; n && o++ < 5 && !("html" === (t = Qt(n)) || o > 1 && i + r.length * a + t.length >= 80);) {
      r.push(t), i += t.length, n = n.parentNode;
    }

    return r.reverse().join(" > ");
  } catch (e) {
    return "<unknown>";
  }
}

function tn(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
  return Array.isArray(e) ? e.map(function (e) {
    try {
      return String(e);
    } catch (e) {
      return "";
    }
  }).filter(function (e) {
    return "" !== e;
  }).join(t) : "";
}

function nn(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function rn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? nn(Object(n), !0).forEach(function (t) {
      nt(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

St(function e(t) {
  Rt(this, e), this.client = t, this.subscriptions = [], this.initDOM(), this.initConsole(), this.initFetch(), this.initHistory(), this.initXHR();
}, [{
  key: "initXHR",
  value: function value() {
    if ("XMLHttpRequest" in window) {
      var e = this,
          t = XMLHttpRequest.prototype;
      Xt(t, "open", function (t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
            r[o] = arguments[o];
          }

          var i = this,
              a = r[1];
          i.__sentry_xhr__ = {
            method: "string" == typeof r[0] ? r[0].toUpperCase() : r[0],
            url: r[1]
          }, "string" == typeof a && "POST" === i.__sentry_xhr__.method && a.match(/sentry_key/) && (i.__sentry_own_request__ = !0);

          var s = function s() {
            if (4 === i.readyState) {
              try {
                i.__sentry_xhr__ && (i.__sentry_xhr__.status_code = i.status);
              } catch (e) {}

              e.xhrBreadcrumb({
                args: r,
                endTimestamp: Date.now(),
                startTimestamp: Date.now(),
                xhr: i
              });
            }
          };

          return "onreadystatechange" in i && "function" == typeof i.onreadystatechange ? Xt(i, "onreadystatechange", function (e) {
            return function () {
              s();

              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                n[r] = arguments[r];
              }

              e.apply(i, n);
            };
          }) : i.addEventListener("readystatechange", s), t.apply(i, r);
        };
      }), Xt(t, "send", function (t) {
        return function () {
          for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
            r[o] = arguments[o];
          }

          return e.xhrBreadcrumb({
            args: r,
            startTimestamp: Date.now(),
            xhr: this
          }), t.apply(this, r);
        };
      });
    }
  }
}, {
  key: "initHistory",
  value: function value() {
    var e = this,
        t = window.onpopstate;

    function n(t) {
      return function () {
        for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
          r[o] = arguments[o];
        }

        var i = r.length > 2 ? r[2] : void 0;

        if (i) {
          var a = e.lastHref,
              s = String(i);
          e.lastHref = s, e.historyBreadcrumb({
            from: a,
            to: s
          });
        }

        return t.apply(this, r);
      };
    }

    window.onpopstate = function () {
      var n = window.location.href,
          r = e.lastHref;

      if (e.lastHref = n, e.historyBreadcrumb({
        from: r,
        to: n
      }), t) {
        for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) {
          i[a] = arguments[a];
        }

        return t.apply(this, i);
      }
    }, Xt(window.history, "pushState", n), Xt(window.history, "replaceState", n);
  }
}, {
  key: "destroy",
  value: function value() {
    this.subscriptions.forEach(function (e) {
      return e();
    });
  }
}, {
  key: "initDOM",
  value: function value() {
    var e = this,
        t = function t(_t3) {
      return e.prepareDomEvent("click", _t3);
    },
        n = function n(t) {
      return e.prepareDomEvent("keypress", t);
    };

    window.document.addEventListener("click", t, !1), window.document.addEventListener("keypress", n, !1), this.subscriptions.push(function () {
      window.document.removeEventListener("click", t, !1), window.document.removeEventListener("keypress", n, !1);
    });
  }
}, {
  key: "prepareDomEvent",
  value: function value(e, t) {
    var n;

    try {
      n = t.target ? en(t.target) : en(t);
    } catch (e) {
      n = "<unknown>";
    }

    0 !== n.length && this.client.addBreadcrumb({
      category: "ui.".concat(e),
      message: n
    });
  }
}, {
  key: "initFetch",
  value: function value() {
    var e = this;
    (function () {
      if (!function () {
        if (!("fetch" in window)) return !1;

        try {
          return new Headers(), new Request(""), new Response(), !0;
        } catch (e) {
          return !1;
        }
      }()) return !1;
      if (Jt(window.fetch)) return !0;
      var e = !1,
          t = window.document;
      if (t && "function" == typeof t.createElement) try {
        var n = t.createElement("iframe");
        n.sandbox.add("allow-scripts"), n.sandbox.add("allow-same-origin"), n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = Jt(n.contentWindow.fetch)), t.head.removeChild(n);
      } catch (e) {}
      return e;
    })() && Xt(window, "fetch", function (t) {
      return function () {
        for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) {
          r[o] = arguments[o];
        }

        var i = {
          args: r,
          fetchData: {
            method: $t(r),
            url: Yt(r)
          },
          startTimestamp: Date.now()
        };
        return e.fetchBreadcrumb(Object.assign({}, i)), t.apply(window, r).then(function (t) {
          return e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
            endTimestamp: Date.now(),
            response: t
          })), t;
        }, function (t) {
          throw e.fetchBreadcrumb(Object.assign(Object.assign({}, i), {
            endTimestamp: Date.now(),
            error: t
          })), t;
        });
      };
    });
  }
}, {
  key: "fetchBreadcrumb",
  value: function value(e) {
    e.endTimestamp && (e.fetchData.url.match(/sentry_key/) && "POST" === e.fetchData.method || (e.error ? this.client.addBreadcrumb({
      category: "fetch",
      data: e.fetchData,
      level: "error",
      type: "http"
    }) : this.client.addBreadcrumb({
      category: "fetch",
      data: Object.assign(Object.assign({}, e.fetchData), {
        status_code: e.response.status
      }),
      type: "http"
    })));
  }
}, {
  key: "xhrBreadcrumb",
  value: function value(e) {
    if (e.endTimestamp) {
      if (e.xhr.__sentry_own_request__) return;
      this.client.addBreadcrumb({
        category: "xhr",
        data: e.xhr.__sentry_xhr__,
        type: "http"
      });
    }
  }
}, {
  key: "initConsole",
  value: function value() {
    var e = this;
    ["debug", "info", "warn", "error", "log", "assert"].forEach(function (t) {
      t in window.console && Xt(window.console, t, function (n) {
        return function () {
          for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
            o[i] = arguments[i];
          }

          var a = {
            category: "console",
            data: {
              arguments: o.map(function (e) {
                try {
                  return JSON.stringify(e), e;
                } catch (t) {
                  return Object.prototype.toString.call(e);
                }
              }),
              logger: "console"
            },
            level: t,
            message: tn(o, " ")
          };

          if ("assert" === t) {
            if (!1 !== o[0]) return;
            a.message = "Assertion failed: ".concat(tn(o.slice(1), " ") || "console.assert"), a.data.arguments = o.slice(1);
          }

          e.client.addBreadcrumb(a), n && Function.prototype.apply.call(n, window.console, o);
        };
      });
    });
  }
}, {
  key: "historyBreadcrumb",
  value: function value(e) {
    var t = e.from,
        n = e.to,
        r = Kt(window.location.href),
        o = Kt(t),
        i = Kt(n);
    o.path || (o = r), r.protocol === i.protocol && r.host === i.host && (n = i.relative), r.protocol === o.protocol && r.host === o.host && (t = o.relative), this.client.addBreadcrumb({
      category: "navigation",
      data: {
        from: t,
        to: n
      }
    });
  }
}]);
var on = new Zt({
  dsn: "https://820fe9124d6a4b4d8ef0ee1e44a29c4b@sentry-new.myshopline.com/305",
  release: "1.13.0",
  environment: "production",
  beforeSend: function beforeSend(e) {
    return e;
  }
});

function an(e, t) {
  if (t) {
    var n = t.message,
        r = t.stack;
    return t.message = JSON.stringify(rn(rn({}, e || {}), {}, {
      originErrorMessage: n,
      originErrorData: JSON.stringify(t),
      errorLevel: t.errorLevel || at.Error
    })), on.report(t), t.message = n, void (t.stack = r);
  }

  on.report(new Error(JSON.stringify(rn(rn({}, e), {}, {
    errorLevel: e.errorLevel || at.Error
  }))));
}

function sn(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function cn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? sn(Object(n), !0).forEach(function (t) {
      nt(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

on.setTag("host", window.location.origin);

var un = new t("webpaymentsdk", {
  performance: !1
}),
    ln = function () {
  function t() {
    Qe(this, t);
  }

  return tt(t, null, [{
    key: "init",
    value: function value() {
      un.init({
        projectName: "pcisdk",
        environment: "production",
        version: "1.13.0"
      }), on.setTag("pvId", e);
    }
  }, {
    key: "reportError",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "report_error",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      e instanceof xt || e.name === st.IframeError || (e instanceof kt ? e.isReported || (an(cn({
        eventName: t
      }, n), e), e.setIsReported()) : an(cn({
        eventName: t
      }, n), e));
    }
  }, {
    key: "handleError",
    value: function value(e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default_error",
          r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (t.reportData(n, r), t.reportError(e, n, r), e instanceof xt || e instanceof kt) throw e;
      var o = "".concat(n, " ").concat(e.message || "pci sdk inner error"),
          i = new xt(o);
      throw Object.assign(i, e), i.name = e.name || "Error", i.code = e.code || i.code, i.errorLevel = e.errorLevel || at.Error, i.data = cn({
        code: ot.InnerSDKError,
        msg: o
      }, e.data || {}), i;
    }
  }, {
    key: "reportData",
    value: function value(e, n) {
      try {
        un.report(e, n ? {
          extraData: JSON.stringify(n)
        } : {});
      } catch (r) {
        t.reportError(r, "".concat(e, "_report_data_error"), {
          data: n
        });
      }
    }
  }, {
    key: "reportErrorData",
    value: function value(e, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : at.Error;
      t.reportData(e, n), an(cn({
        eventName: e,
        errorLevel: r
      }, n));
    }
  }]), t;
}(),
    pn = function e(t) {
  var n = this;
  Qe(this, e), nt(this, "originData", void 0), nt(this, "addReportData", function (e) {
    un.init(e), Object.assign(n.originData, e || {});
  }), nt(this, "reportData", function (e, t) {
    return ln.reportData(e, t);
  }), nt(this, "reportErrorData", function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : at.Error;
    return ln.reportErrorData(e, Object.assign({
      originData: n.originData
    }, t), r);
  }), nt(this, "reportError", function (e, t, r) {
    return ln.reportError(e, t, cn({
      eventName: t,
      originData: n.originData
    }, r || {}));
  }), nt(this, "handleError", function (e, t, r) {
    return ln.handleError(e, t, cn({
      originData: n.originData
    }, r));
  }), this.originData = cn({}, t);
};

nt(pn, "init", void 0);

var dn = function () {
  function e(t) {
    Qe(this, e), nt(this, "config", {}), nt(this, "validateResolve", void 0), nt(this, "payResolve", void 0), nt(this, "payReject", void 0), nt(this, "cardBrandResolve", void 0), nt(this, "cardBinValueResolve", void 0), nt(this, "beforePayResolve", void 0), nt(this, "cardBinVerifyResolve", void 0), nt(this, "cardBinVerifyReject", void 0), nt(this, "cardBinOptionsResolve", void 0), nt(this, "cardTokenResolve", void 0), nt(this, "cardTokenReject", void 0), nt(this, "cardInfoResolve", void 0), nt(this, "cardInfoReject", void 0), nt(this, "iframeLoaded", {}), this.config = t;
  }

  return tt(e, [{
    key: "setValidateResolve",
    value: function value(e) {
      this.validateResolve = e;
    }
  }, {
    key: "setPayResolve",
    value: function value(e) {
      this.payResolve = e;
    }
  }, {
    key: "setPayReject",
    value: function value(e) {
      this.payReject = e;
    }
  }, {
    key: "setCardBrandResolve",
    value: function value(e) {
      this.cardBrandResolve = e;
    }
  }, {
    key: "setCardBinValueResolve",
    value: function value(e) {
      this.cardBinValueResolve = e;
    }
  }, {
    key: "setBeforePayResolve",
    value: function value(e) {
      this.beforePayResolve = e;
    }
  }, {
    key: "setCardBinVerifyResolve",
    value: function value(e) {
      this.cardBinVerifyResolve = e;
    }
  }, {
    key: "setCardBinVerifyReject",
    value: function value(e) {
      this.cardBinVerifyReject = e;
    }
  }, {
    key: "setCardBinOptionsResolve",
    value: function value(e) {
      this.cardBinOptionsResolve = e;
    }
  }, {
    key: "setCardTokenResolve",
    value: function value(e) {
      this.cardTokenResolve = e;
    }
  }, {
    key: "setCardTokenReject",
    value: function value(e) {
      this.cardTokenReject = e;
    }
  }, {
    key: "setCardInfoResolve",
    value: function value(e) {
      this.cardInfoResolve = e;
    }
  }, {
    key: "setCardInfoReject",
    value: function value(e) {
      this.cardInfoReject = e;
    }
  }, {
    key: "setIframeLoaded",
    value: function value(e) {
      var t = this;
      e.forEach(function (e) {
        return t.iframeLoaded[e] = !1;
      });
    }
  }, {
    key: "handleEvent",
    value: function value(e) {
      var t = this,
          n = e.eventType,
          r = e.name,
          o = e.isEmpty,
          i = e.isValid,
          a = e.brand,
          s = e.isFocus,
          c = e.status,
          u = e.value;
      "focus" === n ? this.triggerEvent("onFocus", {
        fieldName: r,
        isEmpty: o,
        isFocus: s,
        isValid: i
      }) : "input" === n ? this.triggerEvent("onFieldValidChange", {
        fieldName: r,
        isValid: i,
        isEmpty: o
      }) : "brandChange" === n ? this.triggerEvent("onBrandChange", {
        brand: a
      }) : "cardBinValueChange" === n ? this.triggerEvent("onCardBinValueChange", u) : "getCurrentCardBinValue" === n ? this.cardBinValueResolve(u) : "validate" === n ? this.validateResolve(i) : "payResult" === n ? c === wt.Success ? this.payResolve(u) : this.payReject(u) : "getCardBrand" === n ? this.cardBrandResolve(a) : "loadFinished" === n ? (this.iframeLoaded[r] = !0, Object.keys(this.iframeLoaded).every(function (e) {
        return t.iframeLoaded[e];
      }) && (ln.reportData("pci_sdk_onInit"), this.triggerEvent("onInit", {}))) : "getBeforePayData" === n ? this.beforePayResolve(u) : "cardBinVerifyChange" === n ? this.triggerEvent("onCardBinChange", u) : "setCardBinOptions" === n ? this.cardBinOptionsResolve() : "cardBinVerifyResult" === n ? c === wt.Success ? this.cardBinVerifyResolve(u) : this.cardBinVerifyReject(u) : "cardTokenResult" === n ? c === wt.Success ? this.cardTokenResolve(u) : this.cardTokenReject(u) : "cardInfoResult" === n && (c === wt.Success ? this.cardInfoResolve(u) : this.cardInfoReject(u));
    }
  }, {
    key: "triggerEvent",
    value: function value(e, t) {
      try {
        this.config[e] && this.config[e](t);
      } catch (n) {
        ln.handleError(n, "pci_sdk_triggerEvent_".concat(e, "_error"), t);
      }
    }
  }]), e;
}(),
    fn = ["number", "expDate", "cvc", "firstName"],
    hn = function () {
  function e(t) {
    Qe(this, e), nt(this, "config", {}), nt(this, "uuid", void 0), nt(this, "host", void 0), nt(this, "mountDom", void 0), nt(this, "postMessageInstance", new ut()), nt(this, "cardIframeInstance", void 0), nt(this, "cardEventInstance", void 0), nt(this, "hasCardName", !0), nt(this, "reporter", void 0), this.initReporter(t);

    try {
      this.reporter.reportData("pci_sdk_constructor_start"), this.host = (null == t ? void 0 : t.host) || "", this.uuid = function () {
        var e = new Date().getTime();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
          var n = (e + 16 * Math.random()) % 16 | 0;
          return e = Math.floor(e / 16), ("x" == t ? n : 3 & n | 8).toString(16);
        });
      }(), this.postMessageInstance.setUuid(this.uuid), this.postMessageInstance.setIframeHost(this.host), this.cardIframeInstance = new Ot(this.uuid), this.reporter.reportData("pci_sdk_constructor_end");
    } catch (e) {
      this.reporter.handleError(e, "pci_sdk_constructor_error");
    }
  }

  var t, n;
  return tt(e, [{
    key: "initReporter",
    value: function value(e) {
      try {
        ln.init(), this.reporter = new pn(e);
      } catch (e) {
        ln.handleError(e, "pci_sdk_init_reporter_error");
      }
    }
  }, {
    key: "create",
    value: function value(e) {
      try {
        this.reporter.reportData("pci_sdk_create_start", {
          config: e
        }), this.config = e, this.cardEventInstance = new dn(e), this.reporter.reportData("pci_sdk_create_end");
      } catch (e) {
        this.reporter.handleError(e, "pci_sdk_create_error");
      }
    }
  }, {
    key: "mount",
    value: function value(e) {
      var t = this;

      try {
        this.reporter.reportData("pci_sdk_mount_start");
        var n = "string" == typeof e ? document.querySelector(e) : e;
        if (this.mountDom = n, this.cardIframeInstance.setParentDom(n), !n) throw new kt("Can't find the mount dom", st.NoDom);
        this.hasCardName = !!n.querySelector('[data-pci="firstName"]');
        var r = this.hasCardName ? fn : fn.slice(0, 3);
        this.cardIframeInstance.renderIframe(this.host, r, this.config, this.postMessageInstance), this.cardEventInstance.setIframeLoaded(r), window.addEventListener("message", function (e) {
          e.data.uuid === t.uuid && t.cardEventInstance.handleEvent(e.data);
        }), this.reporter.reportData("pci_sdk_mount_end", {
          hasCardName: this.hasCardName
        });
      } catch (e) {
        this.reporter.handleError(e, "pci_sdk_mount_error");
      }
    }
  }, {
    key: "setStyle",
    value: function value(e) {
      try {
        this.reporter.reportData("pci_sdk_setStyle_start", {
          params: e
        });
        var t = e.type,
            n = e.fieldName,
            r = e.style;
        this.postMessageInstance.setStyle(r, t, n), this.reporter.reportData("pci_sdk_setStyle_end");
      } catch (e) {
        this.reporter.handleError(e, "pci_sdk_setStyle_error");
      }
    }
  }, {
    key: "destroy",
    value: function value() {
      var e = this;

      try {
        if (this.reporter.reportData("pci_sdk_destroy_start"), !this.mountDom) return void this.reporter.reportData("pci_sdk_destroy_no_dom");
        fn.forEach(function (t) {
          return e.cardIframeInstance.unmountDom('[data-pci="'.concat(t, '"]'));
        }), this.reporter.reportData("pci_sdk_destroy_end");
      } catch (e) {
        this.reporter.handleError(e, "pci_sdk_destroy_error");
      }
    }
  }, {
    key: "validate",
    value: (t = ct.mark(function e(t) {
      var n = this;
      return ct.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.reporter.reportData("pci_sdk_validate_start"), e.abrupt("return", new Promise(function (e) {
                n.cardEventInstance.setValidateResolve(e), n.postMessageInstance.getValidate({
                  hasCardName: n.hasCardName,
                  targetName: "number",
                  validateItems: t
                });
              }).then(function (e) {
                return n.reporter.reportData("pci_sdk_validate_end", {
                  validateResult: e
                }), e;
              })["catch"](function (e) {
                return n.reporter.handleError(e, "pci_sdk_validate_error");
              }));

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    }), n = function n() {
      var e = this,
          n = arguments;
      return new Promise(function (r, o) {
        var i = t.apply(e, n);

        function a(e) {
          Je(i, r, o, a, s, "next", e);
        }

        function s(e) {
          Je(i, r, o, a, s, "throw", e);
        }

        a(void 0);
      });
    }, function (e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: function value(e) {
      var t = this,
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return this.reporter.reportData("pci_sdk_pay_start", {
        nextAction: e
      }), new Promise(function (r, o) {
        t.cardEventInstance.setPayResolve(r), t.cardEventInstance.setPayReject(o), t.postMessageInstance.pay(e, t.hasCardName, n, "number");
      }).then(function (e) {
        return t.reporter.reportData("pci_sdk_pay_end", {
          payResult: e
        }), e;
      })["catch"](function (e) {
        return t.reporter.handleError(e, "pci_sdk_pay_error");
      });
    }
  }, {
    key: "getCardBrand",
    value: function value() {
      var e = this;
      return this.reporter.reportData("pci_sdk_getCardBrand_start"), new Promise(function (t) {
        e.cardEventInstance.setCardBrandResolve(t), e.postMessageInstance.getCardBrand("number");
      }).then(function (t) {
        return e.reporter.reportData("pci_sdk_getCardBrand_end", {
          cardBrand: t
        }), t;
      })["catch"](function (t) {
        return e.reporter.handleError(t, "pci_sdk_getCardBrand_error");
      });
    }
  }, {
    key: "getCurrentCardBinValue",
    value: function value() {
      var e = this;
      return new Promise(function (t) {
        e.cardEventInstance.setCardBinValueResolve(t), e.postMessageInstance.getCurrentCardBinValue("number");
      })["catch"](function (t) {
        return e.reporter.handleError(t, "pci_sdk_getCurrentCardBinValue_error");
      });
    }
  }, {
    key: "getBeforePayData",
    value: function value(e) {
      var t = this;
      return this.reporter.reportData("pci_sdk_getBeforePayData_start", {
        nextAction: e
      }), new Promise(function (n) {
        t.cardEventInstance.setBeforePayResolve(n), t.postMessageInstance.getBeforePayData(e, "number");
      }).then(function (e) {
        return t.reporter.reportData("pci_sdk_getBeforePayData_end", {
          beforePayData: e
        }), e;
      })["catch"](function (e) {
        return t.reporter.handleError(e, "pci_sdk_getBeforePayData_error");
      });
    }
  }, {
    key: "setCardBinOptions",
    value: function value(e) {
      var t = this;
      return this.reporter.reportData("pci_sdk_setCardBinOptions_start", e), new Promise(function (n) {
        t.cardEventInstance.setCardBinOptionsResolve(n), t.postMessageInstance.setCardBinOptions(e, "number");
      }).then(function (e) {
        return t.reporter.reportData("pci_sdk_setCardBinOptions_end", {
          result: e
        }), e;
      })["catch"](function (e) {
        return t.reporter.handleError(e, "pci_sdk_setCardBinOptions_error");
      });
    }
  }, {
    key: "getCardBinVerifyResult",
    value: function value() {
      var e = this,
          t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
      return this.reporter.reportData("pci_sdk_getCardBinVerifyResult_start", {
        readCache: t
      }), new Promise(function (n, r) {
        e.cardEventInstance.setCardBinVerifyResolve(n), e.cardEventInstance.setCardBinVerifyReject(r), e.postMessageInstance.getCardBinVerifyResult(t, "number");
      }).then(function (t) {
        return e.reporter.reportData("pci_sdk_getCardBinVerifyResult_end", {
          cardBinVerifyResult: t
        }), t;
      })["catch"](function (t) {
        return e.reporter.handleError(t, "pci_sdk_getCardBinVerifyResult_error");
      });
    }
  }, {
    key: "getCardToken",
    value: function value(e) {
      var t = this;
      return this.reporter.reportData("pci_sdk_getCardToken_start", e), new Promise(function (n, r) {
        t.cardEventInstance.setCardTokenResolve(n), t.cardEventInstance.setCardTokenReject(r), t.postMessageInstance.getCardToken(e, t.hasCardName, "number");
      }).then(function (e) {
        return t.reporter.reportData("pci_sdk_getCardToken_end"), e;
      })["catch"](function (e) {
        return t.reporter.handleError(e, "pci_sdk_getCardToken_error");
      });
    }
  }, {
    key: "getCurrentCardInfo",
    value: function value() {
      var e = this;
      return this.reporter.reportData("pci_sdk_getCurrentCardInfo_start"), new Promise(function (t, n) {
        e.cardEventInstance.setCardInfoResolve(t), e.cardEventInstance.setCardInfoReject(n), e.postMessageInstance.getCurrentCardInfo("number");
      }).then(function (t) {
        return e.reporter.reportData("pci_sdk_getCurrentCardInfo_end"), t;
      })["catch"](function (t) {
        return e.reporter.handleError(t, "pci_sdk_getCurrentCardInfo_error");
      });
    }
  }]), e;
}(),
    vn = function () {
  var e = c(l.mark(function e(t) {
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.abrupt("return", new Promise(function (e) {
              setTimeout(function () {
                e();
              }, t);
            }));

          case 1:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t) {
    return e.apply(this, arguments);
  };
}(),
    yn = function yn(e, t, n) {
  return c(l.mark(function r() {
    var o,
        i,
        a,
        s,
        c,
        u = arguments;
    return l.wrap(function (r) {
      for (;;) {
        switch (r.prev = r.next) {
          case 0:
            o = n.maxCount, i = n.interval, a = 0;

          case 2:
            if (!(a < o)) {
              r.next = 27;
              break;
            }

            return s = a !== o - 1, r.prev = 4, r.next = 7, e.apply(void 0, u);

          case 7:
            if (c = r.sent, !t(null, c) || !s) {
              r.next = 13;
              break;
            }

            return r.next = 11, vn(i);

          case 11:
            r.next = 14;
            break;

          case 13:
            return r.abrupt("return", c);

          case 14:
            r.next = 24;
            break;

          case 16:
            if (r.prev = 16, r.t0 = r["catch"](4), !t(r.t0, null) || !s) {
              r.next = 23;
              break;
            }

            return r.next = 21, vn(i);

          case 21:
            r.next = 24;
            break;

          case 23:
            throw r.t0;

          case 24:
            a++, r.next = 2;
            break;

          case 27:
          case "end":
            return r.stop();
        }
      }
    }, r, null, [[4, 16]]);
  }));
};

function mn(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function gn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? mn(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var _n = yn(function () {
  var e = c(l.mark(function e(t, n) {
    var r, o, i;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return r = t.url, o = t.payToken, i = {}, o && (i["x-paytoken"] = o), e.abrupt("return", we.post(r, n, {
              headers: i
            })["catch"](function (e) {
              var t = R.handleAPIErrorData(null == e ? void 0 : e.data, {
                code: v.AbnormalTrade,
                msg: y.AbnormalTrade
              });
              he.handleError(e, "order_pay_error", gn({
                url: r,
                response: {
                  error: e
                }
              }, t));
            }));

          case 4:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, n) {
    return e.apply(this, arguments);
  };
}(), function (e) {
  if (e) {
    var t,
        n = 400 === e.statusCode && (null === (t = e.data) || void 0 === t ? void 0 : t.code) === v.FrequentRequest;
    return 400 !== e.statusCode || n;
  }

  return !1;
}, {
  maxCount: 5,
  interval: 1e3
});

function bn(e, t) {
  var _n3 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

  if (!_n3) {
    if (Array.isArray(e) || (_n3 = function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return wn(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wn(e, t);
    }(e)) || t && e && "number" == typeof e.length) {
      _n3 && (e = _n3);

      var r = 0,
          o = function o() {};

      return {
        s: o,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e4) {
          throw _e4;
        },
        f: o
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var i,
      a = !0,
      s = !1;
  return {
    s: function s() {
      _n3 = _n3.call(e);
    },
    n: function n() {
      var e = _n3.next();

      return a = e.done, e;
    },
    e: function e(_e5) {
      s = !0, i = _e5;
    },
    f: function f() {
      try {
        a || null == _n3["return"] || _n3["return"]();
      } finally {
        if (s) throw i;
      }
    }
  };
}

function wn(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function Cn(e) {
  return Object.keys(e).map(function (t) {
    return e[t] ? "".concat(t, ": ").concat(e[t], ";") : "";
  }).join("");
}

function xn(e, t) {
  if (!e || !e.content || !t) return null;
  var n = e.content,
      r = e.props,
      o = void 0 === r ? {} : r,
      i = e.children,
      a = document.createElement(n);

  if (Object.keys(o).forEach(function (e) {
    void 0 !== o[e] && ("rawStyle" === e ? Cn(o[e]) && a.setAttribute("style", Cn(o[e])) : a.setAttribute(e, o[e]));
  }), Array.isArray(i)) {
    var s,
        c = bn(i);

    try {
      for (c.s(); !(s = c.n()).done;) {
        xn(s.value, a);
      }
    } catch (e) {
      c.e(e);
    } finally {
      c.f();
    }
  } else "string" == typeof i ? a.textContent = i : i ? xn(i, a) : a.textContent = "";

  "img" === n && a.addEventListener("error", function (e) {
    var t = e.target.parentNode;
    he.reportErrorData("load_img_error", {
      src: a.src,
      parentNode: {
        nodeName: null == t ? void 0 : t.nodeName,
        className: (null == t ? void 0 : t.className) || "",
        id: (null == t ? void 0 : t.id) || ""
      }
    });
  }), t.appendChild(a);
}

var kn = function () {
  function e(t, n) {
    var o = this;
    r(this, e), _a2(this, "type", void 0), _a2(this, "payOptions", void 0), _a2(this, "domId", void 0), _a2(this, "handlePostmessage", function (e) {
      var t = e.data,
          n = e.origin;

      if (/^https:\/\/cashiers(-[^\.]+)?\.myshopline\.com$/.test(n)) {
        he.reportData("challenge_next_action", {
          validateState: JSON.stringify(t)
        });
        var r = t.success,
            i = t.nextAction || {},
            a = i.url,
            s = i.type;

        if (window.removeEventListener("message", o.handlePostmessage, !1), r) {
          if (s === ze.Redirect && a) {
            if (o.type === ze.WorldPayChallenge) {
              var c = document.getElementById(o.domId);
              c && c.parentElement && c.parentElement.removeChild(c);
            }

            En(i, o.payOptions);
          }
        } else he.reportErrorData("challenge_next_action_error", t);
      }
    }), this.type = t, this.payOptions = n;
  }

  return i(e, [{
    key: "startChallenge",
    value: function value(e) {
      this.type === ze.WorldPayChallenge && this.iframePost(e, "worldPayChallengeIframe-".concat(Date.now()));
    }
  }, {
    key: "iframePost",
    value: function value(e, t) {
      var n = e.url,
          r = e.method,
          o = e.data,
          i = o.size,
          a = o.requestParams,
          s = void 0 === a ? {} : a;
      this.domId = t, xn({
        content: "div",
        props: {
          id: t
        },
        children: [{
          content: "div",
          props: {
            style: "\n            position: fixed;\n            width: 100%;\n            height: 100%;\n            z-index: 1000;\n            top: 0;\n            left: 0;\n            background-color: rgba(0, 0, 0, 0.45);\n            "
          }
        }, {
          content: "div",
          props: {
            style: "\n              position: fixed;\n              width: 100%;\n              height: 100%;\n              z-index: 1000;\n              top: 0;\n              left: 0;\n            "
          },
          children: {
            content: "iframe",
            props: {
              src: n,
              name: t,
              style: "\n                position: relative;\n                width: ".concat(i.width, ";\n                height: ").concat(i.height, ";\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                background: #fff;\n              ")
            }
          }
        }]
      }, document.body), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1), In(n, s, r, t);
    }
  }]), e;
}(),
    On = function () {
  function e(t, n) {
    var o = this;
    r(this, e), _a2(this, "type", void 0), _a2(this, "payOptions", void 0), _a2(this, "domId", void 0), _a2(this, "handlePostmessage", function (e) {
      var t = e.data;

      if (function (e) {
        return /^https:\/\/cashiers(-[^\.]+)?\.myshopline\.com$/.test(e);
      }(e.origin)) {
        var n = t.success,
            r = t.nextAction || {},
            i = t.nextAction || {},
            a = i.url,
            s = i.type;

        if (he.reportData("useepay_3ds_next_action_".concat(s), {
          validateState: JSON.stringify(t)
        }), n) {
          if (s === ze.Redirect && a) {
            if (window.removeEventListener("message", o.handlePostmessage, !1), o.domId) {
              var c = document.getElementById(o.domId);
              c && c.parentElement && c.parentElement.removeChild(c);
            }

            En(r, o.payOptions);
          }

          s === ze.UseepayChallenge && o.challenge(t.nextAction);
        } else he.reportErrorData("useepay_3ds_next_action_".concat(s, "_error"), t);
      }
    }), this.type = t, this.payOptions = n;
  }

  return i(e, [{
    key: "gather",
    value: function value(e) {
      var t = e.url,
          n = e.method,
          r = e.data,
          o = "UseepayGatherIframe-".concat(Date.now()),
          i = document.createElement("iframe");
      i.src = t, i.name = o, i.style.width = "0", i.style.height = "0", i.style.display = "none", document.body.appendChild(i), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1), In(t, r, n, o);
    }
  }, {
    key: "challenge",
    value: function value(e) {
      e.type === ze.UseepayChallenge && this.iframePost(e, "UseepayChallengeIframe-".concat(Date.now()));
    }
  }, {
    key: "iframePost",
    value: function value(e, t) {
      var n = e.url;
      this.domId = t, xn({
        content: "div",
        props: {
          id: t
        },
        children: [{
          content: "div",
          props: {
            style: "\n            position: fixed;\n            width: 100%;\n            height: 100%;\n            z-index: 1000;\n            top: 0;\n            left: 0;\n            "
          }
        }, {
          content: "div",
          props: {
            style: "\n              position: fixed;\n              width: 100%;\n              height: 100%;\n              z-index: 1000;\n              top: 0;\n              left: 0;\n            "
          },
          children: {
            content: "iframe",
            props: {
              src: n,
              name: t,
              style: "\n                position: relative;\n                width: 100%;\n                height: 100%;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                background: #fff;\n              "
            }
          }
        }]
      }, document.body), window.removeEventListener("message", this.handlePostmessage, !1), window.addEventListener("message", this.handlePostmessage, !1);
    }
  }]), e;
}();

function Pn(e, t) {
  if (function (e) {
    return void 0 === e;
  }(n = t) || function (e) {
    return null === e;
  }(n)) return I(e);
  var n;
  if (!P(t) || !P(e)) return I(t);
  var r = {};
  return Object.keys(e).forEach(function (n) {
    r[n] = Pn(e[n], t[n]);
  }), Object.keys(t).forEach(function (e) {
    r[e] || (r[e] = I(t[e]));
  }), r;
}

function In(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "post",
      r = arguments.length > 3 ? arguments[3] : void 0;
  he.reportData("redirectPost_start");
  var o = document.createElement("form");

  for (var i in o.style.display = "none", o.method = n, o.action = e, r && (o.target = r), t) {
    var a = document.createElement("input");
    a.name = i, a.value = t[i], o.appendChild(a);
  }

  document.body.appendChild(o), he.reportData("redirectPost_end"), o.submit();
}

function En(e, t) {
  return Rn.apply(this, arguments);
}

function Rn() {
  return (Rn = c(l.mark(function e(t, n) {
    var r, o, i, a, s, u, p, d;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return r = t.method, o = void 0 === r ? "GET" : r, i = t.url, a = t.data, s = t.target, u = null == n ? void 0 : n.beforeRedirect, p = new Promise(function () {
              var e = c(l.mark(function e(n) {
                return l.wrap(function (e) {
                  for (;;) {
                    switch (e.prev = e.next) {
                      case 0:
                        if (!u) {
                          e.next = 9;
                          break;
                        }

                        return e.prev = 1, e.next = 4, u(s);

                      case 4:
                        e.next = 9;
                        break;

                      case 6:
                        e.prev = 6, e.t0 = e["catch"](1), he.reportErrorData("before_redirect_error", {
                          nextAction: t,
                          error: e.t0
                        });

                      case 9:
                        n(null);

                      case 10:
                      case "end":
                        return e.stop();
                    }
                  }
                }, e, null, [[1, 6]]);
              }));
              return function (t) {
                return e.apply(this, arguments);
              };
            }()), d = new Promise(function (e) {
              setTimeout(e, 3e3);
            }), e.abrupt("return", Promise.race([p, d]).then(function () {
              "POST" === o ? In(i, a) : "GET" === o && (he.reportData("handleRedirect_GET"), window.location.href = i);
            }));

          case 5:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

function Dn(e) {
  return Sn.apply(this, arguments);
}

function Sn() {
  return (Sn = c(l.mark(function e(t) {
    var n,
        r,
        o,
        i,
        a,
        s,
        c,
        u,
        p,
        d = arguments;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (n = d.length > 1 && void 0 !== d[1] ? d[1] : {}, r = n.payOptions, o = n.paymentMethodOptions, i = n.paymentMethod, a = n.subPaymentMethod, s = null == r ? void 0 : r.hooks, t.type !== ze.Confirm) {
              e.next = 25;
              break;
            }

            if (e.t0 = null == s ? void 0 : s.beforeConfirm, !e.t0) {
              e.next = 8;
              break;
            }

            return e.next = 8, s.beforeConfirm()["catch"](he.handleError);

          case 8:
            if (c = {
              paymentInstrument: {
                paymentMethod: i,
                subPaymentMethod: a
              }
            }, o && (c.paymentMethodOptions = o), null == s || !s.extendConfirmParams) {
              e.next = 15;
              break;
            }

            return e.next = 13, s.extendConfirmParams()["catch"](he.handleError);

          case 13:
            (u = e.sent) && P(u) && (c = Pn(u, c));

          case 15:
            return e.next = 17, _n(t, c)["catch"](he.handleError);

          case 17:
            if (p = e.sent, e.t1 = null == s ? void 0 : s.afterConfirm, !e.t1) {
              e.next = 22;
              break;
            }

            return e.next = 22, s.afterConfirm()["catch"](he.handleError);

          case 22:
            return e.abrupt("return", jn(p, r));

          case 25:
            if (t.type !== ze.Redirect) {
              e.next = 30;
              break;
            }

            return e.next = 28, En(t, r)["catch"](he.handleError);

          case 28:
            e.next = 53;
            break;

          case 30:
            if (t.type !== ze.ExchangeTicket) {
              e.next = 35;
              break;
            }

            return e.next = 33, En(t, r)["catch"](he.handleError);

          case 33:
            e.next = 53;
            break;

          case 35:
            if (t.type !== ze.WorldPayChallenge) {
              e.next = 41;
              break;
            }

            return new kn(t.type, r).startChallenge(t), e.abrupt("return");

          case 41:
            if (t.type !== ze.UseepayChallenge) {
              e.next = 46;
              break;
            }

            new On(t.type, r).challenge(t), e.next = 53;
            break;

          case 46:
            if (t.type !== ze.UseepayGather) {
              e.next = 51;
              break;
            }

            new On(t.type, r).gather(t), e.next = 53;
            break;

          case 51:
            if (null == s || !s.handlePayAction) {
              e.next = 53;
              break;
            }

            return e.abrupt("return", s.handlePayAction(t));

          case 53:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

function jn(e, t) {
  return Ln.apply(this, arguments);
}

function Ln() {
  return (Ln = c(l.mark(function e(t, n) {
    var r;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (200 !== t.statusCode) {
              e.next = 5;
              break;
            }

            return r = t.data.nextAction, e.abrupt("return", Dn(r, {
              payOptions: n
            }));

          case 5:
            he.handleError(t, "pay_nextAction_error");

          case 6:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

var Bn,
    Tn,
    Nn = function Nn() {
  var e = window.navigator,
      t = e.userAgent,
      n = e.language,
      r = window.screen,
      o = r.colorDepth,
      i = r.width,
      a = r.height,
      s = window.navigator.javaEnabled().toString();
  return {
    transactionWebSite: window.location.href,
    javaEnabled: s,
    colorDepth: o.toString(),
    screenHeight: i.toString(),
    screenWidth: a.toString(),
    timeZoneOffset: new Date().getTimezoneOffset().toString(),
    accept: "application/json",
    userAgent: t,
    language: n,
    javaScriptEnabled: "true"
  };
},
    An = function An(e, t, n) {
  var r = {};
  return r.client = Nn(), e === He.WorldPay && (null == t ? void 0 : t.type) === ze.WorldPayGather && (r.additionalData = {
    ddcReferenceId: (null == t ? void 0 : t.SessionId) || ""
  }), null != n && n.isInstallment && null != n && n.installmentCount && (r.paymentMethodOptions = {
    installments: {
      count: null == n ? void 0 : n.installmentCount
    }
  }), r;
};

function Mn(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Fn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Mn(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

!function (e) {
  e.Google = "googleFont", e.System = "system";
}(Bn || (Bn = {}));
Ve.Number, Ve.FirstName, Ve.ExpDate, Ve.Cvc;
var Hn = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.45298 7.94043C8.86649 8.2889 8.60666 8.62269 8.59923 9.33797C8.59563 9.68549 8.31985 9.94303 7.89582 9.94303C7.49737 9.94303 7.1924 9.68549 7.1924 9.33797C7.19612 8.05414 7.54504 7.66166 8.16865 7.27285C8.62522 6.98674 8.97785 6.66762 8.97785 6.1871C8.97785 5.67724 8.57325 5.34712 8.07214 5.34712C7.58587 5.34712 7.15624 5.63856 7.11445 6.26413C7.0902 6.62714 6.78059 6.98126 6.35721 6.98126C5.93369 6.98126 5.59998 6.61104 5.59998 6.26413C5.59998 4.80823 6.73212 4.09998 8.07956 4.09998C9.55321 4.09998 10.6 4.84826 10.6 6.13208C10.6 6.99407 10.1471 7.53328 9.45298 7.94043ZM7.92373 12.4033C8.39886 12.4033 8.81089 12.0109 8.8146 11.523C8.81089 11.0425 8.39886 10.65 7.92373 10.65C7.43375 10.65 7.02915 11.0425 7.03286 11.523C7.02915 12.0109 7.43375 12.4033 7.92373 12.4033Z" fill="currentColor"/></svg>',
    Wn = {
  inputBackground: "#fff",
  inputHeight: "46px",
  inputLabelColor: "rgba(44, 44, 44, 0.75)",
  inputFontColor: "#2C2C2C",
  inputIconColor: "rgba(44, 44, 44, 0.75)",
  inputBorderColor: "rgba(142, 142, 142, 0.3)",
  inputBorderRadius: "4px",
  inputFocusBorderColor: "#276EAF",
  inputErrorBorderColor: "#F04949",
  inputErrorFontColor: "#F04949",
  inputTipGutter: "6px",
  inputTipColor: "rgba(44, 44, 44, 0.5)"
},
    Vn = {
  selectHeight: Wn.inputHeight,
  selectMarginBottom: "12px",
  selectSkeletonBackground: Wn.inputFontColor,
  selectFontColor: "rgb(54, 61, 77)",
  selectPlaceholderFontColor: "#999999",
  selectBackground: "rgb(255, 255, 255)",
  selectBorderColor: Wn.inputBorderColor,
  selectBorderRadius: Wn.inputBorderRadius,
  selectIconColor: "#1E1E1E",
  selectErrorBorderColor: "#F04949",
  selectErrorFontColor: "#F04949",
  optionsFontColor: "rgb(54, 61, 77)",
  optionsBackground: "rgb(255, 255, 255)",
  optionsDisabledBackground: "rgb(247, 248, 251)",
  optionsDisabledFontColor: "rgb(184, 190, 204)"
},
    Un = (_a2(Tn = {}, Fe.CreditCard, Fn(Fn({}, Wn), {}, {
  formItemGutter: "12px",
  cardNumberIconSvg: '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99998 2.70002C6.70211 2.70002 5.64998 3.75216 5.64998 5.05002V5.79999H10.35V5.05002C10.35 3.75216 9.29784 2.70002 7.99998 2.70002ZM4.34998 5.05002V5.79999H4C2.89543 5.79999 2 6.69542 2 7.79999V12.8C2 13.9046 2.89543 14.8 4 14.8H12C13.1046 14.8 14 13.9046 14 12.8V7.79999C14 6.69542 13.1046 5.79999 12 5.79999H11.65V5.05002C11.65 3.03418 10.0158 1.40002 7.99998 1.40002C5.98414 1.40002 4.34998 3.03418 4.34998 5.05002ZM4 7.09999H12C12.3866 7.09999 12.7 7.41339 12.7 7.79999V12.8C12.7 13.1866 12.3866 13.5 12 13.5H4C3.6134 13.5 3.3 13.1866 3.3 12.8V7.79999C3.3 7.41339 3.6134 7.09999 4 7.09999ZM8.59998 10.5395C8.9587 10.332 9.20005 9.94419 9.20005 9.49999C9.20005 8.83725 8.66279 8.29999 8.00005 8.29999C7.33731 8.29999 6.80005 8.83725 6.80005 9.49999C6.80005 9.94413 7.04134 10.3319 7.39998 10.5394V11.9C7.39998 12.2314 7.6686 12.5 7.99998 12.5C8.33135 12.5 8.59998 12.2314 8.59998 11.9V10.5395Z" fill="currentColor"/></svg>',
  holderNameIconSvg: Hn,
  securityCodeIconSvg: Hn,
  footerFontColor: "rgba(44, 44, 44, 0.5)",
  footerIconColor: "#35C08E",
  footerLinkColor: "#466c63",
  footerIconSvg: '\n<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M10.8773 5.33337H10.1557C9.99882 5.33337 9.84958 5.40529 9.75727 5.52856L7.33873 8.72793L6.24331 7.27795C6.151 7.15613 6.0033 7.08275 5.84484 7.08275H5.12328C5.02327 7.08275 4.96481 7.19136 5.02327 7.26914L6.94026 9.80515C6.98554 9.86545 7.04524 9.91458 7.11441 9.94847C7.18357 9.98236 7.26021 10 7.33796 10C7.41572 10 7.49235 9.98236 7.56152 9.94847C7.63068 9.91458 7.69038 9.86545 7.73567 9.80515L10.9758 5.51976C11.0358 5.44198 10.9773 5.33337 10.8773 5.33337V5.33337Z" fill="currentColor"/>\n<path d="M13.25 3.46888V9.59634C13.25 10.0143 13.0411 10.4046 12.6934 10.6364L8.13867 13.6729C8.0547 13.7289 7.9453 13.7289 7.86132 13.6729L3.30662 10.6364C2.95888 10.4046 2.75 10.0143 2.75 9.59634V3.46888C2.75 3.3517 2.83138 3.25025 2.94577 3.22483L7.94577 2.11372C7.98149 2.10578 8.01851 2.10578 8.05423 2.11372L13.0542 3.22483C13.1686 3.25025 13.25 3.3517 13.25 3.46888Z" stroke="currentColor" stroke-width="1.5"/>\n</svg>\n'
})), _a2(Tn, Fe.FPX, Fn(Fn({}, Vn), {}, {
  selectBorderColor: "#CCCCCC",
  selectSkeletonBackground: "rgba(44,44,44,0.05)",
  maintainTimeFontColor: "#F86140",
  nextStepTipFontColor: "rgba(44, 44, 44, 0.75)",
  footerFontColor: "rgba(30, 30, 30, 0.4)",
  footerLinkColor: "#356DFF",
  footerIconColor: "#35C08E"
})), _a2(Tn, "installment", Fn(Fn({}, Vn), {}, {
  quesIconColor: "rgba(44, 44, 44, 0.75)",
  infoIconColor: "rgba(44, 44, 44, 0.75)",
  headerFontColor: "rgba(44, 44, 44, 0.75)"
})), _a2(Tn, "block", {
  imgColor: "rgba(44, 44, 44, 0.5)",
  fontColor: "#1E1E1E"
}), _a2(Tn, "simple", {
  fontColor: "rgba(44, 44, 44, 0.5)"
}), _a2(Tn, "default", {
  fontFamily: ["Helvetica Neue", " Arial", " sans-serif"],
  fontLib: Bn.System
}), Tn);

function zn(e) {
  if (!e || !P(e)) return {};
  var t = e[Fe.CreditCard] || {};
  return function (e) {
    if (!e || !P(e)) return !1;
    var t = e.fontLib,
        n = e.fontFamily;
    return !(!Array.isArray(n) || 0 === n.length || t !== Bn.Google && t !== Bn.System);
  }(e["default"]) && (t.inputFontLib = e["default"].fontLib, t.inputFontFamily = e["default"].fontFamily), t;
}

function qn(e) {
  if (!e || !P(e) || 0 === Object.keys(e).length) return Un;
  var t = JSON.parse(JSON.stringify(Un));
  return Object.keys(e).forEach(function (n) {
    Object.keys(e[n]).forEach(function (r) {
      var o = e[n][r];
      (function (e) {
        return !("string" == typeof e && !e.trim()) && e && ("string" == typeof e || Array.isArray(e));
      })(o) && (t[n] || (t[n] = {}), t[n][r] = o);
    });
  }), t;
}

function Gn(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Zn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Gn(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Xn,
    Kn,
    $n = {
  "zh-CN": "zh-hans-cn",
  "zh-TW": "zh-hant-tw",
  no: "nb"
},
    Yn = {},
    Jn = function () {
  function e(t, n) {
    r(this, e), _a2(this, "newLanguage", void 0), _a2(this, "displayLanguage", void 0), _a2(this, "data", void 0), _a2(this, "defaultData", void 0), _a2(this, "language", "en"), _a2(this, "env", void 0), _a2(this, "languageJson", void 0), _a2(this, "defaultJson", void 0), this.language = t, this.env = n.env, this.init();
  }

  var t, n, o, s, u, p, d;
  return i(e, [{
    key: "init",
    value: function value() {
      var e = this,
          t = this.language || "en";
      this.newLanguage = "string" == typeof t ? {
        extend: t
      } : t, this.newLanguage.extend = this.newLanguage.extend || "en", this.displayLanguage = this.newLanguage.extend;
      var n = $n[this.displayLanguage] ? $n[this.displayLanguage] : this.displayLanguage;
      this.languageJson = this.requestJsonData(n)["catch"](c(l.mark(function t() {
        var n;
        return l.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return e.displayLanguage = "en", n = e.requestJsonData("en"), e.defaultJson = n, t.abrupt("return", n);

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })));
    }
  }, {
    key: "setData",
    value: (d = c(l.mark(function e() {
      var t, n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.languageJson;

            case 2:
              t = e.sent, n = t.data, this.data = n;

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return d.apply(this, arguments);
    })
  }, {
    key: "setDefaultData",
    value: (p = c(l.mark(function e() {
      var t, n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.defaultJson || (this.defaultJson = this.requestJsonData("en")), e.next = 3, this.defaultJson;

            case 3:
              t = e.sent, n = t.data, this.defaultData = n;

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return p.apply(this, arguments);
    })
  }, {
    key: "requestJsonData",
    value: (u = c(l.mark(function e(t) {
      var n, r, o, i;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n = "".concat(this.env, "_").concat(t), !(r = Yn[n])) {
                e.next = 6;
                break;
              }

              return e.next = 5, r;

            case 5:
              return e.abrupt("return", e.sent);

            case 6:
              return a = this.env, s = t, o = "https://cdn.myshopline.com/t/i18n/payment-acceptance-payment-sdk/".concat(a || Se.Prod, "/").concat(s || "en", ".raw.tree.json"), Yn[n] = we.get(o)["catch"](function (e) {
                delete Yn[n], he.handleError(e, "I18n_request_".concat(t, "_error"), {
                  language: t,
                  response: {
                    error: e
                  }
                });
              }), e.next = 10, Yn[n];

            case 10:
              return i = e.sent, e.abrupt("return", i);

            case 12:
            case "end":
              return e.stop();
          }
        }

        var a, s;
      }, e, this);
    })), function (e) {
      return u.apply(this, arguments);
    })
  }, {
    key: "getVal",
    value: function value(e, t) {
      return t ? t.split(".").reduce(function (e, t) {
        var n;
        return null !== (n = null == e ? void 0 : e[t]) && void 0 !== n ? n : "";
      }, e) : "";
    }
  }, {
    key: "getOne",
    value: (s = c(l.mark(function e(t) {
      var n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.data) {
                e.next = 3;
                break;
              }

              return e.next = 3, this.setData();

            case 3:
              if ("" !== (n = "" === (n = this.getVal(this.newLanguage, t)) ? this.getVal(this.data, t) : n)) {
                e.next = 12;
                break;
              }

              if (this.defaultData) {
                e.next = 9;
                break;
              }

              return e.next = 9, this.setDefaultData();

            case 9:
              return e.abrupt("return", this.getVal(this.defaultData, t));

            case 12:
              return e.abrupt("return", n);

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return s.apply(this, arguments);
    })
  }, {
    key: "getData",
    value: (o = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.data) {
                e.next = 3;
                break;
              }

              return e.next = 3, this.setData();

            case 3:
              return e.abrupt("return", Zn(Zn({}, this.data), this.newLanguage));

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "get",
    value: (n = c(l.mark(function e(t) {
      var n = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!Array.isArray(t)) {
                e.next = 6;
                break;
              }

              return e.next = 3, Promise.all(t.map(function (e) {
                return n.getOne(e);
              }));

            case 3:
              return e.abrupt("return", e.sent);

            case 6:
              return e.next = 8, this.getOne(t);

            case 8:
              return e.abrupt("return", e.sent);

            case 9:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "getDisplayLanguage",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.data) {
                e.next = 3;
                break;
              }

              return e.next = 3, this.setData();

            case 3:
              return e.abrupt("return", this.displayLanguage);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

!function (e) {
  e.InvalidCardNumber = "4455", e.InvalidCard = "3001", e.InvalidExpDate = "4459", e.InvalidCVC = "4453";
}(Kn || (Kn = {}));
var Qn = (_a2(Xn = {}, Kn.InvalidCardNumber, {
  field: "number",
  i18nKey: "pleaseEnterValidCardNumber"
}), _a2(Xn, Kn.InvalidCard, {
  field: "number",
  i18nKey: "pleaseChangeAnotherCard"
}), _a2(Xn, Kn.InvalidExpDate, {
  field: "expDate",
  i18nKey: "pleaseEnterExpired"
}), _a2(Xn, Kn.InvalidCVC, {
  field: "cvc",
  i18nKey: "pleaseEnterCVV"
}), Xn);

function er(e, t) {
  return tr.apply(this, arguments);
}

function tr() {
  return (tr = c(l.mark(function e(t, n) {
    var r, o, i, a;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (t && Qn[t]) {
              e.next = 2;
              break;
            }

            return e.abrupt("return");

          case 2:
            return o = (r = Qn[t]).field, i = r.i18nKey, e.next = 5, n.get(i);

          case 5:
            return a = e.sent, e.abrupt("return", {
              field: o,
              message: a
            });

          case 7:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

var nr,
    rr,
    or,
    ir,
    ar,
    sr,
    cr = {},
    ur = [],
    lr = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;

function pr(e, t) {
  for (var n in t) {
    e[n] = t[n];
  }

  return e;
}

function dr(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}

function fr(e, t, n) {
  var r,
      o,
      i,
      a = {};

  for (i in t) {
    "key" == i ? r = t[i] : "ref" == i ? o = t[i] : a[i] = t[i];
  }

  if (arguments.length > 2 && (a.children = arguments.length > 3 ? nr.call(arguments, 2) : n), "function" == typeof e && null != e.defaultProps) for (i in e.defaultProps) {
    void 0 === a[i] && (a[i] = e.defaultProps[i]);
  }
  return hr(e, a, r, o, null);
}

function hr(e, t, n, r, o) {
  var i = {
    type: e,
    props: t,
    key: n,
    ref: r,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: null == o ? ++or : o
  };
  return null == o && null != rr.vnode && rr.vnode(i), i;
}

function vr(e) {
  return e.children;
}

function yr(e, t) {
  this.props = e, this.context = t;
}

function mr(e, t) {
  if (null == t) return e.__ ? mr(e.__, e.__.__k.indexOf(e) + 1) : null;

  for (var n; t < e.__k.length; t++) {
    if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
  }

  return "function" == typeof e.type ? mr(e) : null;
}

function gr(e) {
  var t, n;

  if (null != (e = e.__) && null != e.__c) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) {
      if (null != (n = e.__k[t]) && null != n.__e) {
        e.__e = e.__c.base = n.__e;
        break;
      }
    }

    return gr(e);
  }
}

function _r(e) {
  (!e.__d && (e.__d = !0) && ir.push(e) && !br.__r++ || sr !== rr.debounceRendering) && ((sr = rr.debounceRendering) || ar)(br);
}

function br() {
  for (var e; br.__r = ir.length;) {
    e = ir.sort(function (e, t) {
      return e.__v.__b - t.__v.__b;
    }), ir = [], e.some(function (e) {
      var t, n, r, o, i, a;
      e.__d && (i = (o = (t = e).__v).__e, (a = t.__P) && (n = [], (r = pr({}, o)).__v = o.__v + 1, Er(a, o, r, t.__n, void 0 !== a.ownerSVGElement, null != o.__h ? [i] : null, n, null == i ? mr(o) : i, o.__h), Rr(n, o), o.__e != i && gr(o)));
    });
  }
}

function wr(e, t, n, r, o, i, a, s, c, u) {
  var l,
      p,
      d,
      f,
      h,
      v,
      y,
      m = r && r.__k || ur,
      g = m.length;

  for (n.__k = [], l = 0; l < t.length; l++) {
    if (null != (f = n.__k[l] = null == (f = t[l]) || "boolean" == typeof f ? null : "string" == typeof f || "number" == typeof f || "bigint" == typeof f ? hr(null, f, null, null, f) : Array.isArray(f) ? hr(vr, {
      children: f
    }, null, null, null) : f.__b > 0 ? hr(f.type, f.props, f.key, null, f.__v) : f)) {
      if (f.__ = n, f.__b = n.__b + 1, null === (d = m[l]) || d && f.key == d.key && f.type === d.type) m[l] = void 0;else for (p = 0; p < g; p++) {
        if ((d = m[p]) && f.key == d.key && f.type === d.type) {
          m[p] = void 0;
          break;
        }

        d = null;
      }
      Er(e, f, d = d || cr, o, i, a, s, c, u), h = f.__e, (p = f.ref) && d.ref != p && (y || (y = []), d.ref && y.push(d.ref, null, f), y.push(p, f.__c || h, f)), null != h ? (null == v && (v = h), "function" == typeof f.type && f.__k === d.__k ? f.__d = c = Cr(f, c, e) : c = xr(e, f, d, m, h, c), "function" == typeof n.type && (n.__d = c)) : c && d.__e == c && c.parentNode != e && (c = mr(d));
    }
  }

  for (n.__e = v, l = g; l--;) {
    null != m[l] && ("function" == typeof n.type && null != m[l].__e && m[l].__e == n.__d && (n.__d = mr(r, l + 1)), jr(m[l], m[l]));
  }

  if (y) for (l = 0; l < y.length; l++) {
    Sr(y[l], y[++l], y[++l]);
  }
}

function Cr(e, t, n) {
  for (var r, o = e.__k, i = 0; o && i < o.length; i++) {
    (r = o[i]) && (r.__ = e, t = "function" == typeof r.type ? Cr(r, t, n) : xr(n, r, r, o, r.__e, t));
  }

  return t;
}

function xr(e, t, n, r, o, i) {
  var a, s, c;
  if (void 0 !== t.__d) a = t.__d, t.__d = void 0;else if (null == n || o != i || null == o.parentNode) e: if (null == i || i.parentNode !== e) e.appendChild(o), a = null;else {
    for (s = i, c = 0; (s = s.nextSibling) && c < r.length; c += 2) {
      if (s == o) break e;
    }

    e.insertBefore(o, i), a = i;
  }
  return void 0 !== a ? a : o.nextSibling;
}

function kr(e, t, n) {
  "-" === t[0] ? e.setProperty(t, n) : e[t] = null == n ? "" : "number" != typeof n || lr.test(t) ? n : n + "px";
}

function Or(e, t, n, r, o) {
  var i;

  e: if ("style" === t) {
    if ("string" == typeof n) e.style.cssText = n;else {
      if ("string" == typeof r && (e.style.cssText = r = ""), r) for (t in r) {
        n && t in n || kr(e.style, t, "");
      }
      if (n) for (t in n) {
        r && n[t] === r[t] || kr(e.style, t, n[t]);
      }
    }
  } else if ("o" === t[0] && "n" === t[1]) i = t !== (t = t.replace(/Capture$/, "")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + i] = n, n ? r || e.addEventListener(t, i ? Ir : Pr, i) : e.removeEventListener(t, i ? Ir : Pr, i);else if ("dangerouslySetInnerHTML" !== t) {
    if (o) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");else if ("href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e) try {
      e[t] = null == n ? "" : n;
      break e;
    } catch (e) {}
    "function" == typeof n || (null != n && (!1 !== n || "a" === t[0] && "r" === t[1]) ? e.setAttribute(t, n) : e.removeAttribute(t));
  }
}

function Pr(e) {
  this.l[e.type + !1](rr.event ? rr.event(e) : e);
}

function Ir(e) {
  this.l[e.type + !0](rr.event ? rr.event(e) : e);
}

function Er(e, t, n, r, o, i, a, s, c) {
  var u,
      l,
      p,
      d,
      f,
      h,
      v,
      y,
      m,
      g,
      _,
      b = t.type;

  if (void 0 !== t.constructor) return null;
  null != n.__h && (c = n.__h, s = t.__e = n.__e, t.__h = null, i = [s]), (u = rr.__b) && u(t);

  try {
    e: if ("function" == typeof b) {
      if (y = t.props, m = (u = b.contextType) && r[u.__c], g = u ? m ? m.props.value : u.__ : r, n.__c ? v = (l = t.__c = n.__c).__ = l.__E : ("prototype" in b && b.prototype.render ? t.__c = l = new b(y, g) : (t.__c = l = new yr(y, g), l.constructor = b, l.render = Lr), m && m.sub(l), l.props = y, l.state || (l.state = {}), l.context = g, l.__n = r, p = l.__d = !0, l.__h = []), null == l.__s && (l.__s = l.state), null != b.getDerivedStateFromProps && (l.__s == l.state && (l.__s = pr({}, l.__s)), pr(l.__s, b.getDerivedStateFromProps(y, l.__s))), d = l.props, f = l.state, p) null == b.getDerivedStateFromProps && null != l.componentWillMount && l.componentWillMount(), null != l.componentDidMount && l.__h.push(l.componentDidMount);else {
        if (null == b.getDerivedStateFromProps && y !== d && null != l.componentWillReceiveProps && l.componentWillReceiveProps(y, g), !l.__e && null != l.shouldComponentUpdate && !1 === l.shouldComponentUpdate(y, l.__s, g) || t.__v === n.__v) {
          l.props = y, l.state = l.__s, t.__v !== n.__v && (l.__d = !1), l.__v = t, t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function (e) {
            e && (e.__ = t);
          }), l.__h.length && a.push(l);
          break e;
        }

        null != l.componentWillUpdate && l.componentWillUpdate(y, l.__s, g), null != l.componentDidUpdate && l.__h.push(function () {
          l.componentDidUpdate(d, f, h);
        });
      }
      l.context = g, l.props = y, l.state = l.__s, (u = rr.__r) && u(t), l.__d = !1, l.__v = t, l.__P = e, u = l.render(l.props, l.state, l.context), l.state = l.__s, null != l.getChildContext && (r = pr(pr({}, r), l.getChildContext())), p || null == l.getSnapshotBeforeUpdate || (h = l.getSnapshotBeforeUpdate(d, f)), _ = null != u && u.type === vr && null == u.key ? u.props.children : u, wr(e, Array.isArray(_) ? _ : [_], t, n, r, o, i, a, s, c), l.base = t.__e, t.__h = null, l.__h.length && a.push(l), v && (l.__E = l.__ = null), l.__e = !1;
    } else null == i && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = Dr(n.__e, t, n, r, o, i, a, c);

    (u = rr.diffed) && u(t);
  } catch (e) {
    t.__v = null, (c || null != i) && (t.__e = s, t.__h = !!c, i[i.indexOf(s)] = null), rr.__e(e, t, n);
  }
}

function Rr(e, t) {
  rr.__c && rr.__c(t, e), e.some(function (t) {
    try {
      e = t.__h, t.__h = [], e.some(function (e) {
        e.call(t);
      });
    } catch (e) {
      rr.__e(e, t.__v);
    }
  });
}

function Dr(e, t, n, r, o, i, a, s) {
  var c,
      u,
      l,
      p = n.props,
      d = t.props,
      f = t.type,
      h = 0;
  if ("svg" === f && (o = !0), null != i) for (; h < i.length; h++) {
    if ((c = i[h]) && "setAttribute" in c == !!f && (f ? c.localName === f : 3 === c.nodeType)) {
      e = c, i[h] = null;
      break;
    }
  }

  if (null == e) {
    if (null === f) return document.createTextNode(d);
    e = o ? document.createElementNS("http://www.w3.org/2000/svg", f) : document.createElement(f, d.is && d), i = null, s = !1;
  }

  if (null === f) p === d || s && e.data === d || (e.data = d);else {
    if (i = i && nr.call(e.childNodes), u = (p = n.props || cr).dangerouslySetInnerHTML, l = d.dangerouslySetInnerHTML, !s) {
      if (null != i) for (p = {}, h = 0; h < e.attributes.length; h++) {
        p[e.attributes[h].name] = e.attributes[h].value;
      }
      (l || u) && (l && (u && l.__html == u.__html || l.__html === e.innerHTML) || (e.innerHTML = l && l.__html || ""));
    }

    if (function (e, t, n, r, o) {
      var i;

      for (i in n) {
        "children" === i || "key" === i || i in t || Or(e, i, null, n[i], r);
      }

      for (i in t) {
        o && "function" != typeof t[i] || "children" === i || "key" === i || "value" === i || "checked" === i || n[i] === t[i] || Or(e, i, t[i], n[i], r);
      }
    }(e, d, p, o, s), l) t.__k = [];else if (h = t.props.children, wr(e, Array.isArray(h) ? h : [h], t, n, r, o && "foreignObject" !== f, i, a, i ? i[0] : n.__k && mr(n, 0), s), null != i) for (h = i.length; h--;) {
      null != i[h] && dr(i[h]);
    }
    s || ("value" in d && void 0 !== (h = d.value) && (h !== e.value || "progress" === f && !h || "option" === f && h !== p.value) && Or(e, "value", h, p.value, !1), "checked" in d && void 0 !== (h = d.checked) && h !== e.checked && Or(e, "checked", h, p.checked, !1));
  }
  return e;
}

function Sr(e, t, n) {
  try {
    "function" == typeof e ? e(t) : e.current = t;
  } catch (e) {
    rr.__e(e, n);
  }
}

function jr(e, t, n) {
  var r, o;

  if (rr.unmount && rr.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || Sr(r, null, t)), null != (r = e.__c)) {
    if (r.componentWillUnmount) try {
      r.componentWillUnmount();
    } catch (e) {
      rr.__e(e, t);
    }
    r.base = r.__P = null;
  }

  if (r = e.__k) for (o = 0; o < r.length; o++) {
    r[o] && jr(r[o], t, "function" != typeof e.type);
  }
  n || null == e.__e || dr(e.__e), e.__e = e.__d = void 0;
}

function Lr(e, t, n) {
  return this.constructor(e, n);
}

function Br(e, t, n) {
  var r, o, i;
  rr.__ && rr.__(e, t), o = (r = "function" == typeof n) ? null : n && n.__k || t.__k, i = [], Er(t, e = (!r && n || t).__k = fr(vr, null, [e]), o || cr, cr, void 0 !== t.ownerSVGElement, !r && n ? [n] : o ? null : t.firstChild ? nr.call(t.childNodes) : null, i, !r && n ? n : o ? o.__e : t.firstChild, r), Rr(i, e);
}

function Tr(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function Nr(e, t) {
  if (e) {
    if ("string" == typeof e) return Tr(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Tr(e, t) : void 0;
  }
}

function Ar(e) {
  return function (e) {
    if (Array.isArray(e)) return Tr(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || Nr(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

nr = ur.slice, rr = {
  __e: function __e(e, t, n, r) {
    for (var o, i, a; t = t.__;) {
      if ((o = t.__c) && !o.__) try {
        if ((i = o.constructor) && null != i.getDerivedStateFromError && (o.setState(i.getDerivedStateFromError(e)), a = o.__d), null != o.componentDidCatch && (o.componentDidCatch(e, r || {}), a = o.__d), a) return o.__E = o;
      } catch (t) {
        e = t;
      }
    }

    throw e;
  }
}, or = 0, yr.prototype.setState = function (e, t) {
  var n;
  n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = pr({}, this.state), "function" == typeof e && (e = e(pr({}, n), this.props)), e && pr(n, e), null != e && this.__v && (t && this.__h.push(t), _r(this));
}, yr.prototype.forceUpdate = function (e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), _r(this));
}, yr.prototype.render = vr, ir = [], ar = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, br.__r = 0;
var Mr = [],
    Fr = [];

function Hr(e, t) {
  if (e && "undefined" != typeof document) {
    var n,
        r = !0 === t.prepend ? "prepend" : "append",
        o = !0 === t.singleTag,
        i = "string" == typeof t.container ? document.querySelector(t.container) : document.getElementsByTagName("head")[0];

    if (o) {
      var a = Mr.indexOf(i);
      -1 === a && (a = Mr.push(i) - 1, Fr[a] = {}), n = Fr[a] && Fr[a][r] ? Fr[a][r] : Fr[a][r] = s();
    } else n = s();

    65279 === e.charCodeAt(0) && (e = e.substring(1)), n.styleSheet ? n.styleSheet.cssText += e : n.appendChild(document.createTextNode(e));
  }

  function s() {
    var e = document.createElement("style");
    if (e.setAttribute("type", "text/css"), t.attributes) for (var n = Object.keys(t.attributes), o = 0; o < n.length; o++) {
      e.setAttribute(n[o], t.attributes[n[o]]);
    }
    var a = "prepend" === r ? "afterbegin" : "beforeend";
    return i.insertAdjacentElement(a, e), e;
  }
}

var Wr = {
  container: "index_module_container__cbd1ab7f",
  inputWrap: "index_module_inputWrap__cbd1ab7f",
  label: "index_module_label__cbd1ab7f",
  stepAside: "index_module_stepAside__cbd1ab7f",
  content: "index_module_content__cbd1ab7f",
  focused: "index_module_focused__cbd1ab7f",
  error: "index_module_error__cbd1ab7f",
  messageArea: "index_module_messageArea__cbd1ab7f",
  iconArea: "index_module_iconArea__cbd1ab7f"
};
Hr(".index_module_container__cbd1ab7f {\n  position: relative;\n  width: 100%;\n  overflow: visible;\n  transition: all 0.2s linear;\n}\n  .index_module_container__cbd1ab7f .index_module_inputWrap__cbd1ab7f {\n    position: relative;\n    box-sizing: border-box;\n    overflow: hidden;\n    z-index: 1;\n    background: #fff;\n    height: 46px;\n    border: 1px solid;\n    border-radius: 4px;\n    color: rgba(142, 142, 142, 0.3);\n    border-color: currentColor;\n  }\n  .index_module_container__cbd1ab7f .index_module_inputWrap__cbd1ab7f .index_module_label__cbd1ab7f {\n      position: absolute;\n      top: calc(50% - 16px / 2);\n      left: 16px;\n      font-size: 14px;\n      line-height: 16px;\n      /* 这里必须使用 color, 避免影响 box-shadow-color */\n      color: rgba(44, 44, 44, 0.75);\n      pointer-events: none;\n      transition: all 0.2s linear;\n      white-space: nowrap;\n    }\n  .index_module_container__cbd1ab7f .index_module_inputWrap__cbd1ab7f .index_module_label__cbd1ab7f.index_module_stepAside__cbd1ab7f {\n        font-size: 10px;\n        transform: translateY(-9px);\n        transition: all 0.2s linear;\n      }\n  .index_module_container__cbd1ab7f .index_module_inputWrap__cbd1ab7f .index_module_content__cbd1ab7f {\n      height: 100%;\n      background-color: transparent;\n    }\n  .index_module_container__cbd1ab7f .index_module_inputWrap__cbd1ab7f.index_module_focused__cbd1ab7f {\n      /* 通过修改 color 配合 currentColor, 一并修改 border-color 与 box-shadow-color */\n      color: #276EAF;\n      border-color: currentColor;\n      box-shadow: 0 0 0 1px currentColor;\n    }\n  .index_module_container__cbd1ab7f.index_module_error__cbd1ab7f .index_module_inputWrap__cbd1ab7f {\n      color: #F04949;\n      border-color: currentColor;\n      box-shadow: 0 0 0 1px currentColor;\n    }\n  .index_module_container__cbd1ab7f .index_module_messageArea__cbd1ab7f {\n  }\n  .index_module_container__cbd1ab7f .index_module_iconArea__cbd1ab7f {\n  }\n", {});
var Vr = u(function (e) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  !function () {
    var t = {}.hasOwnProperty;

    function n() {
      for (var e = [], r = 0; r < arguments.length; r++) {
        var o = arguments[r];

        if (o) {
          var i = _typeof(o);

          if ("string" === i || "number" === i) e.push(this && this[o] || o);else if (Array.isArray(o)) e.push(n.apply(this, o));else if ("object" === i) if (o.toString === Object.prototype.toString) for (var a in o) {
            t.call(o, a) && o[a] && e.push(this && this[a] || a);
          } else e.push(o.toString());
        }
      }

      return e.join(" ");
    }

    e.exports ? (n["default"] = n, e.exports = n) : window.classNames = n;
  }();
});

function Ur(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".ExtraMessage_module_extraMessageContainer__186d9e75 {\n  font-size: 14px;\n  line-height: 16px;\n  transition: all 0.2s linear;\n  margin-left: 1px;\n  overflow: hidden;\n  margin-top: 6px;\n  color: rgba(44, 44, 44, 0.5);\n}\n  .ExtraMessage_module_extraMessageContainer__186d9e75.ExtraMessage_module_hidden__186d9e75 {\n    height: 0;\n    margin-top: 0;\n  }\n  .ExtraMessage_module_extraMessageContainer__186d9e75.ExtraMessage_module_error__186d9e75 {\n    color: #F04949;\n  }\n", {});

var zr = Vr.bind({
  extraMessageContainer: "ExtraMessage_module_extraMessageContainer__186d9e75",
  hidden: "ExtraMessage_module_hidden__186d9e75",
  error: "ExtraMessage_module_error__186d9e75"
}),
    qr = function (e) {
  h(n, yr);
  var t = Ur(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.message,
          n = e.hidden,
          r = e.type,
          o = e.gutter,
          i = e.color;
      return fr("div", {
        className: zr({
          extraMessageContainer: !0,
          hidden: n,
          error: "error" === r
        }),
        style: {
          marginTop: n ? void 0 : o,
          color: i
        }
      }, fr("span", {
        className: zr({
          message: !0
        })
      }, t));
    }
  }]), n;
}(),
    Gr = "CardBrandIcon_module_cardBrandIconContainer__128ff952",
    Zr = "CardBrandIcon_module_image__128ff952";

Hr(".CardBrandIcon_module_cardBrandIconContainer__128ff952 {\n  width: 38px;\n  height: 24px;\n  position: absolute;\n  right: 16px;\n  top: 0;\n  bottom: 0;\n  z-index: 3;\n  margin: auto;\n  display: flex;\n}\n  .CardBrandIcon_module_cardBrandIconContainer__128ff952 .CardBrandIcon_module_image__128ff952 {\n    width: 100%;\n    margin: auto;\n  }\n", {});
var Xr = Ze(je.Prod).imageHost;

function Kr(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Xr,
      n = e.toLowerCase().replace(/[ (\/]/g, "-").replace(/[)]/g, "");
  return "".concat(t, "/payment-sdk/images/card-brand/").concat(n, ".png");
}

function $r(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

function Yr(e, t) {
  return Jr.apply(this, arguments);
}

function Jr() {
  return (Jr = c(l.mark(function e(t, n) {
    var r, o;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (t && "Other" !== t) {
              e.next = 2;
              break;
            }

            return e.abrupt("return", !1);

          case 2:
            return r = Kr(t, n), o = document.createElement("img"), e.abrupt("return", Promise.race([new Promise(function (e) {
              o.addEventListener("load", function () {
                return e(!0);
              }), o.addEventListener("error", function () {
                return e(!1);
              }), o.addEventListener("abort", function () {
                return e(!1);
              }), o.src = r, o.complete && e(!0);
            }), new Promise(function (e) {
              var t;
              return setTimeout(e, 1e3, null !== (t = o.complete) && void 0 !== t && t);
            })]));

          case 5:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

var Qr = function (e) {
  h(n, yr);
  var t = $r(n);

  function n() {
    var e;
    r(this, n);

    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = t.call.apply(t, [this].concat(i))), "state", {
      cardBrandImgIsValid: null
    }), e;
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.cardBrand,
          n = e.imageHost;
      return fr("div", {
        className: Gr
      }, !1 !== this.state.cardBrandImgIsValid && fr("img", {
        className: Zr,
        src: Kr(t, n),
        alt: t
      }));
    }
  }]), n;
}();

_a2(Qr, "defaultProps", {
  imageHost: Xr
});

var eo = {
  iconTipsContainer: "IconTips_module_iconTipsContainer__78cb66fd",
  icon: "IconTips_module_icon__78cb66fd",
  imgIcon: "IconTips_module_imgIcon__78cb66fd"
};

function to(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".IconTips_module_iconTipsContainer__78cb66fd {\n  color: rgba(44, 44, 44, 0.75);\n  position: absolute;\n  right: 16px;\n  top: 0;\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n}\n  .IconTips_module_iconTipsContainer__78cb66fd .IconTips_module_icon__78cb66fd {\n    margin: auto;\n    z-index: 2;\n    line-height: 1;\n  }\n  .IconTips_module_iconTipsContainer__78cb66fd .IconTips_module_icon__78cb66fd > svg {\n      max-width: -webkit-fit-content;\n      max-width: -moz-fit-content;\n      max-width: fit-content;\n      width: 16px;\n      height: 16px;\n    }\n  .IconTips_module_iconTipsContainer__78cb66fd .IconTips_module_icon__78cb66fd .IconTips_module_imgIcon__78cb66fd {\n      max-width: -webkit-fit-content;\n      max-width: -moz-fit-content;\n      max-width: fit-content;\n      width: 16px;\n      height: 16px;\n    }\n", {});

function no(e, t) {
  var n = null;
  return function () {
    for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
      o[i] = arguments[i];
    }

    n && (clearTimeout(n), n = null), n = setTimeout(function () {
      e.apply(void 0, o);
    }, t);
  };
}

var ro = function (e) {
  h(n, yr);
  var t = to(n);

  function n() {
    var e;
    r(this, n);

    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = t.call.apply(t, [this].concat(i))), "removeResizeListener", void 0), _a2(d(e), "getResizeTriggerSize", function () {
      switch (e.props.triggerSize) {
        case !0:
          return 600;

        case !1:
          return null;

        default:
          return e.props.triggerSize;
      }
    }), e;
  }

  return i(n, [{
    key: "componentDidMount",
    value: function value() {
      var e = this.getResizeTriggerSize();

      if (null !== e && this.base instanceof Element) {
        var t = function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              o = function o() {
            var r = +getComputedStyle(e).getPropertyValue("width").replace("px", "");
            n(r > t);
          },
              i = no(o, null == r ? void 0 : r.resizeWait);

          return window.addEventListener("resize", i), {
            removeListener: function removeListener() {
              window.removeEventListener("resize", i);
            },
            callListener: function callListener() {
              return o();
            }
          };
        }(this.base, e, this.props.onResize, {
          resizeWait: 200
        }),
            n = t.removeListener,
            r = t.callListener;

        this.removeResizeListener = n, this.props.immediate && setTimeout(r);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.removeResizeListener && this.removeResizeListener();
    }
  }, {
    key: "render",
    value: function value() {
      return this.props.children;
    }
  }]), n;
}();

function oo(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

_a2(ro, "defaultProps", {
  immediate: !0
});

var io = {
  splitReg: "!\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
  matchReg: /!\[([^\]]+)\]\(([^)]+)\)/,
  replaceReg: "(!\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
},
    ao = {
  splitReg: "\\[[^\\]]+\\][\\\\]*\\([^)]+\\)",
  matchReg: /\[([^\]]+)\]\(([^)]+)\)/,
  replaceReg: "(\\[[^\\]]+\\])(\\\\+)(\\([^)]+\\))"
},
    so = {
  splitReg: "\\\\?\\*\\\\?\\*[^\\s]+\\\\?\\*\\\\?\\*",
  matchReg: /\*\*([^\s]+)\*\*/,
  replaceReg: "\\\\\\*\\\\\\*([^\\s]+)\\\\\\*\\\\\\*"
},
    co = {
  splitReg: "\\\\n|\\n",
  matchReg: /\n/,
  replaceReg: /\\n/
},
    uo = function uo(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
  return {
    tagName: e,
    content: t,
    property: n
  };
},
    lo = function lo(e, t, n, r) {
  return t + (n ? n.slice(1) : "") + r;
};

function po(e) {
  return (po = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  })(e);
}

var fo = function () {
  function e() {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, e), oo(this, "formatString", function (e, t) {
      return t && t.variable ? (n = e, r = t.variable, o = t.handleVariable, "string" == typeof n && n ? r && "object" === po(r) ? n.replace(/{{\s*([^}\s]+)\s*}}/g, function (e, t) {
        if (void 0 !== r[t]) {
          var n = r[t];
          return "function" == typeof o ? o(n) : n;
        }

        return e;
      }) : n : "") : e;
      var n, r, o;
    }), oo(this, "handleStrong", function (e, t) {
      var n = t.match(e);
      return uo("strong", n[1]);
    }), oo(this, "handleStrongReplace", function (e, t) {
      var n = t.replace(new RegExp(e, "g"), "**$1**");
      return uo("text", n);
    });
  }

  var t;
  return (t = [{
    key: "parseToTagConfig",
    value: function value(e, t) {
      var n = this,
          r = [],
          o = ao,
          i = io,
          a = so,
          s = co;
      if (!e || 0 !== e.indexOf("$RT$")) return [uo("text", e)];
      e = (e = this.formatString(e, t)).slice("$RT$".length);
      var c = "(".concat(i.splitReg, ")|(").concat(o.splitReg, ")|(").concat(a.splitReg, ")|(").concat(s.splitReg, ")");
      return e.split(new RegExp(c)).filter(function (e) {
        return !!e;
      }).forEach(function (e) {
        var t;

        if (new RegExp(i.matchReg).test(e)) {
          var c = e.match(i.matchReg);
          t = uo("img", "", {
            alt: c[1],
            src: c[2]
          });
        } else if (new RegExp(o.matchReg).test(e)) {
          var u = e.match(o.matchReg);
          t = uo("a", u[1], {
            href: u[2],
            target: "_blank",
            rel: "noopener"
          });
        } else if (a.matchReg.test(e)) t = n.handleStrong(a.matchReg, e);else if (new RegExp(i.replaceReg).test(e)) {
          var l = e.replace(new RegExp(i.replaceReg, "g"), lo);
          t = uo("text", l);
        } else if (new RegExp(o.replaceReg).test(e)) {
          var p = e.replace(new RegExp(o.replaceReg, "g"), lo);
          t = uo("text", p);
        } else t = new RegExp(a.replaceReg).test(e) ? n.handleStrongReplace(a.replaceReg, e) : new RegExp(s.replaceReg).test(e) ? uo("text", "\\n") : new RegExp(s.matchReg).test(e) ? uo("br", "") : uo("text", e);

        r.push(t);
      }), r;
    }
  }, {
    key: "parseToDom",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = document.createElement(t);
      return e.forEach(function (e) {
        var t = document.createElement("text" === e.tagName ? "span" : e.tagName);
        t.textContent = e.content, e.property && Object.keys(e.property).forEach(function (n) {
          return t.setAttribute(n, e.property[n]);
        }), n.appendChild(t);
      }), n;
    }
  }, {
    key: "autoParseToDom",
    value: function value(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "div",
          n = arguments.length > 2 ? arguments[2] : void 0,
          r = this.parseToTagConfig(e, n);
      return this.parseToDom(r, t);
    }
  }]) && function (e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }(e.prototype, t), e;
}(),
    ho = "index_module_richText__ef90b042",
    vo = "index_module_tagText__ef90b042",
    yo = "index_module_tagLink__ef90b042";

function mo(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

function go(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

Hr(".index_module_richText__ef90b042 .index_module_tagText__ef90b042 {\n  }\n  .index_module_richText__ef90b042 .index_module_tagLink__ef90b042 {\n  }\n  .index_module_richText__ef90b042 strong {\n    font-weight: bold;\n  }\n", {});

var _o = new fo(),
    bo = {
  text: function text(e, t) {
    return fr("span", {
      style: {
        color: null == t ? void 0 : t.fontColor
      },
      className: vo
    }, e.content);
  },
  a: function a(e, t) {
    var n = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? go(Object(n), !0).forEach(function (t) {
          _a2(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : go(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({}, e.property);

    return fr("a", {
      style: {
        color: null == t ? void 0 : t.linkColor,
        textDecoration: null == t ? void 0 : t.linkDecoration
      },
      className: yo,
      href: n.href,
      target: n.target,
      rel: "noopener"
    }, e.content);
  },
  strong: function strong(e, t) {
    return fr("strong", {
      style: {
        color: null == t ? void 0 : t.fontColor
      },
      className: yo
    }, e.content);
  },
  br: function br() {
    return fr("br", null);
  }
},
    wo = function (e) {
  h(n, yr);
  var t = mo(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this,
          t = _o.parseToTagConfig(this.props.text, this.props.parseOption);

      return fr("span", {
        className: ho
      }, t.map(function (t) {
        var n;
        return null !== (n = null == bo ? void 0 : bo[t.tagName](t, e.props.theme)) && void 0 !== n ? n : null;
      }));
    }
  }]), n;
}(),
    Co = {
  tooltipWrapper: "index_module_tooltipWrapper__24a566ba",
  tooltip: "index_module_tooltip__24a566ba",
  tooltipWrap: "index_module_tooltipWrap__24a566ba",
  tooltipShow: "index_module_tooltipShow__24a566ba",
  tooltipContent: "index_module_tooltipContent__24a566ba",
  tooltipThemeDark: "index_module_tooltipThemeDark__24a566ba",
  tooltipThemeWhite: "index_module_tooltipThemeWhite__24a566ba"
};

function xo(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ko(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? xo(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xo(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function Oo(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr('.index_module_tooltipWrapper__24a566ba {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 0;\n  height: 0;\n}\n\n.index_module_tooltip__24a566ba {\n  position: absolute;\n  z-index: 3;\n  display: none;\n}\n\n.index_module_tooltip__24a566ba::after {\n    content: "";\n    position: absolute;\n    width: 0px;\n    height: 0px;\n    border: 6px solid transparent;\n    border-color: inherit;\n  }\n\n.index_module_tooltip__24a566ba[data-placement^="top"]::after {\n      border-left-color: transparent;\n      border-right-color: transparent;\n      border-bottom-color: transparent;\n      bottom: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n\n.index_module_tooltip__24a566ba[data-placement^="top"] .index_module_tooltipWrap__24a566ba {\n      bottom: calc(100% + 10px);\n    }\n\n.index_module_tooltip__24a566ba[data-placement^="top"] .index_module_tooltipWrap__24a566ba::before {\n        width: 100%;\n        height: 12px;\n        bottom: -12px;\n        left: 0px;\n      }\n\n.index_module_tooltip__24a566ba[data-placement^="bottom"]::after {\n      border-left-color: transparent;\n      border-right-color: transparent;\n      border-top-color: transparent;\n      top: 100%;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n\n.index_module_tooltip__24a566ba[data-placement^="bottom"] .index_module_tooltipWrap__24a566ba {\n      top: calc(100% + 10px);\n      bottom: auto;\n    }\n\n.index_module_tooltip__24a566ba[data-placement^="bottom"] .index_module_tooltipWrap__24a566ba::before {\n        width: 100%;\n        height: 12px;\n        top: -12px;\n        left: 0px;\n      }\n\n.index_module_tooltip__24a566ba[data-placement^="left"]::after {\n      border-top-color: transparent;\n      border-right-color: transparent;\n      border-bottom-color: transparent;\n      right: 100%;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n\n.index_module_tooltip__24a566ba[data-placement^="left"] .index_module_tooltipWrap__24a566ba {\n      right: calc(100% + 10px);\n    }\n\n.index_module_tooltip__24a566ba[data-placement^="left"] .index_module_tooltipWrap__24a566ba::before {\n        height: 100%;\n        width: 12px;\n        right: -12px;\n        top: 0px;\n      }\n\n.index_module_tooltip__24a566ba[data-placement^="right"]::after {\n      border-left-color: transparent;\n      border-top-color: transparent;\n      border-bottom-color: transparent;\n      left: 100%;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n\n.index_module_tooltip__24a566ba[data-placement^="right"] .index_module_tooltipWrap__24a566ba {\n      left: calc(100% + 10px);\n    }\n\n.index_module_tooltip__24a566ba[data-placement^="right"] .index_module_tooltipWrap__24a566ba::before {\n        height: 100%;\n        width: 12px;\n        left: -12px;\n        top: 0px;\n      }\n\n.index_module_tooltip__24a566ba[data-placement$="Left"] .index_module_tooltipWrap__24a566ba {\n      right: 0px;\n    }\n\n.index_module_tooltip__24a566ba[data-placement$="Right"] .index_module_tooltipWrap__24a566ba {\n      left: 0px;\n    }\n\n.index_module_tooltip__24a566ba[data-placement$="Top"] .index_module_tooltipWrap__24a566ba {\n      bottom: 0;\n    }\n\n.index_module_tooltip__24a566ba[data-placement$="Bottom"] .index_module_tooltipWrap__24a566ba {\n      top: 0;\n      bottom: auto;\n    }\n\n.index_module_tooltip__24a566ba[data-placement="top"] .index_module_tooltipWrap__24a566ba {\n      left: -9999px;\n      right: -9999px;\n      margin: auto !important;\n    }\n\n.index_module_tooltip__24a566ba[data-placement="bottom"] .index_module_tooltipWrap__24a566ba {\n      left: -9999px;\n      right: -9999px;\n      bottom: auto;\n      margin: auto !important;\n    }\n\n.index_module_tooltip__24a566ba[data-placement="left"] .index_module_tooltipWrap__24a566ba {\n      bottom: auto;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n\n.index_module_tooltip__24a566ba[data-placement="right"] .index_module_tooltipWrap__24a566ba {\n      bottom: auto;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n\n.index_module_tooltip__24a566ba.index_module_tooltipShow__24a566ba {\n    display: block;\n    z-index: 1000;\n  }\n\n.index_module_tooltipWrap__24a566ba {\n  position: absolute;\n  bottom: 26px;\n  right: -17px;\n  box-sizing: border-box;\n  width: 180px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  border-radius: 4px;\n  font-size: 12px;\n  line-height: 18px;\n}\n\n.index_module_tooltipWrap__24a566ba::before {\n    content: "";\n    display: block;\n    position: absolute;\n  }\n\n.index_module_tooltipContent__24a566ba {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 6px 12px;\n}\n\n.index_module_tooltipThemeDark__24a566ba {\n  border-color: rgba(30, 30, 30, 0.9);\n}\n\n.index_module_tooltipThemeDark__24a566ba .index_module_tooltipWrap__24a566ba {\n    background: rgba(30, 30, 30, 0.9);\n    color: rgba(255, 255, 255, 0.9);\n  }\n\n.index_module_tooltipThemeWhite__24a566ba {\n  border-color: #fff;\n}\n\n.index_module_tooltipThemeWhite__24a566ba .index_module_tooltipWrap__24a566ba {\n    background: #fff;\n    color: #474f5e;\n    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.22);\n  }\n', {});
var Po,
    Io,
    Eo = Vr.bind(Co);
!function (e) {
  e.Dark = "dark", e.White = "white";
}(Po || (Po = {})), function (e) {
  e.Click = "click", e.Hover = "hover";
}(Io || (Io = {}));

var Ro = function (e) {
  h(n, yr);
  var t = Oo(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "getTheme",
    value: function value() {
      var e = this.props.theme,
          t = {
        extend: Po.Dark
      };
      return "string" == typeof e ? t.extend = e : Object.assign(t, e), t;
    }
  }, {
    key: "stopBubble",
    value: function value(e) {
      e.stopPropagation();
    }
  }, {
    key: "getTooltipPosition",
    value: function value() {
      var e = this.props,
          t = e.triggerAbsPos,
          n = e.isAutoCenter,
          r = e.placement,
          o = e.containerAbsPos;
      if (!n || !r.includes("top") && !r.includes("bottom")) return {};
      var i = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
          a = o ? o.width : i - 20,
          s = {
        width: "".concat(a, "px")
      };
      if (t.left < 10) s.left = "0", s.right = "auto";else if (i - t.right < 10) s.right = "0", s.left = "auto";else {
        var c;
        s.left = "".concat(-(t.left - (null !== (c = null == o ? void 0 : o.left) && void 0 !== c ? c : 10)), "px"), s.right = "auto";
      }
      return s;
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.title,
          r = t.placement,
          o = t.content,
          i = t.triggerAbsPos,
          a = t.trigger,
          s = t.isShowTooltip,
          c = t.onHideTooltip;
      if (!n && !o) return null;
      var u = this.getTheme(),
          l = this.getTooltipPosition();
      return fr("div", {
        className: Eo({
          tooltip: !0,
          tooltipTriggerHover: a === Io.Hover,
          tooltipTriggerClick: a === Io.Click,
          tooltipThemeDark: u.extend === Po.Dark,
          tooltipThemeWhite: u.extend === Po.White,
          tooltipShow: s
        }),
        "data-placement": r,
        style: {
          width: "".concat(i.width, "px"),
          height: "".concat(i.height, "px"),
          left: "".concat(i.left, "px"),
          top: "".concat(i.top, "px"),
          borderColor: u.background
        },
        onClick: a === Io.Click ? function (t) {
          return e.stopBubble(t);
        } : void 0,
        onMouseLeave: a === Io.Hover ? function () {
          return c();
        } : void 0
      }, fr("div", {
        className: Co.tooltipWrap,
        style: {
          width: l.width || u.width,
          borderRadius: u.borderRadius,
          background: u.background,
          color: u.fontColor,
          left: l.left,
          right: l.right
        }
      }, fr("div", {
        className: Co.tooltipContent,
        style: {
          overflowY: u.maxHeight ? "scroll" : void 0,
          maxHeight: u.maxHeight,
          padding: u.padding
        }
      }, o || fr(wo, {
        text: n,
        theme: u
      }))));
    }
  }]), n;
}();

_a2(Ro, "defaultProps", {
  title: "",
  placement: "topLeft",
  theme: Po.Dark
});

var Do = function (e) {
  h(n, yr);
  var t = Oo(n);

  function n() {
    var e;
    r(this, n);

    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = t.call.apply(t, [this].concat(i))), "CONTAINER_DOM", void 0), _a2(d(e), "isShowTooltip", void 0), _a2(d(e), "removeEventListeners", []), _a2(d(e), "getTriggerDomPos", function () {
      var t = (e.base instanceof Element ? e.base : e.base.parentNode).getBoundingClientRect(),
          n = window.scrollY || window.pageYOffset || (0 === document.documentElement.scrollTop ? document.body.scrollTop : document.documentElement.scrollTop);
      return {
        width: t.width,
        height: t.height,
        right: t.right,
        left: t.x || t.left,
        top: (t.y || t.top) + n
      };
    }), _a2(d(e), "renderTooltip", function () {
      e.base && Br(fr(Ro, ko(ko({}, e.props), {}, {
        triggerAbsPos: e.getTriggerDomPos(),
        isShowTooltip: e.isShowTooltip,
        onHideTooltip: e.hideTooltip
      })), e.CONTAINER_DOM);
    }), _a2(d(e), "handleResize", function () {
      e.isShowTooltip && e.renderTooltip();
    }), _a2(d(e), "showTooltip", function (t) {
      t.stopPropagation(), e.isShowTooltip = !0, e.renderTooltip();
    }), _a2(d(e), "hideTooltip", function () {
      e.isShowTooltip = !1, e.renderTooltip();
    }), e;
  }

  return i(n, [{
    key: "createContainer",
    value: function value() {
      if (!this.CONTAINER_DOM) {
        var e = document.createElement("DIV");
        e.className = Co.tooltipWrapper, document.body.appendChild(e), this.CONTAINER_DOM = e;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      Ee(this.CONTAINER_DOM), this.removeEventListeners && this.removeEventListeners.length > 0 && this.removeEventListeners.forEach(function (e) {
        return e();
      });
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.base && (this.createContainer(), this.addEventListeners());
    }
  }, {
    key: "addEventListeners",
    value: function value() {
      var e = this;
      this.props.trigger === Io.Click ? (this.base.addEventListener("click", this.showTooltip), document.addEventListener("click", this.hideTooltip), this.removeEventListeners.push(function () {
        return e.base.removeEventListener("click", e.showTooltip);
      }), this.removeEventListeners.push(function () {
        return document.removeEventListener("click", e.hideTooltip);
      })) : this.props.trigger === Io.Hover && (this.base.addEventListener("mouseover", this.showTooltip), this.removeEventListeners.push(function () {
        return e.base.removeEventListener("mouseover", e.showTooltip);
      }));
    }
  }, {
    key: "render",
    value: function value() {
      return this.renderTooltip(), fr(ro, {
        triggerSize: !0,
        onResize: this.handleResize
      }, this.props.children);
    }
  }]), n;
}();

function So(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

_a2(Do, "defaultProps", {
  trigger: Io.Hover
});

var jo = Vr.bind(eo),
    Lo = function (e) {
  h(n, yr);
  var t = So(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.icon,
          n = e.text,
          r = e.color,
          o = "string" == typeof t ? fr("img", {
        src: t,
        alt: "icon",
        className: eo.imgIcon
      }) : t;
      return fr("div", {
        className: jo({
          iconTipsContainer: !0
        }),
        style: {
          color: r
        }
      }, fr("div", {
        className: eo.icon
      }, n ? fr(Do, {
        content: n
      }, o) : o));
    }
  }]), n;
}();

function Bo(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var To = Vr.bind(Wr),
    No = function (e) {
  h(o, yr);
  var t,
      n = Bo(o);

  function o(e) {
    var t;
    return r(this, o), _a2(d(t = n.call(this, e)), "functionArrayCallAtUnmount", []), _a2(d(t), "envConfig", void 0), _a2(d(t), "addUnmountFunction", function () {
      for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
        n[r] = arguments[r];
      }

      n.forEach(function (e) {
        "function" == typeof e && t.functionArrayCallAtUnmount.push(e);
      });
    }), _a2(d(t), "setPlaceholder", function () {
      t.props.pciInstanceBusInput.setPciInstanceCreateConfig({
        placeholder: _a2({}, t.props.name, t.props.placeholder)
      });
    }), _a2(d(t), "setTheme", function () {
      var e, n, r, o, i, a;
      t.props.pciInstanceBusInput.setStyle(t.props.name, {
        padding: "20px 0 0 16px",
        color: null === (e = t.props) || void 0 === e || null === (n = e.theme) || void 0 === n ? void 0 : n.inputFontColor,
        fontLib: null === (r = t.props) || void 0 === r || null === (o = r.theme) || void 0 === o ? void 0 : o.inputFontLib,
        fontFamily: null === (i = t.props) || void 0 === i || null === (a = i.theme) || void 0 === a ? void 0 : a.inputFontFamily
      });
    }), _a2(d(t), "handleFocus", function (e) {
      var n = e.isFocus,
          r = e.isEmpty,
          o = e.isValid,
          i = {
        isFocused: n,
        isEmpty: r,
        isValid: o,
        isCreditNumberFormatInError: r || !o
      };
      n && (i.isDisplayErrorForce = !1), t.setState(i);
    }), _a2(d(t), "handleFieldValidChange", function (e) {
      t.setState({
        isEmpty: e.isEmpty,
        isValid: e.isValid
      });
    }), _a2(d(t), "handleCardBinChange", function () {
      var e = c(l.mark(function e(n) {
        var r, o, i, a, s, c, u;
        return l.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (!(i = null !== (r = null == n || null === (o = n.binInfo) || void 0 === o ? void 0 : o.brand) && void 0 !== r ? r : null)) {
                  e.next = 6;
                  break;
                }

                return e.next = 4, Yr(i, null === (a = t.envConfig) || void 0 === a ? void 0 : a.imageHost);

              case 4:
                if (e.sent) {
                  e.next = 6;
                  break;
                }

                i = null;

              case 6:
                if (s = n.verifyResult, c = null, null != s && s.result) {
                  e.next = 13;
                  break;
                }

                return u = s.errorCode, e.next = 12, t.getCardBinErrorMessage(u);

              case 12:
                c = e.sent;

              case 13:
                t.setState({
                  cardBrand: i,
                  cardBinErrorMessage: c,
                  isCardBrandValidateInError: !!c
                });

              case 14:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), _a2(d(t), "linkInputEvent", function () {
      var e = t.props.pciInstanceBusInput;
      t.addUnmountFunction(e.addEventListener("init", function () {
        t.setTheme();
      }), e.addEventListener("focus", t.handleFocus, t.props.name), e.addEventListener("fieldValidChange", t.handleFieldValidChange, t.props.name), "number" === t.props.name && e.addEventListener("cardBinChange", t.handleCardBinChange));
    }), _a2(d(t), "state", {
      isFocused: !1,
      isValid: !1,
      isEmpty: !0,
      errorMessage: null,
      isCreditNumberFormatInError: !1,
      cardBinErrorMessage: null,
      isCardBrandValidateInError: !1,
      cardBrand: null,
      isDisplayErrorForce: !1
    }), t.envConfig = Ze(e.env), t;
  }

  return i(o, [{
    key: "getCardBinErrorMessage",
    value: (t = c(l.mark(function e(t) {
      var n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if ("number" != typeof t && "string" != typeof t || (n = this.props.i18nGetText("validator.".concat(t))), !n) {
                e.next = 5;
                break;
              }

              return e.abrupt("return", n);

            case 5:
              return e.abrupt("return", this.props.i18nGetText("cardIsNotSupported"));

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "getErrorDisplayStatus",
    value: function value() {
      if (this.state.isDisplayErrorForce) return !0;
      var e = this.state,
          t = e.isCardBrandValidateInError,
          n = e.isCreditNumberFormatInError,
          r = e.isFocused,
          o = e.isEmpty;
      return !!t || !r && !o && n;
    }
  }, {
    key: "getErrorMessage",
    value: function value() {
      return this.props.error ? this.props.error : this.state.isCardBrandValidateInError ? this.state.cardBinErrorMessage : this.state.errorMessage ? this.state.errorMessage : this.state.isEmpty || !this.state.isValid ? this.props.i18nGetText("formItems.".concat(this.props.name, ".errorTips")) : void 0;
    }
  }, {
    key: "setError",
    value: function value(e) {
      this.setState({
        errorMessage: e,
        isDisplayErrorForce: !0
      });
    }
  }, {
    key: "validate",
    value: function value() {
      return this.setState({
        isDisplayErrorForce: !this.state.isValid
      }), !this.state.isCreditNumberFormatInError && !this.state.isCardBrandValidateInError;
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.props.placeholder && this.setPlaceholder(), this.linkInputEvent();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.functionArrayCallAtUnmount.forEach(function (e) {
        return e();
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e,
          t,
          n = this.props,
          r = n.label,
          o = n.name,
          i = n.className,
          s = n.help,
          c = n.tips,
          u = n.theme,
          l = void 0 === u ? {} : u,
          p = this.state,
          d = p.isFocused,
          f = p.isEmpty,
          h = p.cardBrand,
          v = this.getErrorMessage(),
          y = this.getErrorDisplayStatus(),
          m = !!v && fr(qr, {
        message: v,
        hidden: !y,
        type: "error",
        gutter: l.inputTipGutter,
        color: l.inputErrorFontColor
      }),
          g = !!s && fr(qr, {
        message: s,
        hidden: y || !d,
        gutter: l.inputTipGutter,
        color: l.inputTipColor
      }),
          _ = h ? fr(Qr, {
        cardBrand: h,
        imageHost: null === (e = this.envConfig) || void 0 === e ? void 0 : e.imageHost
      }) : c && c.icon && fr(Lo, {
        icon: c.icon,
        text: c.text,
        color: l.inputIconColor
      });

      return fr("div", {
        className: To((t = {
          container: !0
        }, _a2(t, i, !!i), _a2(t, "error", y), t))
      }, fr("div", {
        className: To({
          inputWrap: !0,
          focused: d
        }),
        style: {
          color: d ? l.inputFocusBorderColor : y ? l.inputErrorBorderColor : l.inputBorderColor,
          height: l.inputHeight,
          backgroundColor: l.inputBackground,
          borderRadius: l.inputBorderRadius
        }
      }, fr("label", {
        className: To({
          label: !0,
          stepAside: d || !f
        }),
        style: {
          color: l.inputLabelColor
        }
      }, r), fr("div", {
        className: Wr.content,
        "data-pci": o
      }), _), fr("div", {
        className: Wr.messageArea
      }, g, m));
    }
  }]), o;
}();

function Ao(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = n, o = e.length; r < o; r++) {
    var i = e[r];

    if ("function" == typeof t) {
      if (i === t(i, r, e)) return r;
    } else if (i === t) return r;
  }

  return -1;
}

function Mo(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Fo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Mo(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mo(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

_a2(No, "defaultProps", {
  env: je.Prod
});

var Ho = {
  focus: function focus(e, t) {
    return function (n) {
      e === n.fieldName && t(n);
    };
  },
  fieldValidChange: function fieldValidChange(e, t) {
    return function (n) {
      e === n.fieldName && t(n);
    };
  }
};

function Wo(e) {
  var t = !1,
      n = Object.freeze({
    init: [],
    focus: [],
    brandChange: [],
    fieldValidChange: [],
    cardBinChange: [],
    cardBinValueChange: []
  }),
      r = Object.freeze({
    placeholder: Object.freeze({}),
    extraConfig: Object.freeze({})
  }),
      o = {
    input: {
      addEventListener: function addEventListener(e, t, r) {
        return e in Ho && (t = Ho[e](r, t)), n[e].push(t), function () {
          return o.input.removeEventListener(e, t);
        };
      },
      removeEventListener: function removeEventListener(e, t) {
        if (n) {
          var r = Ao(n[e], t);
          -1 !== r && n[e].splice(r, 1);
        }
      },
      setPciInstanceCreateConfig: function setPciInstanceCreateConfig(e) {
        var t, n;
        t = r, n = e, r = Object.freeze({
          placeholder: Object.freeze(Fo(Fo({}, t.placeholder), n.placeholder)),
          extraConfig: Object.freeze(Fo(Fo({}, t.extraConfig), n.placeholder))
        });
      },
      setStyle: function setStyle(t, n) {
        e.setStyle({
          type: "base",
          fieldName: t,
          style: n
        });
      }
    },
    form: {
      setInitialed: function setInitialed() {
        t = !0;
      },
      getPciInstanceCreateConfig: function getPciInstanceCreateConfig() {
        if (t) throw new Error("Call getPciInstanceCreateConfig() before initialed!");
        return r;
      },
      emitEvent: function emitEvent(e, t) {
        n[e].forEach(function (e) {
          return e(t);
        });
      },
      destroyBus: function destroyBus() {
        n = null, r = null;
      }
    }
  };
  return o;
}

var Vo = ["number", "firstName", "expDate", "cvc"].map(function (e) {
  return ["formItems.".concat(e, ".labelTitle"), "formItems.".concat(e, ".placeholder"), "formItems.".concat(e, ".tips"), "formItems.".concat(e, ".errorTips")];
}).reduce(function (e, t) {
  return e.concat(t);
}),
    Uo = ["43000", "43001", "43002", "43004", "43005", "43006", "43007", "43008"].map(function (e) {
  return "validator.".concat(e);
}),
    zo = [].concat(Ar(Vo), Ar(Uo), ["cardIsNotSupported", "pleaseEnterNameOnCardOrBusinessName", "footer", "content.creditCard.serviceTips"]),
    qo = function e(t, n) {
  var o = this;
  r(this, e), _a2(this, "config", void 0), _a2(this, "usefulLanguage", void 0), _a2(this, "isReady", void 0), _a2(this, "i18nGetter", void 0), _a2(this, "ready", c(l.mark(function e() {
    var t;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return t = [o.config.footerI18nKey], e.next = 3, o.i18nGetter(zo.concat(t));

          case 3:
            o.usefulLanguage = e.sent, o.isReady = !0;

          case 5:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))), _a2(this, "getText", function (e) {
    var t, n;
    return o.usefulLanguage.hasOwnProperty(e) ? n = o.usefulLanguage[e] : o.isReady && console.warn("TextHandler.getText() 查无该 key: ".concat(e)), null !== (t = n) && void 0 !== t ? t : "";
  }), this.config = n, this.i18nGetter = t, this.usefulLanguage = {}, this.isReady = !1;
},
    Go = {
  container: "Layout_module_container__4f34d329",
  inputWrap: "Layout_module_inputWrap__4f34d329",
  label: "Layout_module_label__4f34d329",
  stepAside: "Layout_module_stepAside__4f34d329",
  content: "Layout_module_content__4f34d329",
  focused: "Layout_module_focused__4f34d329",
  error: "Layout_module_error__4f34d329",
  messageArea: "Layout_module_messageArea__4f34d329",
  iconArea: "Layout_module_iconArea__4f34d329",
  pciContainer: "Layout_module_pciContainer__4f34d329",
  input: "Layout_module_input__4f34d329",
  pciDateAndCvcBox: "Layout_module_pciDateAndCvcBox__4f34d329",
  pciPcStyle: "Layout_module_pciPcStyle__4f34d329",
  pciMobileStyle: "Layout_module_pciMobileStyle__4f34d329",
  footerArea: "Layout_module_footerArea__4f34d329",
  skeletonBone: "Layout_module_skeletonBone__4f34d329",
  hidden: "Layout_module_hidden__4f34d329",
  skeletonClient: "Layout_module_skeletonClient__4f34d329",
  visible: "Layout_module_visible__4f34d329"
};

function Zo(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Xo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Zo(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zo(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function Ko(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".Layout_module_container__4f34d329 {\n  position: relative;\n  width: 100%;\n  overflow: visible;\n  transition: all 0.2s linear;\n}\n  .Layout_module_container__4f34d329 .Layout_module_inputWrap__4f34d329 {\n    position: relative;\n    box-sizing: border-box;\n    overflow: hidden;\n    z-index: 1;\n    background: #fff;\n    height: 46px;\n    border: 1px solid;\n    border-radius: 4px;\n    color: rgba(142, 142, 142, 0.3);\n    border-color: currentColor;\n  }\n  .Layout_module_container__4f34d329 .Layout_module_inputWrap__4f34d329 .Layout_module_label__4f34d329 {\n      position: absolute;\n      top: calc(50% - 16px / 2);\n      left: 16px;\n      font-size: 14px;\n      line-height: 16px;\n      /* 这里必须使用 color, 避免影响 box-shadow-color */\n      color: rgba(44, 44, 44, 0.75);\n      pointer-events: none;\n      transition: all 0.2s linear;\n      white-space: nowrap;\n    }\n  .Layout_module_container__4f34d329 .Layout_module_inputWrap__4f34d329 .Layout_module_label__4f34d329.Layout_module_stepAside__4f34d329 {\n        font-size: 10px;\n        transform: translateY(-9px);\n        transition: all 0.2s linear;\n      }\n  .Layout_module_container__4f34d329 .Layout_module_inputWrap__4f34d329 .Layout_module_content__4f34d329 {\n      height: 100%;\n      background-color: transparent;\n    }\n  .Layout_module_container__4f34d329 .Layout_module_inputWrap__4f34d329.Layout_module_focused__4f34d329 {\n      /* 通过修改 color 配合 currentColor, 一并修改 border-color 与 box-shadow-color */\n      color: #276EAF;\n      border-color: currentColor;\n      box-shadow: 0 0 0 1px currentColor;\n    }\n  .Layout_module_container__4f34d329.Layout_module_error__4f34d329 .Layout_module_inputWrap__4f34d329 {\n      color: #F04949;\n      border-color: currentColor;\n      box-shadow: 0 0 0 1px currentColor;\n    }\n  .Layout_module_container__4f34d329 .Layout_module_messageArea__4f34d329 {\n  }\n  .Layout_module_container__4f34d329 .Layout_module_iconArea__4f34d329 {\n  }\n\n.Layout_module_pciContainer__4f34d329 {\n  margin: 0 auto;\n}\n\n.Layout_module_pciContainer__4f34d329 .Layout_module_input__4f34d329 {\n    margin-bottom: 12px;\n    position: relative;\n  }\n\n.Layout_module_pciContainer__4f34d329 .Layout_module_pciDateAndCvcBox__4f34d329 {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n\n.Layout_module_pciContainer__4f34d329 .Layout_module_pciDateAndCvcBox__4f34d329 .Layout_module_input__4f34d329:first-child {\n        margin-right: 12px;\n      }\n\n.Layout_module_pciContainer__4f34d329.Layout_module_pciPcStyle__4f34d329 .Layout_module_pciDateAndCvcBox__4f34d329 .Layout_module_input__4f34d329 {\n      width: 50%;\n      margin-bottom: 12px;\n    }\n\n.Layout_module_pciContainer__4f34d329.Layout_module_pciMobileStyle__4f34d329 {\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n.Layout_module_pciContainer__4f34d329.Layout_module_pciMobileStyle__4f34d329 .Layout_module_pciDateAndCvcBox__4f34d329 {\n      display: block;\n    }\n\n.Layout_module_pciContainer__4f34d329.Layout_module_pciMobileStyle__4f34d329 .Layout_module_pciDateAndCvcBox__4f34d329 .Layout_module_input__4f34d329:first-child {\n          margin-right: 0;\n        }\n\n.Layout_module_pciContainer__4f34d329 .Layout_module_footerArea__4f34d329 {\n    position: relative;\n    min-height: 16px;\n  }\n\n.Layout_module_pciContainer__4f34d329 .Layout_module_skeletonBone__4f34d329 {\n    background: #2C2C2C;\n    opacity: 0.05;\n    border-radius: 4px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 2;\n  }\n\n.Layout_module_pciContainer__4f34d329 .Layout_module_skeletonBone__4f34d329.Layout_module_hidden__4f34d329 {\n      opacity: 0;\n      transition: opacity 500ms;\n      z-index: -1;\n    }\n\n.Layout_module_pciContainer__4f34d329 .Layout_module_skeletonClient__4f34d329 {\n    opacity: 0;\n  }\n\n.Layout_module_pciContainer__4f34d329 .Layout_module_skeletonClient__4f34d329.Layout_module_visible__4f34d329 {\n      opacity: 1;\n      transition: opacity 500ms;\n    }\n", {});

var $o = Vr.bind(Go),
    Yo = function Yo(e) {
  var t, n;
  return fr(vr, null, fr("div", {
    className: $o({
      skeletonBone: !0,
      hidden: e.isLoaded
    }),
    style: {
      background: null == e || null === (t = e.theme) || void 0 === t ? void 0 : t.background,
      borderRadius: null == e || null === (n = e.theme) || void 0 === n ? void 0 : n.borderRadius
    }
  }), fr("div", {
    className: $o({
      skeletonClient: !0,
      visible: e.isLoaded
    })
  }, e.children));
},
    Jo = function (e) {
  h(n, yr);
  var t = Ko(n);

  function n() {
    var e;
    r(this, n);

    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = t.call.apply(t, [this].concat(i))), "handleResize", function (t) {
      e.setState({
        isBigSizeView: t
      });
    }), _a2(d(e), "state", {
      isBigSizeView: !1
    }), e;
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.state.isBigSizeView,
          t = this.props,
          n = t.inputCardNumber,
          r = t.inputCvc,
          o = t.inputExpDate,
          i = t.inputFirstName,
          a = t.footer,
          s = t.ref,
          c = t.needAdaptive,
          u = t.isLoaded,
          l = t.theme,
          p = void 0 === l ? {} : l,
          d = {
        marginBottom: p.formItemGutter
      },
          f = {
        background: p.inputFontColor,
        borderRadius: p.inputBorderRadius
      };
      return fr(ro, {
        triggerSize: c,
        onResize: this.handleResize
      }, fr("div", {
        className: $o({
          pciContainer: !0,
          pciPcStyle: e,
          pciMobileStyle: !e
        }),
        ref: s
      }, fr("div", {
        className: Go.input,
        style: d
      }, fr(Yo, {
        isLoaded: u,
        theme: f
      }, n)), !!i && fr("div", {
        className: Go.input,
        style: d
      }, fr(Yo, {
        isLoaded: u,
        theme: f
      }, i)), fr("div", {
        className: Go.pciDateAndCvcBox
      }, fr("div", {
        className: Go.input,
        style: Xo(Xo({}, d), {}, {
          marginRight: e ? p.formItemGutter : void 0
        })
      }, fr(Yo, {
        isLoaded: u,
        theme: f
      }, o)), fr("div", {
        className: Go.input,
        style: d
      }, fr(Yo, {
        isLoaded: u,
        theme: f
      }, r))), !!a && fr("div", {
        className: Go.footerArea
      }, fr(Yo, {
        isLoaded: u,
        theme: f
      }, a))));
    }
  }]), n;
}();

function Qo() {
  return (Qo = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

_a2(Jo, "defaultProps", {
  needAdaptive: !0
});

var ei = function ei(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.99998 2.70002C6.70211 2.70002 5.64998 3.75216 5.64998 5.05002V5.79999H10.35V5.05002C10.35 3.75216 9.29784 2.70002 7.99998 2.70002ZM4.34998 5.05002V5.79999H4C2.89543 5.79999 2 6.69542 2 7.79999V12.8C2 13.9046 2.89543 14.8 4 14.8H12C13.1046 14.8 14 13.9046 14 12.8V7.79999C14 6.69542 13.1046 5.79999 12 5.79999H11.65V5.05002C11.65 3.03418 10.0158 1.40002 7.99998 1.40002C5.98414 1.40002 4.34998 3.03418 4.34998 5.05002ZM4 7.09999H12C12.3866 7.09999 12.7 7.41339 12.7 7.79999V12.8C12.7 13.1866 12.3866 13.5 12 13.5H4C3.6134 13.5 3.3 13.1866 3.3 12.8V7.79999C3.3 7.41339 3.6134 7.09999 4 7.09999ZM8.59998 10.5395C8.9587 10.332 9.20005 9.94419 9.20005 9.49999C9.20005 8.83725 8.66279 8.29999 8.00005 8.29999C7.33731 8.29999 6.80005 8.83725 6.80005 9.49999C6.80005 9.94413 7.04134 10.3319 7.39998 10.5394V11.9C7.39998 12.2314 7.6686 12.5 7.99998 12.5C8.33135 12.5 8.59998 12.2314 8.59998 11.9V10.5395Z",
    fill: "currentColor"
  }));
},
    ti = function ti(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM9.45298 7.94043C8.86649 8.2889 8.60666 8.62269 8.59923 9.33797C8.59563 9.68549 8.31985 9.94303 7.89582 9.94303C7.49737 9.94303 7.1924 9.68549 7.1924 9.33797C7.19612 8.05414 7.54504 7.66166 8.16865 7.27285C8.62522 6.98674 8.97785 6.66762 8.97785 6.1871C8.97785 5.67724 8.57325 5.34712 8.07214 5.34712C7.58587 5.34712 7.15624 5.63856 7.11445 6.26413C7.0902 6.62714 6.78059 6.98126 6.35721 6.98126C5.93369 6.98126 5.59998 6.61104 5.59998 6.26413C5.59998 4.80823 6.73212 4.09998 8.07956 4.09998C9.55321 4.09998 10.6 4.84826 10.6 6.13208C10.6 6.99407 10.1471 7.53328 9.45298 7.94043ZM7.92373 12.4033C8.39886 12.4033 8.81089 12.0109 8.8146 11.523C8.81089 11.0425 8.39886 10.65 7.92373 10.65C7.43375 10.65 7.02915 11.0425 7.03286 11.523C7.02915 12.0109 7.43375 12.4033 7.92373 12.4033Z",
    fill: "currentColor"
  }));
};

function ni(e, t) {
  return !!t || !We[e];
}

function ri(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

    if (null != n) {
      var r,
          o,
          i = [],
          a = !0,
          s = !1;

      try {
        for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0) {
          ;
        }
      } catch (e) {
        s = !0, o = e;
      } finally {
        try {
          a || null == n["return"] || n["return"]();
        } finally {
          if (s) throw o;
        }
      }

      return i;
    }
  }(e, t) || Nr(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

var oi = "index_module_footer__8da0e7ad",
    ii = "index_module_footerTips__8da0e7ad",
    ai = "index_module_footerIcon__8da0e7ad";
Hr(".index_module_footer__8da0e7ad {\n  font-size: 11px;\n  line-height: 16px;\n  display: flex;\n}\n\n.index_module_footer__8da0e7ad a {\n  color: #466c63;\n  text-decoration: none;\n}\n\n.index_module_footer__8da0e7ad a:hover {\n  color: #466c63;\n  text-decoration: none;\n}\n\n.index_module_footer__8da0e7ad a:active {\n  color: #466c63;\n  text-decoration: none;\n}\n\n.index_module_footerTips__8da0e7ad {\n  color: rgba(44, 44, 44, 0.5);\n  word-break: break-word;\n}\n\n.index_module_footerIcon__8da0e7ad {\n  color: #35c08e;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  margin-right: 4px;\n  position: relative;\n  top: -1px;\n}\n", {});

var si = function si(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    d: "M10.8773 5.33337H10.1557C9.99882 5.33337 9.84958 5.40529 9.75727 5.52856L7.33873 8.72793L6.24331 7.27795C6.151 7.15613 6.0033 7.08275 5.84484 7.08275H5.12328C5.02327 7.08275 4.96481 7.19136 5.02327 7.26914L6.94026 9.80515C6.98554 9.86545 7.04524 9.91458 7.11441 9.94847C7.18357 9.98236 7.26021 10 7.33796 10C7.41572 10 7.49235 9.98236 7.56152 9.94847C7.63068 9.91458 7.69038 9.86545 7.73567 9.80515L10.9758 5.51976C11.0358 5.44198 10.9773 5.33337 10.8773 5.33337V5.33337Z",
    fill: "currentColor"
  }), fr("path", {
    d: "M13.25 3.46888V9.59634C13.25 10.0143 13.0411 10.4046 12.6934 10.6364L8.13867 13.6729C8.0547 13.7289 7.9453 13.7289 7.86132 13.6729L3.30662 10.6364C2.95888 10.4046 2.75 10.0143 2.75 9.59634V3.46888C2.75 3.3517 2.83138 3.25025 2.94577 3.22483L7.94577 2.11372C7.98149 2.10578 8.01851 2.10578 8.05423 2.11372L13.0542 3.22483C13.1686 3.25025 13.25 3.3517 13.25 3.46888Z",
    stroke: "currentColor",
    "stroke-width": "1.5"
  }));
};

function ci(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var ui = function (e) {
  h(n, yr);
  var t = ci(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.icon,
          n = e.theme,
          r = e.message,
          o = e.children;
      return r || o ? fr("div", {
        className: oi
      }, null === t ? null : fr("div", {
        className: ai,
        style: {
          color: null == n ? void 0 : n.iconColor
        }
      }, t || fr(si, null)), fr("div", {
        className: ii
      }, o, r && fr(wo, {
        text: r,
        theme: n
      }))) : null;
    }
  }]), n;
}();

function li(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var pi = function (e) {
  h(a, yr);
  var t,
      n,
      o = li(a);

  function a() {
    return r(this, a), o.apply(this, arguments);
  }

  return i(a, [{
    key: "componentDidMount",
    value: function value() {
      this.getNeedHandleI18n();
    }
  }, {
    key: "getNeedHandleI18n",
    value: (n = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              "text" in this.props ? this.setState({
                needHandleI18n: !1
              }) : "i18n" in this.props && (this.setState({
                needHandleI18n: !0
              }), this.getI18nText());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "getI18nText",
    value: (t = c(l.mark(function e() {
      var t, n, r, o, i, a, s;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.props, n = t.i18n, r = t.footerKey, e.next = 3, n.get(["content.creditCard.serviceTips", r]);

            case 3:
              o = e.sent, i = ri(o, 2), a = i[0], s = i[1], this.setState({
                i18nText: {
                  serviceTips: a,
                  footerTips: s
                }
              });

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.theme,
          n = void 0 === t ? {} : t,
          r = e.text,
          o = void 0 === r ? {} : r,
          i = this.state,
          a = i.needHandleI18n,
          s = i.i18nText,
          c = a ? void 0 === s ? {} : s : o,
          u = c.serviceTips,
          l = c.footerTips;
      return fr(ui, {
        theme: {
          iconColor: n.iconColor
        }
      }, u && fr(wo, {
        text: u,
        theme: n
      }), l && fr(wo, {
        text: l,
        theme: n
      }));
    }
  }]), a;
}();

function di(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function fi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? di(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : di(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function hi(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var vi = function (e) {
  h(o, yr);
  var t,
      n = hi(o);

  function o(e) {
    var t, i;
    return r(this, o), _a2(d(t = n.call(this, e)), "pciInstance", void 0), _a2(d(t), "pciContainerRef", void 0), _a2(d(t), "pciInstanceBus", void 0), _a2(d(t), "textHandler", void 0), _a2(d(t), "inputRefs", void 0), _a2(d(t), "envConfig", void 0), _a2(d(t), "cardBinHandler", {
      getCardBinVerificationParams: function getCardBinVerificationParams() {
        return {
          cardBinSwitch: t.props.enableCardBinVerification,
          cardBinRequestParams: t.props.cardBinVerificationParams,
          supportCardBrands: t.props.supportCardBrands
        };
      },
      getErrorMessage: (i = c(l.mark(function e(n) {
        var r;
        return l.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if ("number" != typeof n && "string" != typeof n) {
                  e.next = 4;
                  break;
                }

                return e.next = 3, t.textHandler.i18nGetter("validator.".concat(n));

              case 3:
                r = e.sent;

              case 4:
                if (!r) {
                  e.next = 8;
                  break;
                }

                return e.abrupt("return", r);

              case 8:
                return e.abrupt("return", t.textHandler.i18nGetter("cardIsNotSupported"));

              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e);
      })), function (e) {
        return i.apply(this, arguments);
      })
    }), _a2(d(t), "state", Object.freeze({
      cardBinError: null,
      isLoaded: !1
    })), _a2(d(t), "validate", c(l.mark(function e() {
      var n, r, o;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t.state.isLoaded) {
                e.next = 3;
                break;
              }

              return console.error("Warning: Can't call validate() if CreditCardForm is not loaded"), e.abrupt("return");

            case 3:
              if (n = t.props.validateFields, r = !0, o = [], n ? Object.keys(t.inputRefs).forEach(function (e) {
                -1 !== Ao(t.props.validateFields, e) && o.push(e);
              }) : o.push.apply(o, Ar(Object.keys(t.inputRefs))), o.forEach(function (e) {
                var n;
                ("firstName" !== e || ni(t.props.channelId, t.props.isBindCard)) && (r = (null === (n = t.inputRefs[e].current) || void 0 === n ? void 0 : n.validate()) && r);
              }), !r) {
                e.next = 10;
                break;
              }

              return e.abrupt("return", t.pciInstance.validate(n));

            case 10:
              return e.abrupt("return", !1);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), _a2(d(t), "getCurrentCardInfo", c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", t.pciInstance.getCurrentCardInfo());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), t.envConfig = Ze(e.env), t.pciInstance = t.props.pciInstance, t.pciInstanceBus = Wo(t.pciInstance), t.pciContainerRef = {
      current: null
    }, t.textHandler = new qo(t.props.i18nResolver(t.props.language, {
      env: t.envConfig.slI18nEnv
    }), {
      channelId: t.props.channelId,
      footerI18nKey: t.props.footerI18nKey
    }), t.inputRefs = {
      number: {
        current: null
      },
      firstName: {
        current: null
      },
      expDate: {
        current: null
      },
      cvc: {
        current: null
      }
    }, t;
  }

  return i(o, [{
    key: "mountPciInstance",
    value: function value() {
      var e = this,
          t = this.pciInstanceBus.form,
          n = t.getPciInstanceCreateConfig,
          r = t.emitEvent,
          o = t.setInitialed,
          i = n();
      this.pciInstance.create({
        placeholder: i.placeholder,
        extraConfig: fi(fi({}, i.extraConfig), this.cardBinHandler.getCardBinVerificationParams()),
        onInit: function onInit() {
          var t;
          o(), r("init"), "function" == typeof (null === (t = e.props) || void 0 === t ? void 0 : t.onLoad) && e.props.onLoad();
        },
        onFocus: function onFocus(e) {
          return r("focus", e);
        },
        onFieldValidChange: function onFieldValidChange(e) {
          return r("fieldValidChange", e);
        },
        onBrandChange: function onBrandChange(e) {
          return r("brandChange", e);
        },
        onCardBinValueChange: function onCardBinValueChange(e) {
          return r("cardBinValueChange", e);
        },
        onCardBinChange: function onCardBinChange(e) {
          r("cardBinChange", e);
        }
      }), this.pciInstance.mount(this.pciContainerRef.current.base);
    }
  }, {
    key: "setFieldError",
    value: function value(e, t) {
      var n;
      this.state.isLoaded ? null === (n = this.inputRefs[e]) || void 0 === n || n.current.setError(t) : console.error("Warning: Can't call setFieldError() if CreditCardForm is not loaded!");
    }
  }, {
    key: "componentDidMount",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.mountPciInstance(), e.next = 3, this.textHandler.ready();

            case 3:
              this.setState({
                isLoaded: !0
              });

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.pciInstanceBus.form.destroyBus();
    }
  }, {
    key: "render",
    value: function value() {
      var e,
          t,
          n,
          r,
          o = this.textHandler.getText,
          i = null !== (e = this.props.theme) && void 0 !== e ? e : {},
          a = {
        pciInstanceBusInput: this.pciInstanceBus.input,
        theme: i,
        i18nGetText: o.bind(this.textHandler),
        env: this.props.env
      },
          s = {
        fontColor: i.footerFontColor,
        linkColor: i.footerLinkColor
      };
      return fr(Jo, {
        ref: this.pciContainerRef,
        needAdaptive: this.props.needAdaptive,
        theme: i,
        isLoaded: this.state.isLoaded,
        inputCardNumber: fr(No, fi(fi({
          name: "number",
          label: o("formItems.number.labelTitle")
        }, a), {}, {
          ref: this.inputRefs.number,
          tips: {
            icon: null !== (t = i.cardNumberIcon) && void 0 !== t ? t : fr(ei, null),
            text: o("formItems.number.tips")
          }
        })),
        inputFirstName: ni(this.props.channelId, this.props.isBindCard) && fr(No, fi(fi({
          name: "firstName",
          label: o("formItems.firstName.labelTitle"),
          help: o("pleaseEnterNameOnCardOrBusinessName")
        }, a), {}, {
          ref: this.inputRefs.firstName,
          tips: {
            icon: null !== (n = i.holderNameIcon) && void 0 !== n ? n : fr(ti, null),
            text: o("formItems.firstName.tips")
          }
        })),
        inputExpDate: fr(No, fi(fi({
          name: "expDate",
          label: o("formItems.expDate.labelTitle")
        }, a), {}, {
          ref: this.inputRefs.expDate
        })),
        inputCvc: fr(No, fi(fi({
          name: "cvc",
          label: o("formItems.cvc.labelTitle")
        }, a), {}, {
          ref: this.inputRefs.cvc,
          tips: {
            icon: null !== (r = i.securityCodeIcon) && void 0 !== r ? r : fr(ti, null),
            text: o("formItems.cvc.tips")
          }
        })),
        footer: null === this.props.footer ? null : fr(pi, {
          theme: fi({
            iconColor: i.footerIconColor
          }, s),
          text: {
            serviceTips: o("content.creditCard.serviceTips"),
            footerTips: o(this.props.footerI18nKey)
          }
        })
      });
    }
  }]), o;
}();

_a2(vi, "defaultProps", Object.freeze({
  i18nResolver: function i18nResolver(e, t) {
    var n = t.env,
        r = new Jn(e, {
      env: n
    });
    return function () {
      var e = c(l.mark(function e(t) {
        var n, o;
        return l.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.next = 2, r.get(t);

              case 2:
                if (n = e.sent, "string" != typeof t) {
                  e.next = 5;
                  break;
                }

                return e.abrupt("return", n);

              case 5:
                return o = {}, t.forEach(function (e, t) {
                  o[e] = n[t];
                }), e.abrupt("return", o);

              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }();
  },
  supportCardBrands: [],
  env: je.Prod,
  isBindCard: !1
}));

var yi = function () {
  function e() {
    r(this, e), _a2(this, "rendered", !1), _a2(this, "destroyed", !1), _a2(this, "customContainer", void 0), _a2(this, "targetElement", void 0);
  }

  var t;
  return i(e, [{
    key: "createContainerElement",
    value: function value() {
      return document.createElement("div");
    }
  }, {
    key: "renderContainer",
    value: function value(e) {
      Br(this.component, e);
    }
  }, {
    key: "render",
    value: (t = c(l.mark(function e(t) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              this.checkDestroyed(), this.checkRendered(), this.customContainer = this.getContainerElement(), this.targetElement = "string" == typeof t ? document.querySelector(t) : t, null === this.customContainer ? this.renderContainer(this.targetElement) : (this.renderContainer(this.customContainer), this.targetElement.appendChild(this.customContainer)), this.rendered = !0;

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.checkDestroyed(), this.customContainer ? (Br(null, this.customContainer), Ee(this.customContainer)) : Br(null, this.targetElement), this.component = null, this.destroyed = !0;
    }
  }, {
    key: "getContainerElement",
    value: function value() {
      return void 0 === this.customContainer ? this.createContainerElement() : this.customContainer;
    }
  }, {
    key: "checkDestroyed",
    value: function value() {
      if (this.destroyed) throw new Error("Widget already destroyed!");
    }
  }, {
    key: "checkRendered",
    value: function value() {
      if (this.rendered) throw new Error("Widget already rendered!");
    }
  }, {
    key: "checkNotRendered",
    value: function value() {
      if (!this.rendered) throw new Error("Call render() method first!");
    }
  }]), e;
}();

function mi(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function gi(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var _i = function (e) {
  h(s, yi);
  var t,
      n,
      o = gi(s);

  function s(e) {
    var t;
    return r(this, s), _a2(d(t = o.call(this)), "componentRef", {
      current: null
    }), _a2(d(t), "component", null), _a2(d(t), "setFieldError", function (e, n) {
      var r;
      return null === (r = t.componentRef) || void 0 === r ? void 0 : r.current.setFieldError(e, n);
    }), t.component = fr(vi, function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? mi(Object(n), !0).forEach(function (t) {
          _a2(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mi(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({
      ref: t.componentRef
    }, e)), t;
  }

  return i(s, [{
    key: "validate",
    value: (n = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.componentRef.current.validate());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.componentRef.current.getCurrentCardInfo());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), s;
}();

function bi(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function wi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? bi(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bi(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Ci = function () {
  function e(t, n, o) {
    var i,
        s,
        c = this;
    r(this, e), _a2(this, "env", void 0), _a2(this, "paymentMethod", void 0), _a2(this, "channelId", void 0), _a2(this, "paymentInitData", void 0), _a2(this, "reporter", void 0), _a2(this, "pciInstance", void 0), _a2(this, "i18n", void 0), _a2(this, "memoryResolve", void 0), _a2(this, "creditCardForm", void 0), this.env = t, this.paymentInitData = n, this.pciInstance = new hn({
      host: n.host
    }), this.i18n = new Jn(n.language, {
      env: t.slI18nEnv
    }), this.creditCardForm = new _i({
      pciInstance: this.pciInstance,
      channelId: n.channelId,
      theme: zn(n.theme),
      needAdaptive: n.needAdaptive,
      enableCardBinVerification: Boolean(o.cardBinSwitch),
      footerI18nKey: null === (i = o.paymentMethodInfo) || void 0 === i || null === (s = i.cashierNotice) || void 0 === s ? void 0 : s.footerI18nKey,
      language: n.language,
      supportCardBrands: o.brands,
      env: t.env,
      isBindCard: n.isBindCard,
      cardBinVerificationParams: {
        merchantId: n.merchantId,
        paymentMethod: n.paymentMethod,
        currency: n.currency,
        amount: n.amount
      },
      onLoad: function onLoad() {
        console.log("加载 pci 完成"), c.memoryResolve(!0);
      }
    }), this.paymentMethod = n.paymentMethod, this.channelId = n.channelId, this.reporter = new ve(n);
  }

  var t, n, o, s, u, p;
  return i(e, [{
    key: "render",
    value: (p = c(l.mark(function e(t) {
      var n = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.creditCardForm.render(t)["catch"](function (e) {
                return n.reporter.handleError(e, "pci_render_error");
              });

            case 2:
              return e.abrupt("return", new Promise(function (e) {
                n.memoryResolve = e;
              }));

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return p.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (u = c(l.mark(function e() {
      var t = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.creditCardForm.validate()["catch"](function (e) {
                return t.reporter.handleError(e, "pci_validate_error");
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (s = c(l.mark(function e(t, n) {
      var r,
          o,
          i,
          a,
          s,
          u = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, this.beforePay()["catch"](this.reporter.handleError);

            case 3:
              if (r = e.sent, o = null == n ? void 0 : n.hooks, e.t0 = null == o ? void 0 : o.beforeConfirm, !e.t0) {
                e.next = 9;
                break;
              }

              return e.next = 9, o.beforeConfirm()["catch"](this.reporter.handleError);

            case 9:
              if (i = An(this.channelId, r), null == o || !o.extendConfirmParams) {
                e.next = 15;
                break;
              }

              return e.next = 13, o.extendConfirmParams()["catch"](this.reporter.handleError);

            case 13:
              (a = e.sent) && P(a) && (i = Pn(a, i));

            case 15:
              return e.next = 17, this.pciInstance.pay(t, wi({
                paymentMethod: this.paymentMethod
              }, i))["catch"](function () {
                var e = c(l.mark(function e(n) {
                  var r, o;
                  return l.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (400 !== n.statusCode) {
                            e.next = 5;
                            break;
                          }

                          return e.next = 3, er(null === (r = n.data) || void 0 === r ? void 0 : r.code, u.i18n);

                        case 3:
                          (o = e.sent) && u.creditCardForm.setFieldError(o.field, o.message);

                        case 5:
                          return e.abrupt("return", u.reporter.handleError(n, "pci_pay_error", {
                            request: {
                              params: {
                                nextAction: t,
                                extraParams: i
                              }
                            },
                            response: {
                              error: n
                            }
                          }));

                        case 6:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));
                return function (t) {
                  return e.apply(this, arguments);
                };
              }());

            case 17:
              if (s = e.sent, e.t1 = null == o ? void 0 : o.afterConfirm, !e.t1) {
                e.next = 22;
                break;
              }

              return e.next = 22, o.afterConfirm()["catch"](this.reporter.handleError);

            case 22:
              return e.abrupt("return", jn(s, n));

            case 25:
              e.prev = 25, e.t2 = e["catch"](0), this.reporter.handleError(e.t2);

            case 28:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 25]]);
    })), function (e, t) {
      return s.apply(this, arguments);
    })
  }, {
    key: "beforePay",
    value: (o = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.channelId !== He.WorldPay) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", this.worldpayBeforePay());

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "worldpayBeforePay",
    value: (n = c(l.mark(function e() {
      var t,
          n,
          r,
          o,
          i,
          a,
          s,
          c,
          u,
          p,
          d,
          f,
          h = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.paymentInitData, n = t.merchantId, r = t.paymentMethod, o = t.channelId, i = {
                merchantId: n,
                paymentMethod: r,
                channelId: o
              }, a = "".concat(this.env.host, "/v1/api/cashier/channel/info"), e.next = 5, we.post(a, i)["catch"](function (e) {
                return h.reporter.handleError(e, "cashier_channel_info_error", {
                  url: a,
                  request: {
                    params: i
                  },
                  response: {
                    error: e
                  }
                });
              });

            case 5:
              if (s = e.sent, c = (null == s ? void 0 : s.data) || {}, (u = c.type) !== ze.Confirm) {
                e.next = 12;
                break;
              }

              return e.abrupt("return", c);

            case 12:
              if (u !== ze.WorldPayGather) {
                e.next = 19;
                break;
              }

              return e.next = 15, this.pciInstance.getBeforePayData(c)["catch"](function (e) {
                h.reporter.handleError(e, "cashier_pci_ddc_error", {
                  response: {
                    error: e
                  }
                });
              });

            case 15:
              return p = e.sent, e.abrupt("return", wi(wi({}, p), {}, {
                type: u
              }));

            case 19:
              throw d = "'NextAction' type not support: ".concat(u), (f = new R(d, v.InnerSDKError, "NextActionTypeNotSupport")).data = {
                code: v.InnerSDKError,
                msg: d
              }, f;

            case 23:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.creditCardForm.destroy();
    }
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.pciInstance.getCurrentCardInfo());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

function xi(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ki(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? xi(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xi(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Oi,
    Pi = function () {
  function e(t, n) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "containerElement", void 0), _a2(this, "pciUiInstance", void 0), _a2(this, "reporter", void 0), this.env = t, this.initData = n, this.reporter = new ve(n);
  }

  var t, n, o, s, u;
  return i(e, [{
    key: "needRenderWidget",
    value: (u = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (s = c(l.mark(function e(t, n) {
      var r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(!t && !this.containerElement || t && this.containerElement)) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return this.containerElement = t, this.pciUiInstance = new Ci(this.env, ki({}, this.initData), n), e.next = 6, this.pciUiInstance.render(t)["catch"](function (e) {
                return r.reporter.handleError(e, "pci_render_error");
              });

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return s.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (o = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.pciUiInstance.validate());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.pciUiInstance.pay(t, n));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.pciUiInstance && (this.pciUiInstance.destroy(), this.pciUiInstance = null);
    }
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.pciUiInstance.getCurrentCardInfo());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

!function (e) {
  e[e.PAYOFF = 0] = "PAYOFF", e[e.ONE = 1] = "ONE", e[e.MULTIPLE = 2] = "MULTIPLE";
}(Oi || (Oi = {}));
var Ii = {
  AED: "د.إ(*)",
  AUD: "A$(*)",
  CNY: "CN¥(*)",
  EUR: "€(*)",
  GBP: "£(*)",
  HKD: "HK$(*)",
  JPY: "JP¥(*)",
  MYR: "RM(*)",
  SGD: "S$(*)",
  THB: "฿(*)",
  TWD: "NT$(*)",
  USD: "US$(*)",
  VND: "(*) ₫"
};

var Ei = function Ei(e) {
  var t;
  return 1 === (null == e ? void 0 : e.length) && "0" === (null == e || null === (t = e[0]) || void 0 === t ? void 0 : t.count) ? Oi.PAYOFF : 1 === (null == e ? void 0 : e.length) ? Oi.ONE : Oi.MULTIPLE;
},
    Ri = function Ri(e, t) {
  var n = e.count,
      r = e.installDownpay,
      o = e.installpay,
      i = "0" === n ? r : o;
  return {
    money: i = function (e, t) {
      var n = t,
          r = Ii[e];
      return r ? r.replace("(*)", n) : "".concat(e).concat(n);
    }(t, i),
    count: n
  };
};

function Di(e, t) {
  return Si.apply(this, arguments);
}

function Si() {
  return (Si = c(l.mark(function e(t, n) {
    var r, o, i, a, s, c, u, p, d, f, h, v;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, t.get(["installmentCount", "installmentDesc1", "installmentDesc2", "installmentDesc3", "installmentSelect", "installmentDiff", "installmentSelectParm", "installmentSupportContentTip", "installmentSupportTip", null == n ? void 0 : n.installmentBankListI18nKey]);

          case 2:
            return r = e.sent, o = ri(r, 10), i = o[0], a = o[1], s = o[2], c = o[3], u = o[4], p = o[5], d = o[6], f = o[7], h = o[8], v = o[9], e.abrupt("return", {
              installmentCount: i,
              installmentDesc1: a,
              installmentDesc2: s,
              installmentDesc3: c,
              installmentSelect: u,
              installmentDiff: p,
              installmentSelectParm: d,
              installmentSupportContentTip: f,
              installmentSupportTip: h,
              installmentBank: v
            });

          case 15:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

function ji(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".index_module_simpleContainer__4a7b4598 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.index_module_simpleContainer__4a7b4598 .index_module_simpleImg__4a7b4598 {\n  width: 200px;\n  height: auto;\n  max-width: 100%;\n}\n\n.index_module_simpleContainer__4a7b4598 .index_module_simpleImg__4a7b4598 + .index_module_simpleDescription__4a7b4598 {\n  margin-top: 24px;\n}\n\n.index_module_simpleContainer__4a7b4598 .index_module_simpleDescription__4a7b4598 {\n  width: 100%;\n  text-align: center;\n  font-size: 12px;\n  line-height: 18px;\n  word-break: break-word;\n  color: rgba(44, 44, 44, 0.5);\n}\n", {});

var Li = Vr.bind({
  simpleContainer: "index_module_simpleContainer__4a7b4598",
  simpleImg: "index_module_simpleImg__4a7b4598",
  simpleDescription: "index_module_simpleDescription__4a7b4598"
}),
    Bi = function (e) {
  h(n, yr);
  var t = ji(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.imgUrl,
          n = e.description,
          r = e.theme;
      return fr("div", {
        className: Li({
          simpleContainer: !0
        })
      }, t && fr("img", {
        src: t,
        className: Li({
          simpleImg: !0
        })
      }), n && fr("div", {
        className: Li({
          simpleDescription: !0
        })
      }, fr(wo, {
        text: n,
        theme: r
      })));
    }
  }]), n;
}();

function Ti(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Ni(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var Ai = function (e) {
  h(n, yi);
  var t = Ni(n);

  function n(e) {
    var o;
    return r(this, n), _a2(d(o = t.call(this)), "component", null), o.component = fr(Bi, function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ti(Object(n), !0).forEach(function (t) {
          _a2(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ti(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({}, e)), o;
  }

  return n;
}(),
    Mi = function () {
  function e(t, n, o) {
    r(this, e), _a2(this, "initData", void 0), _a2(this, "paymentMethodInfo", void 0), _a2(this, "simpleUIComponent", void 0), _a2(this, "i18n", void 0), this.initData = n, this.paymentMethodInfo = o, this.i18n = t;
  }

  var t, n;
  return i(e, [{
    key: "render",
    value: (n = c(l.mark(function e(t) {
      var n, r, o, i;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = this.paymentMethodInfo || {}, o = r.image, i = r.cashierNotice, o || null != i && i.guideI18nKey) {
                e.next = 3;
                break;
              }

              return e.abrupt("return");

            case 3:
              return e.t0 = Ai, e.t1 = o, e.next = 7, this.i18n.get("".concat(null == i ? void 0 : i.guideI18nKey));

            case 7:
              return e.t2 = e.sent, e.t3 = null === (n = this.initData.theme) || void 0 === n ? void 0 : n.simple, e.t4 = {
                imgUrl: e.t1,
                description: e.t2,
                theme: e.t3
              }, this.simpleUIComponent = new e.t0(e.t4), e.next = 13, this.simpleUIComponent.render(t);

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return n.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: function value() {
      return !0;
    }
  }, {
    key: "pay",
    value: (t = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Dn(t, {
                payOptions: n,
                paymentMethod: this.initData.paymentMethod
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, n) {
      return t.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.simpleUIComponent && this.simpleUIComponent.destroy();
    }
  }]), e;
}(),
    Fi = function Fi(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.00005 4C8.44188 4 8.80005 4.35817 8.80005 4.8V9C8.80005 9.44183 8.44188 9.8 8.00005 9.8C7.55822 9.8 7.20005 9.44183 7.20005 9V4.8C7.20005 4.35817 7.55822 4 8.00005 4ZM7.99999 12.45C8.47998 12.45 8.89623 12.0471 8.89998 11.5463C8.89623 11.053 8.47998 10.65 7.99999 10.65C7.505 10.65 7.09625 11.053 7.1 11.5463C7.09625 12.0471 7.505 12.45 7.99999 12.45Z",
    fill: "currentColor"
  }));
},
    Hi = {
  HeaderContainer: "Header_module_HeaderContainer__7550c0c7",
  HeaderSmallContainer: "Header_module_HeaderSmallContainer__7550c0c7",
  HeaderLeftContent: "Header_module_HeaderLeftContent__7550c0c7",
  HeaderRightContent: "Header_module_HeaderRightContent__7550c0c7",
  HeaderQuesIcon: "Header_module_HeaderQuesIcon__7550c0c7",
  HeaderInfoIcon: "Header_module_HeaderInfoIcon__7550c0c7",
  supportTipContentTitle: "Header_module_supportTipContentTitle__7550c0c7",
  supportTipContentTitleSm: "Header_module_supportTipContentTitleSm__7550c0c7"
};

function Wi(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".Header_module_HeaderContainer__7550c0c7 {\n  display: flex;\n  width: 100%;\n  font-size: 14px;\n  line-height: 1;\n  color: rgba(44, 44, 44, 0.75);\n}\n\n.Header_module_HeaderSmallContainer__7550c0c7 {\n  flex-direction: column;\n}\n\n.Header_module_HeaderSmallContainer__7550c0c7 .Header_module_HeaderLeftContent__7550c0c7 {\n    margin-bottom: 5px;\n  }\n\n.Header_module_HeaderLeftContent__7550c0c7 {\n  flex: 1;\n}\n\n.Header_module_HeaderRightContent__7550c0c7 {\n  margin-right: -5px;\n}\n\n.Header_module_HeaderQuesIcon__7550c0c7 {\n  color: rgba(44, 44, 44, 0.4);\n  padding: 0 5px;\n  display: inline-flex;\n  position: relative;\n  bottom: -2px;\n}\n\n.Header_module_HeaderInfoIcon__7550c0c7 {\n  color: rgba(44, 44, 44, 0.4);\n  padding: 0 5px;\n  display: inline-flex;\n  position: relative;\n  bottom: -2px;\n}\n\n.Header_module_supportTipContentTitle__7550c0c7 {\n  width: 100%;\n  text-align: center;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #242833;\n}\n\n.Header_module_supportTipContentTitleSm__7550c0c7 {\n  width: 100%;\n  padding: 2px 0 8px;\n  text-align: center;\n  font-size: 12px;\n  line-height: 1.33;\n  color: #7a8499;\n}\n", {});

var Vi = Vr.bind(Hi),
    Ui = function (e) {
  h(n, yr);
  var t = Wi(n);

  function n(e) {
    var o;
    return r(this, n), _a2(d(o = t.call(this, e)), "installmentType", void 0), _a2(d(o), "headerRef", void 0), _a2(d(o), "state", {
      isBigSizeView: !1
    }), _a2(d(o), "handleResize", function (e) {
      var t = {
        isBigSizeView: e
      };
      o.setState(t);
    }), o.installmentType = Ei(o.props.installmentInfoList), o.headerRef = {
      current: null
    }, o;
  }

  return i(n, [{
    key: "parseHint",
    value: function value() {
      var e = this.props,
          t = e.language,
          n = e.installmentInfoList,
          r = e.currency,
          o = e.isPci,
          i = this.installmentType;
      if (i === Oi.PAYOFF) return {};
      var a = {
        leftHint: "",
        leftHintParseOption: {},
        leftTooltip: "$RT$".concat(t.installmentDesc1, "\n").concat(t.installmentDesc2, "\n").concat(t.installmentDesc3),
        rightHint: "",
        rightTooltipContent: null
      };

      if (i === Oi.ONE) {
        var s = n[0],
            c = Ri(s, r),
            u = c.count,
            l = c.money;
        a.leftHint = "$RT$".concat(t.installmentSelectParm), a.leftHintParseOption = {
          variable: {
            count: u,
            money: l
          },
          handleVariable: function handleVariable(e) {
            return "**".concat(e, "**");
          }
        };
      } else i === Oi.MULTIPLE && (a.leftHint = t.installmentSelect);

      return o && (a.rightHint = t.installmentSupportTip, a.rightTooltipContent = fr("div", null, fr("div", {
        className: Hi.supportTipContentTitle
      }, t.installmentSupportContentTip), fr("div", {
        className: Hi.supportTipContentTitleSm
      }, t.installmentDiff), fr("div", null, fr(wo, {
        text: "$RT$".concat(t.installmentBank)
      })))), a;
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.needAdaptive,
          n = e.isPci,
          r = e.theme,
          o = this.state.isBigSizeView,
          i = this.parseHint(),
          a = {
        fontColor: null == r ? void 0 : r.headerFontColor
      },
          s = this.headerRef.current ? this.headerRef.current.getBoundingClientRect() : null;
      return fr(ro, {
        triggerSize: t,
        onResize: this.handleResize
      }, fr("div", {
        className: Vi({
          HeaderContainer: !0,
          HeaderSmallContainer: !o
        }),
        ref: this.headerRef
      }, i.leftHint && fr("div", {
        className: Hi.HeaderLeftContent
      }, fr(wo, {
        text: i.leftHint,
        parseOption: i.leftHintParseOption,
        theme: a
      }), i.leftTooltip && fr(Do, {
        placement: "topRight",
        title: i.leftTooltip,
        theme: {
          width: "290px"
        },
        isAutoCenter: !o,
        containerAbsPos: s
      }, fr("span", {
        className: Hi.HeaderQuesIcon,
        style: {
          color: null == r ? void 0 : r.quesIconColor
        }
      }, fr(ti, null)))), n && i.rightHint && fr("div", {
        className: Hi.HeaderRightContent
      }, fr(wo, {
        text: i.rightHint,
        theme: a
      }), i.rightTooltipContent && fr(Do, {
        placement: "bottomLeft",
        content: i.rightTooltipContent,
        theme: {
          extend: Po.White,
          maxHeight: "228px",
          width: "375px",
          padding: "16px 20px 20px 20px"
        },
        isAutoCenter: !o,
        containerAbsPos: s
      }, fr("span", {
        className: Hi.HeaderInfoIcon,
        style: {
          color: null == r ? void 0 : r.infoIconColor
        }
      }, fr(Fi, null))))));
    }
  }]), n;
}();

_a2(Ui, "defaultProps", {
  needAdaptive: !0
});

var zi = {
  selectContainer: "index_module_selectContainer__a77e6fe9",
  selectWrap: "index_module_selectWrap__a77e6fe9",
  selectErrorMsg: "index_module_selectErrorMsg__a77e6fe9",
  selectErrorMsgShow: "index_module_selectErrorMsgShow__a77e6fe9",
  selectDropdown: "index_module_selectDropdown__a77e6fe9",
  selectDropdownOpen: "index_module_selectDropdownOpen__a77e6fe9"
};
Hr(".index_module_selectContainer__a77e6fe9 * {\n  margin: 0;\n}\n\n.index_module_selectContainer__a77e6fe9 {\n  margin: 0 auto;\n  position: relative;\n}\n\n.index_module_selectWrap__a77e6fe9 {\n  position: relative;\n  box-sizing: border-box;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.index_module_selectErrorMsg__a77e6fe9 {\n  height: 0;\n  font-size: 14px;\n  line-height: 16px;\n  overflow: hidden;\n  margin-left: 1px;\n  color: #f04949;\n  transition: all 0.2s linear;\n}\n\n.index_module_selectErrorMsg__a77e6fe9.index_module_selectErrorMsgShow__a77e6fe9 {\n    height: 19px;\n    margin-top: 6px;\n  }\n\n.index_module_selectDropdown__a77e6fe9 {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 0;\n  box-sizing: border-box;\n  z-index: 2;\n  overflow-y: scroll;\n  box-shadow: 0px 1px 3px rgba(54, 62, 81, 0.2),\n    0px 0px 16px rgba(54, 62, 81, 0.1);\n  border-radius: 6px;\n  transition: max-height 0.15s linear;\n}\n\n.index_module_selectDropdown__a77e6fe9.index_module_selectDropdownOpen__a77e6fe9 {\n  max-height: 434px;\n}\n", {});
var qi = {
  selectorWrap: "Selector_module_selectorWrap__ec2031f5",
  selectorWrapError: "Selector_module_selectorWrapError__ec2031f5",
  selectLabelWrap: "Selector_module_selectLabelWrap__ec2031f5",
  selectPlaceholder: "Selector_module_selectPlaceholder__ec2031f5",
  selectIcon: "Selector_module_selectIcon__ec2031f5",
  selectOptionImg: "Selector_module_selectOptionImg__ec2031f5"
};
Hr(".Selector_module_selectorWrap__ec2031f5 {\n  position: relative;\n  height: 46px;\n  width: 100%;\n  box-sizing: border-box;\n  border-width: 1px;\n  border-style: solid;\n  border-color: rgba(142, 142, 142, 0.3);\n  background: #fff;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n  .Selector_module_selectorWrap__ec2031f5.Selector_module_selectorWrapError__ec2031f5 {\n    border-color: #f04949;\n    box-shadow: 0 0 0 1px #f04949;\n  }\n\n.Selector_module_selectLabelWrap__ec2031f5 {\n  color: rgb(54, 61, 77);\n  align-items: center;\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 14px 16px;\n  line-height: 18px;\n  font-size: 14px;\n  box-sizing: border-box;\n  outline: none;\n  background-image: none;\n  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n  -webkit-appearance: none; /* 不应用任何特殊样式（去除input的默认样式） */\n  -webkit-tap-highlight-color: rgba(\n    255,\n    0,\n    0,\n    0\n  ); /* 删除点击输入框时高亮的蓝色 */\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  border: none;\n}\n\n.Selector_module_selectPlaceholder__ec2031f5 {\n  color: #999999;\n}\n\n.Selector_module_selectIcon__ec2031f5 {\n  position: absolute;\n  top: calc(50% - 2px);\n  transform: translateY(-50%);\n  right: 19.75px;\n  color: #1e1e1e;\n}\n\n.Selector_module_selectOptionImg__ec2031f5 {\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n}\n", {});

var Gi = function Gi(e) {
  return fr("svg", Qo({}, e, {
    width: "9",
    height: "6",
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    d: "M1.23682 1.5L4.73682 5L8.23682 1.5",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    fill: "none"
  }));
};

function Zi(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var Xi = Vr.bind(qi),
    Ki = function (e) {
  h(n, yr);
  var t = Zi(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "getDisplayOptionComponent",
    value: function value() {
      var e = this.props.displayOption;
      if (e) return fr(vr, null, e.img && fr("img", {
        src: e.img,
        className: qi.selectOptionImg
      }), e.label && fr(wo, {
        text: e.label,
        parseOption: e.labelParseOption
      }));
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.displayOption,
          n = e.placeholder,
          r = e.isError,
          o = e.theme,
          i = !t;
      return fr("div", {
        className: Xi({
          selectorWrap: !0,
          selectorWrapError: r
        }),
        style: {
          height: null == o ? void 0 : o.selectHeight,
          borderColor: r ? null == o ? void 0 : o.selectErrorBorderColor : null == o ? void 0 : o.selectBorderColor,
          borderRadius: null == o ? void 0 : o.selectBorderRadius,
          background: null == o ? void 0 : o.selectBackground,
          boxShadow: r && null != o && o.selectErrorBorderColor ? "0 0 0 1px ".concat(null == o ? void 0 : o.selectErrorBorderColor) : ""
        }
      }, fr("div", {
        className: Xi({
          selectLabelWrap: !0,
          selectPlaceholder: i
        }),
        style: {
          color: i ? null == o ? void 0 : o.selectPlaceholderFontColor : null == o ? void 0 : o.selectFontColor
        }
      }, t ? this.getDisplayOptionComponent() : n), fr("div", {
        className: qi.selectIcon,
        style: {
          color: null == o ? void 0 : o.selectIconColor
        }
      }, fr(Gi, null)));
    }
  }]), n;
}(),
    $i = {
  selectOptionWrap: "Dropdown_module_selectOptionWrap__ae23aee7",
  selectOptionDisabled: "Dropdown_module_selectOptionDisabled__ae23aee7",
  selectOptionActive: "Dropdown_module_selectOptionActive__ae23aee7",
  selectOptionContent: "Dropdown_module_selectOptionContent__ae23aee7",
  selectOptionContentColumn: "Dropdown_module_selectOptionContentColumn__ae23aee7",
  selectOptionLabel: "Dropdown_module_selectOptionLabel__ae23aee7",
  selectOptionImg: "Dropdown_module_selectOptionImg__ae23aee7",
  selectOptionDescription: "Dropdown_module_selectOptionDescription__ae23aee7"
};

function Yi(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".Dropdown_module_selectOptionWrap__ae23aee7 {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  box-sizing: border-box;\n  overflow: hidden;\n  font-size: 14px;\n  color: rgb(54, 61, 77);\n  background: #fff;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n  .Dropdown_module_selectOptionWrap__ae23aee7.Dropdown_module_selectOptionDisabled__ae23aee7 {\n    color: rgb(184, 190, 204);\n    background: rgb(247, 248, 251);\n    cursor: not-allowed;\n  }\n  .Dropdown_module_selectOptionWrap__ae23aee7.Dropdown_module_selectOptionActive__ae23aee7 {\n    color: rgb(54, 61, 77);\n    background: #fff;\n  }\n\n.Dropdown_module_selectOptionContent__ae23aee7 {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n}\n\n.Dropdown_module_selectOptionContent__ae23aee7.Dropdown_module_selectOptionContentColumn__ae23aee7 {\n    flex-direction: column;\n  }\n\n.Dropdown_module_selectOptionLabel__ae23aee7 {\n  flex: 1;\n}\n\n.Dropdown_module_selectOptionImg__ae23aee7 {\n  width: 38px;\n  height: 38px;\n  border-radius: 4px;\n  margin-right: 10px;\n}\n\n.Dropdown_module_selectOptionDescription__ae23aee7 {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  color: rgb(54, 61, 77);\n}\n", {});

var Ji = Vr.bind($i),
    Qi = function (e) {
  h(n, yr);
  var t = Yi(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "getOption",
    value: function value(e) {
      var t = this,
          n = this.props,
          r = n.theme,
          o = n.displayOption,
          i = n.isContentColumn,
          a = (null == o ? void 0 : o.value) === e.value,
          s = e.disabled,
          c = {
        color: null == r ? void 0 : r.optionsFontColor,
        background: null == r ? void 0 : r.optionsBackground
      };
      return s ? (c.color = null == r ? void 0 : r.optionsDisabledFontColor, c.background = null == r ? void 0 : r.optionsDisabledBackground) : a && (c.color = (null == r ? void 0 : r.optionsActiveFontColor) || (null == r ? void 0 : r.optionsFontColor), c.background = (null == r ? void 0 : r.optionsActiveBackground) || (null == r ? void 0 : r.optionsBackground)), fr("div", {
        className: Ji({
          selectOptionWrap: !0,
          selectOptionDisabled: s,
          selectOptionActive: a
        }),
        style: c,
        onClick: s ? void 0 : function () {
          return t.props.onSelectOption(e);
        }
      }, e.img && fr("img", {
        className: $i.selectOptionImg,
        src: e.img
      }), fr("div", {
        className: Ji({
          selectOptionContent: !0,
          selectOptionContentColumn: i
        })
      }, e.label && fr("div", {
        className: $i.selectOptionLabel
      }, fr(wo, {
        text: e.label,
        parseOption: e.labelParseOption
      })), e.description && fr("div", {
        className: $i.selectOptionDescription,
        style: {
          color: null == r ? void 0 : r.optionsDescriptionFontColor
        }
      }, e.description)));
    }
  }, {
    key: "render",
    value: function value() {
      var e = this;
      return fr("div", null, this.props.optionList.map(function (t) {
        return e.getOption(t);
      }));
    }
  }]), n;
}();

function ea(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var ta = Vr.bind(zi),
    na = function (e) {
  h(n, yr);
  var t = ea(n);

  function n() {
    var e;
    r(this, n);

    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = t.call.apply(t, [this].concat(i))), "state", {
      isShowDropdown: !1,
      isBigSizeView: !1,
      displayOption: null,
      errorMsg: ""
    }), _a2(d(e), "clickOutsideCloseDropdown", function () {
      e.hideDropdown();
    }), _a2(d(e), "handleResize", function (t) {
      e.setState({
        isBigSizeView: t
      });
    }), _a2(d(e), "toggleDropdown", function () {
      e.setState({
        isShowDropdown: !e.state.isShowDropdown,
        errorMsg: ""
      });
    }), _a2(d(e), "hideDropdown", function () {
      e.setState({
        isShowDropdown: !1
      });
    }), _a2(d(e), "selectOption", function (t) {
      var n;
      e.hideDropdown(), (null == t ? void 0 : t.value) !== (null === (n = e.state.displayOption) || void 0 === n ? void 0 : n.value) && (e.setState({
        displayOption: t
      }), e.props.onChange(t));
    }), _a2(d(e), "showError", function (t) {
      e.setState({
        errorMsg: t
      });
    }), e;
  }

  return i(n, [{
    key: "componentDidMount",
    value: function value() {
      document.addEventListener("click", this.clickOutsideCloseDropdown), this.props.defaultOption && this.selectOption(this.props.defaultOption);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      document.removeEventListener("click", this.clickOutsideCloseDropdown);
    }
  }, {
    key: "stopBubble",
    value: function value(e) {
      e.stopPropagation();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.needAdaptive,
          r = t.placeholder,
          o = t.optionList,
          i = t.theme,
          a = this.state,
          s = a.isShowDropdown,
          c = a.isBigSizeView,
          u = a.displayOption,
          l = a.errorMsg,
          p = !!l;
      return fr(ro, {
        triggerSize: n,
        onResize: this.handleResize
      }, fr("div", {
        className: ta({
          selectContainer: !0,
          selectMobileStyle: !c,
          selectPcStyle: c
        }),
        onClick: function onClick(t) {
          return e.stopBubble(t);
        }
      }, fr("div", {
        className: zi.selectWrap,
        onClick: function onClick() {
          return e.toggleDropdown();
        }
      }, fr(Ki, {
        displayOption: u,
        placeholder: r,
        isError: p,
        theme: i
      })), fr("div", {
        className: ta({
          selectDropdown: !0,
          selectDropdownOpen: s
        })
      }, fr(Qi, {
        optionList: o,
        displayOption: u,
        onSelectOption: function onSelectOption(t) {
          return e.selectOption(t);
        },
        isContentColumn: !c,
        theme: i
      }))), fr("div", {
        className: ta({
          selectErrorMsg: !0,
          selectErrorMsgShow: p
        }),
        style: {
          color: null == i ? void 0 : i.selectErrorFontColor
        }
      }, l || ""));
    }
  }]), n;
}();

function ra(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

_a2(na, "defaultProps", {
  needAdaptive: !0
});

var oa = function (e) {
  h(n, yr);
  var t = ra(n);

  function n(e) {
    var o;
    return r(this, n), _a2(d(o = t.call(this, e)), "installmentType", void 0), _a2(d(o), "optionList", void 0), o.installmentType = Ei(o.props.installmentInfoList), o.installmentType !== Oi.PAYOFF && (o.optionList = o.getOptionList()), o;
  }

  return i(n, [{
    key: "componentDidMount",
    value: function value() {
      var e = this.props.onChange;
      this.installmentType === Oi.PAYOFF ? e({
        value: "0",
        label: "0"
      }) : this.installmentType === Oi.ONE && e(this.optionList[0]);
    }
  }, {
    key: "getOptionList",
    value: function value() {
      var e = this.props,
          t = e.installmentInfoList,
          n = e.currency,
          r = e.language;
      return t.map(function (e) {
        var t = Ri(e, n),
            o = t.count,
            i = t.money,
            a = "$RT$ ".concat(i);
        return "0" !== o && (a += " x ".concat(r.installmentCount)), {
          value: o,
          label: a.trim(),
          labelParseOption: {
            variable: {
              number: o
            }
          },
          disabled: !e.supportCount
        };
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.onChange,
          n = e.theme;
      return this.installmentType !== Oi.MULTIPLE ? null : fr(na, {
        onChange: t,
        optionList: this.optionList,
        defaultOption: this.optionList[0],
        theme: n
      });
    }
  }]), n;
}(),
    ia = "index_module_skeletonContainer__7346677b";

function aa(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".index_module_skeletonContainer__7346677b {\n  background: rgba(44, 44, 44, 0.05);\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n}\n", {});

var sa = function (e) {
  h(n, yr);
  var t = aa(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props.theme;
      return fr("div", {
        style: {
          width: null == e ? void 0 : e.width,
          height: null == e ? void 0 : e.height,
          background: null == e ? void 0 : e.background,
          borderRadius: null == e ? void 0 : e.borderRadius
        },
        className: ia
      });
    }
  }]), n;
}(),
    ca = {
  InstallmentContainer: "Layout_module_InstallmentContainer__b7c81b26",
  InstallmentHeader: "Layout_module_InstallmentHeader__b7c81b26",
  InstallmentSelect: "Layout_module_InstallmentSelect__b7c81b26",
  InstallmentContentLoading: "Layout_module_InstallmentContentLoading__b7c81b26",
  InstallmentPci: "Layout_module_InstallmentPci__b7c81b26"
};

function ua(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".Layout_module_InstallmentContainer__b7c81b26 {\n  margin: 0 auto;\n  position: relative;\n}\n\n.Layout_module_InstallmentHeader__b7c81b26 {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.Layout_module_InstallmentSelect__b7c81b26 {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.Layout_module_InstallmentContentLoading__b7c81b26 .Layout_module_InstallmentHeader__b7c81b26 {\n  height: 10px;\n}\n\n.Layout_module_InstallmentContentLoading__b7c81b26 .Layout_module_InstallmentSelect__b7c81b26 {\n  height: 48px;\n}\n\n.Layout_module_InstallmentPci__b7c81b26 {\n}\n", {});

var la = Vr.bind(ca),
    pa = function (e) {
  h(n, yr);
  var t = ua(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "getSkeleton",
    value: function value(e) {
      var t,
          n = {
        height: e,
        borderRadius: null === (t = this.props.theme) || void 0 === t ? void 0 : t.selectBorderRadius
      };
      return fr(sa, {
        theme: n
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.isLoaded,
          n = e.theme,
          r = e.header,
          o = e.select,
          i = e.pci;
      return fr("div", {
        className: la({
          InstallmentContainer: !0,
          InstallmentContentLoading: !t
        })
      }, r && fr("div", {
        className: ca.InstallmentHeader,
        style: {
          marginTop: null == n ? void 0 : n.formItemGutter,
          marginBottom: null == n ? void 0 : n.formItemGutter
        }
      }, t ? r : this.getSkeleton()), o && fr("div", {
        className: ca.InstallmentSelect,
        style: {
          marginBottom: null == n ? void 0 : n.formItemGutter
        }
      }, t ? o : this.getSkeleton(null == n ? void 0 : n.selectHeight)), i && fr("div", {
        className: ca.InstallmentPci
      }, i));
    }
  }]), n;
}();

function da(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function fa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? da(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : da(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function ha(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var va = function (e) {
  h(s, yr);
  var t,
      n,
      o = ha(s);

  function s() {
    var e;
    r(this, s);

    for (var t = arguments.length, n = new Array(t), i = 0; i < t; i++) {
      n[i] = arguments[i];
    }

    return _a2(d(e = o.call.apply(o, [this].concat(n))), "pciRef", {
      current: null
    }), _a2(d(e), "state", {
      isLoaded: !1,
      installmentCount: "",
      language: null
    }), _a2(d(e), "selectOption", function (t) {
      var n = !e.state.installmentCount;
      e.setState({
        installmentCount: t.value
      }, function () {
        !n && e.props.pciInstance.setCardBinOptions({
          requestParams: e.getCardBinRequestParams(),
          config: {
            shouldUpdateVerifyResult: !0
          }
        });
      });
    }), _a2(d(e), "setFieldError", function (t, n) {
      var r;
      return null === (r = e.pciRef) || void 0 === r ? void 0 : r.current.setFieldError(t, n);
    }), e;
  }

  return i(s, [{
    key: "componentDidMount",
    value: function value() {
      this.getLanguage();
    }
  }, {
    key: "getLanguage",
    value: (n = c(l.mark(function e() {
      var t, n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, Di(this.props.i18n, null === (t = this.props.initResult.paymentMethodInfo) || void 0 === t ? void 0 : t.cashierNotice);

            case 2:
              n = e.sent, this.setState({
                language: n,
                isLoaded: !0
              });

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.state.installmentCount) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", !1);

            case 2:
              return e.abrupt("return", this.pciRef.current.validate());

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "getInstallmentCount",
    value: function value() {
      return this.state.installmentCount;
    }
  }, {
    key: "getCardBinRequestParams",
    value: function value() {
      var e = this.props.initData,
          t = this.state.installmentCount;
      return {
        merchantId: e.merchantId,
        paymentMethod: e.paymentMethod,
        currency: e.currency,
        installmentCount: t,
        amount: e.amount
      };
    }
  }, {
    key: "getCreditCardForm",
    value: function value() {
      var e,
          t,
          n = this.props,
          r = n.initResult,
          o = n.initData,
          i = n.env,
          a = {
        pciInstance: n.pciInstance,
        language: o.language,
        supportCardBrands: r.brands,
        env: i.env,
        channelId: o.channelId,
        footerI18nKey: null === (e = r.paymentMethodInfo) || void 0 === e || null === (t = e.cashierNotice) || void 0 === t ? void 0 : t.footerI18nKey,
        theme: zn(o.theme),
        needAdaptive: o.needAdaptive,
        enableCardBinVerification: Boolean(r.cardBinSwitch),
        cardBinVerificationParams: this.getCardBinRequestParams(),
        isBindCard: o.isBindCard,
        onLoad: function onLoad() {
          console.log("分期加载 pci 完成");
        }
      };
      return fr(vi, fa(fa({}, a), {}, {
        ref: this.pciRef
      }));
    }
  }, {
    key: "render",
    value: function value() {
      var e,
          t = this.state,
          n = t.isLoaded,
          r = t.language,
          o = t.installmentCount,
          i = this.props,
          a = i.initData,
          s = i.initResult,
          c = a.currency,
          u = a.needAdaptive,
          l = s.installments,
          p = null === (e = a.theme) || void 0 === e ? void 0 : e.installment;
      return fr(pa, {
        isLoaded: n,
        theme: p,
        header: fr(Ui, {
          language: r,
          installmentInfoList: l,
          currency: c,
          needAdaptive: u,
          isPci: !0,
          theme: p
        }),
        select: fr(oa, {
          installmentInfoList: l,
          language: r,
          currency: c,
          onChange: this.selectOption,
          theme: p
        }),
        pci: o ? this.getCreditCardForm() : null
      });
    }
  }]), s;
}();

function ya(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ma(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ya(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ya(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function ga(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var _a = function (e) {
  h(u, yi);
  var t,
      n,
      o,
      s = ga(u);

  function u(e, t, n, o) {
    var i;
    return r(this, u), _a2(d(i = s.call(this)), "componentRef", {
      current: null
    }), _a2(d(i), "pciInstance", void 0), _a2(d(i), "reporter", void 0), _a2(d(i), "initData", void 0), _a2(d(i), "i18n", void 0), _a2(d(i), "component", null), i.initData = n, i.pciInstance = new hn({
      host: n.host
    }), i.reporter = new ve(n), i.i18n = e, i.component = fr(va, {
      ref: i.componentRef,
      env: t,
      i18n: e,
      initData: n,
      initResult: o,
      pciInstance: i.pciInstance
    }), i;
  }

  return i(u, [{
    key: "validate",
    value: (o = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.componentRef.current.validate());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      var r,
          o,
          i = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, r = An(this.initData.channelId, {}, {
                isInstallment: !0,
                installmentCount: this.componentRef.current.getInstallmentCount()
              }), e.next = 4, this.pciInstance.pay(t, ma({
                paymentMethod: this.initData.paymentMethod
              }, r))["catch"](function () {
                var e = c(l.mark(function e(n) {
                  var o, a;
                  return l.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (400 !== n.statusCode) {
                            e.next = 5;
                            break;
                          }

                          return e.next = 3, er(null === (o = n.data) || void 0 === o ? void 0 : o.code, i.i18n);

                        case 3:
                          (a = e.sent) && i.componentRef.current.setFieldError(a.field, a.message);

                        case 5:
                          return e.abrupt("return", i.reporter.handleError(n, "installment_pci_pay_error", {
                            request: {
                              params: {
                                nextAction: t,
                                extraParams: r
                              },
                              response: {
                                error: n
                              }
                            }
                          }));

                        case 6:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));
                return function (t) {
                  return e.apply(this, arguments);
                };
              }());

            case 4:
              return o = e.sent, e.abrupt("return", jn(o, n));

            case 8:
              e.prev = 8, e.t0 = e["catch"](0), this.reporter.handleError(e.t0);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 8]]);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.pciInstance.getCurrentCardInfo());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), u;
}();

function ba(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var wa = function (e) {
  h(o, yr);
  var t,
      n = ba(o);

  function o() {
    var e;
    r(this, o);

    for (var t = arguments.length, i = new Array(t), s = 0; s < t; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = n.call.apply(n, [this].concat(i))), "state", {
      isLoaded: !1,
      language: null
    }), e;
  }

  return i(o, [{
    key: "componentDidMount",
    value: function value() {
      this.getLanguage();
    }
  }, {
    key: "getLanguage",
    value: (t = c(l.mark(function e() {
      var t, n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, Di(this.props.i18n, null === (t = this.props.initResult.paymentMethodInfo) || void 0 === t ? void 0 : t.cashierNotice);

            case 2:
              n = e.sent, this.setState({
                isLoaded: !0,
                language: n
              });

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "render",
    value: function value() {
      var e,
          t = this.state,
          n = t.isLoaded,
          r = t.language,
          o = this.props,
          i = o.initData,
          a = o.onChange,
          s = o.initResult,
          c = null === (e = i.theme) || void 0 === e ? void 0 : e.installment;
      return fr(pa, {
        isLoaded: n,
        theme: c,
        header: fr(Ui, {
          language: r,
          installmentInfoList: s.installments,
          currency: i.currency,
          needAdaptive: i.needAdaptive,
          theme: c
        }),
        select: fr(oa, {
          installmentInfoList: s.installments,
          language: r,
          currency: i.currency,
          onChange: a,
          theme: c
        })
      });
    }
  }]), o;
}();

function Ca(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var xa = function (e) {
  h(s, yi);
  var t,
      n,
      o = Ca(s);

  function s(e, t, n) {
    var i;
    return r(this, s), _a2(d(i = o.call(this)), "componentRef", {
      current: null
    }), _a2(d(i), "component", null), _a2(d(i), "initData", void 0), _a2(d(i), "installmentCount", void 0), i.initData = t, i.component = fr(wa, {
      ref: i.componentRef,
      i18n: e,
      initData: t,
      initResult: n,
      onChange: function onChange(e) {
        return i.installmentCount = e.value;
      }
    }), i;
  }

  return i(s, [{
    key: "validate",
    value: (n = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !!this.installmentCount);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (t = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Dn(t, {
                payOptions: n,
                paymentMethod: this.initData.paymentMethod,
                paymentMethodOptions: {
                  installments: {
                    count: this.installmentCount
                  }
                }
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, n) {
      return t.apply(this, arguments);
    })
  }]), s;
}(),
    ka = function () {
  function e(t, n, o) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "paymentInitData", void 0), _a2(this, "component", void 0), _a2(this, "initResult", void 0), _a2(this, "installmentType", void 0), _a2(this, "paymentMethod", void 0), _a2(this, "isCreditCard", void 0), this.env = t, this.paymentInitData = n, this.initResult = o, this.paymentMethod = this.paymentInitData.paymentMethod, this.isCreditCard = this.paymentMethod === Fe.CreditCard, this.installmentType = Ei(this.initResult.installments);
  }

  var t, n, o, s;
  return i(e, [{
    key: "render",
    value: (s = c(l.mark(function e(t) {
      var n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n = new Jn(this.paymentInitData.language, {
                env: this.env.slI18nEnv
              }), this.isCreditCard ? this.component = new _a(n, this.env, this.paymentInitData, this.initResult) : this.installmentType === Oi.PAYOFF ? this.component = new Mi(n, this.paymentInitData, this.initResult.paymentMethodInfo) : this.component = new xa(n, this.paymentInitData, this.initResult), e.next = 4, this.component.render(t);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return s.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (o = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.component.validate());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.component.pay(t, n));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.component && (this.component.destroy(), this.component = null);
    }
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.isCreditCard) {
                e.next = 2;
                break;
              }

              throw new R("The API does not support the payment method", v.InnerSDKError, "NotSupportApi");

            case 2:
              return e.abrupt("return", this.component.getCurrentCardInfo());

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}(),
    Oa = function () {
  function e(t, n) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "containerElement", void 0), _a2(this, "installmentUI", void 0), _a2(this, "reporter", void 0), this.env = t, this.initData = n, this.reporter = new ve(n);
  }

  var t, n, o, s, u;
  return i(e, [{
    key: "needRenderWidget",
    value: (u = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (s = c(l.mark(function e(t, n) {
      var r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(!t && !this.containerElement || t && this.containerElement)) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return this.containerElement = t, this.installmentUI = new ka(this.env, this.initData, n), e.next = 6, this.installmentUI.render(t)["catch"](function (e) {
                return r.reporter.handleError(e, "installment_pci_render_error");
              });

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return s.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (o = c(l.mark(function e() {
      var t = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.installmentUI.validate()["catch"](function (e) {
                return t.reporter.handleError(e, "installment_pci_validate_error");
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      var r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.installmentUI.pay(t, n)["catch"](function (e) {
                return r.reporter.handleError(e, "installment_pci_validate_error");
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.installmentUI && (this.installmentUI.destroy(), this.installmentUI = null);
    }
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      var t = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.installmentUI.getCurrentCardInfo()["catch"](function (e) {
                return t.reporter.handleError(e, "installment_pci_getCurrentCardInfo_error");
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

function Pa(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Ia(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var Ea = function (e) {
  h(n, yi);
  var t = Ia(n);

  function n(e) {
    var o;
    return r(this, n), _a2(d(o = t.call(this)), "component", null), o.component = fr(Bi, function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Pa(Object(n), !0).forEach(function (t) {
          _a2(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pa(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({}, e)), o;
  }

  return n;
}(),
    Ra = function () {
  function e(t, n, o) {
    var i = this;
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "paymentMethodInfo", void 0), _a2(this, "simpleComponent", void 0), _a2(this, "getI18n", c(l.mark(function e() {
      var t;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = i.initData.language, e.abrupt("return", new Jn(t, {
                env: i.env.slI18nEnv
              }));

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))), this.env = t, this.initData = n, this.paymentMethodInfo = o;
  }

  var t;
  return i(e, [{
    key: "render",
    value: (t = c(l.mark(function e(t) {
      var n, r, o, i, a;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.getI18n();

            case 2:
              if (r = e.sent, o = this.paymentMethodInfo || {}, i = o.image, a = o.cashierNotice, i || null != a && a.guideI18nKey) {
                e.next = 6;
                break;
              }

              return e.abrupt("return");

            case 6:
              return e.t0 = Ea, e.t1 = i, e.next = 10, r.get("".concat(null == a ? void 0 : a.guideI18nKey));

            case 10:
              return e.t2 = e.sent, e.t3 = null === (n = this.initData.theme) || void 0 === n ? void 0 : n.simple, e.t4 = {
                imgUrl: e.t1,
                description: e.t2,
                theme: e.t3
              }, this.simpleComponent = new e.t0(e.t4), e.next = 16, this.simpleComponent.render(t);

            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.simpleComponent && this.simpleComponent.destroy();
    }
  }]), e;
}(),
    Da = {};

function Sa(e) {
  return new Promise(function (t, n) {
    var r = document.createElement("script");
    r.type = "text/javascript", r.src = e, r.onload = r.onreadystatechange = function () {
      this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (Da[e] || (Da[e] = Promise.resolve()), t(), r.onload = r.onreadystatechange = null);
    }, r.onerror = function (t) {
      Da[e] && (Da[e] = void 0), n(t);
    }, (document.head || document.body).appendChild(r);
  });
}

function ja(e) {
  return !!e;
}

function La(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Sa;
  if (e && Da[e]) return Da[e];
  var r = yn(n, ja, t)(e);
  return Da[e] = r, r;
}

function Ba() {
  return Ta.apply(this, arguments);
}

function Ta() {
  return (Ta = c(l.mark(function e() {
    var t, n;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return t = 4, e.next = 3, La("https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js", {
              maxCount: 3,
              interval: 100
            })["catch"](function (e) {
              throw he.reportError(e, "load_apple_js_error"), new Error("LoadChannelJsFail");
            });

          case 3:
            if ((n = window.ApplePaySession) && n.canMakePayments() && n.supportsVersion(t)) {
              e.next = 6;
              break;
            }

            throw new Error("DeviceNotSupportPaymentMethod");

          case 6:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

function Na() {
  return Aa.apply(this, arguments);
}

function Aa() {
  return (Aa = c(l.mark(function e() {
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.prev = 0, e.next = 3, Ba();

          case 3:
            return e.abrupt("return", !0);

          case 6:
            return e.prev = 6, e.t0 = e["catch"](0), he.reportData("isSupportApplePay_error", {
              error: e.t0,
              errorMessage: e.t0.message
            }), e.abrupt("return", !1);

          case 10:
          case "end":
            return e.stop();
        }
      }
    }, e, null, [[0, 6]]);
  }))).apply(this, arguments);
}

function Ma() {
  return !/(micromessenger)/.test(navigator.userAgent.toLocaleLowerCase());
}

var Fa = function () {
  function e(t, n) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "containerElement", void 0), _a2(this, "simpleRender", void 0), this.env = t, this.initData = n;
  }

  var t, n, o, s, u;
  return i(e, [{
    key: "validate",
    value: (u = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "beforeRender",
    value: (s = c(l.mark(function e() {
      var t;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, this.initData.paymentMethod !== Fe.WeChatPay || Ma()) {
                e.next = 3;
                break;
              }

              throw new Error("not support WeChatPay");

            case 3:
              e.next = 10;
              break;

            case 5:
              throw e.prev = 5, e.t0 = e["catch"](0), (t = new R(e.t0.message)).setAPIErrorData({
                code: v.DeviceNotSupportPaymentMethod,
                msg: y.DeviceNotSupportPaymentMethod
              }), t;

            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 5]]);
    })), function () {
      return s.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (o = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t || this.containerElement) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return t && (this.containerElement = t), this.simpleRender = new Ra(this.env, this.initData, n.paymentMethodInfo), e.next = 6, this.simpleRender.render(this.containerElement);

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Dn(t, {
                payOptions: n,
                paymentMethod: this.initData.paymentMethod
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.simpleRender && (this.simpleRender.destroy(), this.simpleRender = null);
    }
  }, {
    key: "needRenderWidget",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

Hr(".payment-sdk-paypal-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.payment-sdk-paypal-container .paypal-img {\n  width: 192px;\n  height: 107px;\n  margin-bottom: 32px;\n}\n\n.payment-sdk-paypal-container .paypal-img img {\n  max-width: 100%;\n}\n\n.payment-sdk-paypal-container .paypal-tips {\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: #959595;\n}\n", {});

var Ha = function () {
  function e() {
    r(this, e), _a2(this, "container", void 0);
  }

  return i(e, [{
    key: "render",
    value: function value(e) {
      this.container = e;
      xn({
        content: "div",
        props: {
          "class": "payment-sdk-paypal-container"
        },
        children: [{
          content: "div",
          props: {
            "class": "paypal-img"
          },
          children: {
            content: "img",
            props: {
              src: "https://cdn.myshopline.com/pay/fe-prod/payment-sdk/images/guide-simple.png"
            }
          }
        }, {
          content: "div",
          props: {
            "class": "paypal-tips"
          },
          children: "After clicking “Complete order”, you will be redirected to PayPal to complete your purchase securely."
        }]
      }, e);
    }
  }]), e;
}(),
    Wa = function () {
  function e(t, n) {
    r(this, e), _a2(this, "initData", void 0), _a2(this, "containerElement", void 0), _a2(this, "paypalUiInstance", void 0), _a2(this, "reporter", void 0), this.initData = n, this.reporter = new ve(n);
  }

  var t, n, o, s;
  return i(e, [{
    key: "render",
    value: (s = c(l.mark(function e(t) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t || this.containerElement) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              t && (this.containerElement = t), this.paypalUiInstance = new Ha(), this.paypalUiInstance.render(this.containerElement);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return s.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (o = c(l.mark(function e(t, n) {
      var r;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, _n(t, {
                paymentInstrument: {
                  paymentMethod: this.initData.paymentMethod
                }
              });

            case 3:
              return r = e.sent, e.abrupt("return", jn(r, n));

            case 7:
              return e.prev = 7, e.t0 = e["catch"](0), e.abrupt("return", this.reporter.handleError(e.t0, "paypal_pay_error"));

            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 7]]);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (n = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.containerElement && (this.containerElement.innerHTML = ""), this.paypalUiInstance = null;
    }
  }, {
    key: "needRenderWidget",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}(),
    Va = function Va(e) {
  return fr("svg", Qo({}, e, {
    width: "200",
    height: "113",
    viewBox: "0 0 200 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    d: "M151 70.0171C151 67.5027 152.704 66 154.704 66C156.703 66 158.407 67.5027 158.407 70.0171C158.407 70.9936 157.942 71.9062 157.125 72.6701C156.29 73.4516 155.231 73.9322 154.406 74.0565C153.427 74.204 152.704 75.0447 152.704 76.0342V78.6658C152.704 79.7705 153.599 80.6667 154.704 80.6667C155.808 80.6667 156.704 79.7712 156.704 78.6666V77.558C157.829 77.1301 158.932 76.4571 159.857 75.5915C161.269 74.2717 162.407 72.3637 162.407 70.0171C162.407 65.3862 159.004 62 154.704 62C150.403 62 147 65.3862 147 70.0171C147 71.1217 147.895 72.0171 149 72.0171C150.105 72.0171 151 71.1217 151 70.0171Z",
    fill: "currentColor"
  }), fr("path", {
    d: "M154.5 88C155.881 88 157 86.8807 157 85.5C157 84.1193 155.881 83 154.5 83C153.119 83 152 84.1193 152 85.5C152 86.8807 153.119 88 154.5 88Z",
    fill: "currentColor"
  }), fr("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M25 13.219C25 12.1144 25.8954 11.219 27 11.219H64.022C68.8042 11.219 73.3899 13.122 76.7669 16.508L90.3001 30.0773H154.24C159.763 30.0773 164.24 34.5544 164.24 40.0773V54.2006L172.334 56.0079C173.248 56.2119 173.898 57.0229 173.898 57.9595L173.9 69.8512C173.9 72.8249 173.9 75.7995 173.9 78.0324C173.9 79.1488 173.9 80.0799 173.899 80.7328L173.899 81.6964L173.898 81.7537L173.898 81.777L173.898 81.7984L173.897 81.8294C173.896 81.8515 173.887 81.9744 173.874 82.0747C173.866 82.125 173.856 82.175 173.844 82.2246C171.338 92.7681 161.454 97.3662 157.263 98.8897C155.45 99.549 153.511 99.4864 151.773 98.8716C150.089 98.2761 148.567 97.6263 147.191 96.9382H69.4814C63.9586 96.9382 59.4814 92.4611 59.4814 86.9382V66.8548H54.4261C50.2409 66.8548 46.2278 65.1894 43.2723 62.2261C41.0674 60.0152 38.0732 58.7727 34.9508 58.7727H28.791C27.6864 58.7727 26.791 57.8773 26.791 56.7727C26.791 55.6681 27.6864 54.7727 28.791 54.7727H34.9508C39.1359 54.7727 43.1491 56.4381 46.1045 59.4014C48.3095 61.6123 51.3036 62.8548 54.4261 62.8548H59.4814V52.1721C53.7323 50.0648 49.6299 44.5436 49.6299 38.0642C49.6299 36.9596 50.5253 36.0642 51.6299 36.0642C52.7345 36.0642 53.6299 36.9596 53.6299 38.0642C53.6299 44.151 58.5642 49.0854 64.6511 49.0854H69.9975C72.4759 49.0854 74.8529 50.0697 76.6057 51.8219L82.4235 57.6377C84.0397 59.2533 86.2314 60.1609 88.5166 60.1609C91.465 60.1609 92.9414 56.5958 90.8561 54.5113L67.5836 31.2469C66.8024 30.4659 66.8022 29.1996 67.5831 28.4184C68.364 27.6372 69.6303 27.637 70.4115 28.4179L72.0714 30.0773H84.6508L73.9347 19.3327C71.3081 16.6991 67.7415 15.219 64.022 15.219H27C25.8954 15.219 25 14.3236 25 13.219ZM141.086 92.9382C139.585 91.6448 138.415 90.3244 137.505 89.0513C136.653 87.8588 136.041 86.7235 135.602 85.7129H63.4814V86.9382C63.4814 90.2519 66.1677 92.9382 69.4814 92.9382H141.086ZM134.495 81.7129C134.481 81.5365 134.48 81.3835 134.48 81.2737V71.3447H63.4814V81.7129H134.495ZM134.48 67.3447V57.96C134.48 57.0176 135.138 56.2031 136.059 56.0048L152.379 52.4923C153.791 52.1884 155.252 52.194 156.662 52.5087L160.24 53.3075V40.0773C160.24 36.7636 157.553 34.0773 154.24 34.0773H76.0728L93.6841 51.6824C98.2898 56.2866 95.029 64.1609 88.5166 64.1609C85.1707 64.1609 81.9619 62.832 79.5956 60.4666L73.7778 54.6508C72.7751 53.6485 71.4153 53.0854 69.9975 53.0854H64.6511C64.2575 53.0854 63.8674 53.0702 63.4814 53.0405V67.3447H134.48ZM169.898 59.5625L155.791 56.4126C154.945 56.2238 154.068 56.2204 153.221 56.4028L138.48 59.5754V81.2737C138.48 81.3715 138.482 81.396 138.483 81.4037C138.525 81.8111 138.835 84.0307 140.76 86.7262C142.673 89.4047 146.275 92.684 153.107 95.1005C154.053 95.4352 155.034 95.4443 155.897 95.1305C159.872 93.6852 167.813 89.7797 169.899 81.5182L169.899 80.7311C169.9 80.0789 169.9 79.1483 169.9 78.032C169.9 75.7996 169.9 72.8252 169.9 69.8515L169.898 59.5625Z",
    fill: "currentColor"
  }));
},
    Ua = "index_module_blockContainer__690ba59b",
    za = "index_module_blockImg__690ba59b",
    qa = "index_module_blockDescription__690ba59b";

function Ga(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".index_module_blockContainer__690ba59b {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.index_module_blockImg__690ba59b {\n  width: 200px;\n  height: auto;\n  max-width: 100%;\n  color: rgba(44, 44, 44, 0.5);\n}\n\n.index_module_blockImg__690ba59b + .index_module_blockDescription__690ba59b {\n  margin-top: 24px;\n}\n\n.index_module_blockDescription__690ba59b {\n  width: 100%;\n  text-align: center;\n  font-size: 12px;\n  line-height: 18px;\n  word-break: break-word;\n  color: rgba(44, 44, 44, 0.5);\n}\n", {});

var Za = function (e) {
  h(n, yr);
  var t = Ga(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.description,
          n = e.theme;
      return fr("div", {
        className: Ua
      }, fr("div", {
        className: za,
        style: {
          color: null == n ? void 0 : n.imgColor
        }
      }, fr(Va, null)), t && fr("div", {
        className: qa
      }, fr(wo, {
        text: t,
        theme: n
      })));
    }
  }]), n;
}();

function Xa(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Ka(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var $a = function (e) {
  h(n, yi);
  var t = Ka(n);

  function n(e) {
    var o;
    return r(this, n), _a2(d(o = t.call(this)), "component", null), o.component = fr(Za, function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Xa(Object(n), !0).forEach(function (t) {
          _a2(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xa(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({}, e)), o;
  }

  return n;
}(),
    Ya = function () {
  function e(t, n) {
    var o = this;
    r(this, e), _a2(this, "env", void 0), _a2(this, "theme", void 0), _a2(this, "reporter", void 0), _a2(this, "blockUI", void 0), _a2(this, "mount", function () {
      var e = c(l.mark(function e(t, n) {
        var r;
        return l.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (t) {
                  e.next = 2;
                  break;
                }

                return e.abrupt("return");

              case 2:
                return o.reporter.addReportData(n), e.next = 5, o.getText(n.language)["catch"](o.reporter.handleError);

              case 5:
                return r = e.sent, o.blockUI = new $a({
                  description: r,
                  theme: o.theme
                }), e.next = 9, o.blockUI.render(t);

              case 9:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }()), _a2(this, "getText", function () {
      var e = c(l.mark(function e(t) {
        var n;
        return l.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = new Jn(t, {
                  env: o.env.slI18nEnv
                }), e.abrupt("return", n.get("paymentMethodNotSupported"));

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), this.env = t, this.theme = n, this.reporter = new ve({});
  }

  return i(e, [{
    key: "destroy",
    value: function value() {
      this.blockUI && this.blockUI.destroy();
    }
  }]), e;
}();

function Ja() {
  var e = navigator.userAgent,
      t = -1 !== e.indexOf("MSIE"),
      n = /Windows\sNT ([0-9\.]+).*?Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/.exec(e),
      r = n ? Number(n[1]) : null,
      o = n ? Number(n[2]) : null;
  return t || !!(n && o <= 11 && r <= 7);
}

var Qa,
    es,
    ts = function () {
  function e(t, n) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "containerElement", null), _a2(this, "plugin", void 0), _a2(this, "theme", void 0), _a2(this, "reporter", void 0), _a2(this, "subScene", void 0), _a2(this, "blockRender", void 0), this.initData = n, this.env = t, this.reporter = new ve(n), this.theme = qn(n.theme), this.findPlugin(), this.reporter.reportData("plugin_init");
  }

  var t, n, o, s, u, p, d, f;
  return i(e, [{
    key: "findPlugin",
    value: function value() {
      var e = this.initData.plugins;
      if (e && Array.isArray(e)) for (var t = e.length, n = 0; n < t; n++) {
        var r = e[n],
            o = Array.isArray(r),
            i = o ? r[0] : r,
            a = o ? r[1] : void 0;

        if (!(!i.info.channelId || i.info.channelId !== this.initData.channelId || !i.info.paymentMethod || i.info.paymentMethod !== this.initData.paymentMethod) && !this.plugin) {
          if (this.plugin = new i(a), i.info.scene === Ke.PCI) {
            if (Ja()) throw this.reporter.reportData("plugin_not_support_browser"), new R(y.NotSupportBrowser, v.NotSupportBrowser, "NotSupportBrowser");
            this.subScene = new Pi(this.env, this.initData);
          }

          break;
        }
      }
    }
  }, {
    key: "applyHook",
    value: (f = c(l.mark(function e(t) {
      var n,
          r,
          o,
          i,
          a,
          s,
          c,
          u,
          p = arguments;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.plugin) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              for (e.prev = 2, this.reporter.reportData("plugin_applyHook_".concat(t, "_start")), r = p.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
                o[i - 1] = p[i];
              }

              if (!this.subScene || !this.subScene[t]) {
                e.next = 11;
                break;
              }

              return e.next = 8, (a = this.subScene)[t].apply(a, o);

            case 8:
              n = e.sent, e.next = 16;
              break;

            case 11:
              if (!this.plugin || !this.plugin[t]) {
                e.next = 16;
                break;
              }

              return c = o.map(function (e) {
                return I(e);
              }), e.next = 15, (s = this.plugin)[t].apply(s, Ar(c));

            case 15:
              n = e.sent;

            case 16:
              return this.reporter.reportData("plugin_applyHook_".concat(t, "_end")), e.abrupt("return", n);

            case 20:
              e.prev = 20, e.t0 = e["catch"](2), u = "plugin_applyHook_".concat(t, "_error"), this.reporter.reportData(u), this.reporter.handleError(e.t0, u);

            case 25:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[2, 20]]);
    })), function (e) {
      return f.apply(this, arguments);
    })
  }, {
    key: "needRenderWidget",
    value: (d = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return d.apply(this, arguments);
    })
  }, {
    key: "afterInit",
    value: (p = c(l.mark(function e(t) {
      var n, r, o, i;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.reporter.reportData("plugin_applyHook_afterInit_start"), n = this.theme, r = new Jn(this.initData.language, {
                env: this.env.slI18nEnv
              }), e.next = 5, r.getData();

            case 5:
              return o = e.sent, e.t0 = Object, e.t1 = O(this.initData, ["currency", "countryCode", "channelId", "paymentMethod", "merchantId"]), e.t2 = n, e.t3 = o.extend, e.next = 12, r.getDisplayLanguage();

            case 12:
              return e.t4 = e.sent, e.t5 = o, e.t6 = this.env.env, e.t7 = this.initData.clientId, e.t8 = {
                theme: e.t2,
                language: e.t3,
                displayLanguage: e.t4,
                languageObj: e.t5,
                env: e.t6,
                clientId: e.t7
              }, i = e.t0.assign.call(e.t0, e.t1, e.t8), e.abrupt("return", this.applyHook("afterInit", i, t.channelInfo));

            case 19:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return p.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (u = c(l.mark(function e(t, n) {
      var r,
          o,
          i = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return t && (this.containerElement = t), e.prev = 3, e.next = 6, this.applyHook("beforeRender", t);

            case 6:
              return e.next = 8, this.applyHook("render", t, n);

            case 8:
              e.next = 18;
              break;

            case 10:
              return e.prev = 10, e.t0 = e["catch"](3), o = new Ya(this.env, null === (r = this.initData.theme) || void 0 === r ? void 0 : r.block), this.blockRender = o, e.next = 16, o.mount(t, this.initData)["catch"](function (e) {
                i.reporter.handleError(e, "plugin_render_fail_error");
              });

            case 16:
              this.reporter.reportData("plugin_applyHook_render_error"), this.reporter.handleError(e.t0);

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[3, 10]]);
    })), function (e, t) {
      return u.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (s = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!this.blockRender) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", !1);

            case 2:
              return e.next = 4, this.applyHook("validate");

            case 4:
              return e.abrupt("return", e.sent);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return s.apply(this, arguments);
    })
  }, {
    key: "extendPaySession",
    value: (o = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.applyHook("extendPaySession");

            case 2:
              return e.abrupt("return", e.sent);

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      var r;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, r = this.createHooks(["beforeConfirm", "extendConfirmParams", "afterConfirm", "handlePayAction"]), n.hooks = r, !this.subScene || !this.subScene.pay) {
                e.next = 5;
                break;
              }

              return e.abrupt("return", this.subScene.pay(t, n));

            case 5:
              return e.next = 7, Dn(t, {
                payOptions: n,
                paymentMethod: this.initData.paymentMethod
              });

            case 7:
              return e.abrupt("return", e.sent);

            case 10:
              e.prev = 10, e.t0 = e["catch"](0), this.reporter.handleError(e.t0, "plugin_pay_error");

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 10]]);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "createHooks",
    value: function value(e) {
      var t = this,
          n = {};
      return e.map(function (e) {
        n[e] = function () {
          var n = c(l.mark(function n(r) {
            return l.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return n.next = 2, t.applyHook(e, r);

                  case 2:
                    return n.abrupt("return", n.sent);

                  case 3:
                  case "end":
                    return n.stop();
                }
              }
            }, n);
          }));
          return function (e) {
            return n.apply(this, arguments);
          };
        }();
      }), n;
    }
  }, {
    key: "destroy",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.containerElement) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              if (!this.blockRender) {
                e.next = 7;
                break;
              }

              this.blockRender.destroy(), this.reporter.reportData("plugin_destroy_block_fail"), e.next = 9;
              break;

            case 7:
              return e.next = 9, this.applyHook("destroy", this.containerElement);

            case 9:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }], [{
    key: "checkHasPlugin",
    value: function value(e) {
      var t = e.plugins;
      if (!t || !Array.isArray(t)) return !1;

      for (var n = t.length, r = 0; r < n; r++) {
        var o = t[r],
            i = Array.isArray(o) ? o[0] : o;
        if (!(!i.info.channelId || i.info.channelId !== e.channelId || !i.info.paymentMethod || i.info.paymentMethod !== e.paymentMethod)) return !0;
      }

      return !1;
    }
  }]), e;
}();

!function (e) {
  e[e.Maintaining = 0] = "Maintaining", e[e.Available = 1] = "Available";
}(Qa || (Qa = {})), function (e) {
  e.Success = "SUCCESS", e.Fail = "FAIL";
}(es || (es = {}));

var ns = function ns(e) {
  var t;
  t = Number(e);
  var n = (t = new Date(t)).getFullYear(),
      r = t.getMonth() + 1 >= 10 ? t.getMonth() + 1 : "0".concat(t.getMonth() + 1),
      o = t.getDate() >= 10 ? t.getDate() : "0".concat(t.getDate()),
      i = t.getHours() >= 10 ? t.getHours() : "0".concat(t.getHours()),
      a = t.getMinutes() >= 10 ? t.getMinutes() : "0".concat(t.getMinutes()),
      s = t.getSeconds() >= 10 ? t.getSeconds() : "0".concat(t.getSeconds());
  return "".concat(n, "/").concat(r, "/").concat(o, " ").concat(i, ":").concat(a, ":").concat(s);
},
    rs = {
  FPXContainer: "Layout_module_FPXContainer__deeec25b",
  FPXNextStepTip: "Layout_module_FPXNextStepTip__deeec25b",
  FPXContentLoading: "Layout_module_FPXContentLoading__deeec25b",
  FPXSelect: "Layout_module_FPXSelect__deeec25b",
  FPXFooterTip: "Layout_module_FPXFooterTip__deeec25b"
};

function os(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function is(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? os(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : os(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function as(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".Layout_module_FPXContainer__deeec25b {\n  margin: 0 auto;\n  position: relative;\n}\n\n.Layout_module_FPXNextStepTip__deeec25b {\n  font-size: 12px;\n  line-height: 18px;\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.Layout_module_FPXContentLoading__deeec25b .Layout_module_FPXSelect__deeec25b {\n  height: 48px;\n}\n\n.Layout_module_FPXContentLoading__deeec25b .Layout_module_FPXFooterTip__deeec25b {\n  height: 10px;\n}\n\n.Layout_module_FPXContentLoading__deeec25b .Layout_module_FPXNextStepTip__deeec25b {\n  height: 20px;\n}\n\n/* 骨架屏样式 结束 */\n", {});

var ss = Vr.bind(rs),
    cs = function (e) {
  h(n, yr);
  var t = as(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "getSkeleton",
    value: function value(e) {
      var t;
      return fr(sa, {
        theme: is(is({}, (null === (t = this.props.theme) || void 0 === t ? void 0 : t.skeleton) || {}), {}, {
          height: e
        })
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.isLoaded,
          n = e.theme,
          r = e.select,
          o = e.hint,
          i = e.footer;
      return fr("div", {
        className: ss({
          FPXContainer: !0,
          FPXContentLoading: !t
        })
      }, fr("div", {
        className: rs.FPXSelect
      }, t ? r : this.getSkeleton(null == n ? void 0 : n.selectHeight)), fr("div", {
        className: rs.FPXNextStepTip,
        style: {
          marginTop: null == n ? void 0 : n.itemGutter,
          marginBottom: null == n ? void 0 : n.itemGutter
        }
      }, t ? o : this.getSkeleton()), fr("div", {
        className: rs.FPXFooterTip
      }, t ? i : this.getSkeleton()));
    }
  }]), n;
}();

function us(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ls(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? us(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : us(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function ps(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var ds = function (e) {
  h(o, yr);
  var t,
      n = ps(o);

  function o(e) {
    var t;
    return r(this, o), _a2(d(t = n.call(this, e)), "selectRef", void 0), _a2(d(t), "state", {
      isLoaded: !1,
      errorMsg: "",
      displayOption: null,
      optionList: null,
      language: null
    }), _a2(d(t), "validate", function () {
      var e,
          n = t.state.displayOption,
          r = !!n && !n.disabled;
      r || t.showError(null === (e = t.state.language) || void 0 === e ? void 0 : e.placeholder);
      return r;
    }), _a2(d(t), "showError", function (e) {
      var n;
      null === (n = t.selectRef.current) || void 0 === n || n.showError(e);
    }), t.selectRef = {
      current: null
    }, t;
  }

  return i(o, [{
    key: "componentDidMount",
    value: function value() {
      this.getLanguage();
    }
  }, {
    key: "getLanguage",
    value: (t = c(l.mark(function e() {
      var t, n, r, o, i, a, s, c, u, p, d;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.props, n = t.guideI18nKey, r = t.footerI18nKey, o = t.i18n, e.next = 3, o.get(["FPX.selectBank", "FPX.bankMaintenance", n, r]);

            case 3:
              i = e.sent, a = ri(i, 4), s = a[0], c = a[1], u = a[2], p = a[3], d = {
                placeholder: s,
                errorMsg: s,
                hint: u,
                bankMaintenance: c,
                footer: p
              }, this.setState({
                isLoaded: !0,
                language: d
              });

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "getOptionList",
    value: function value() {
      var e = this.props,
          t = e.bankList,
          n = e.imgHost,
          r = this.state.language;
      return t.map(function (e) {
        return {
          value: e.bankCode,
          label: e.bankName,
          img: "".concat(n, "/payment-sdk/assets/image/FPX/").concat(e.bankCode, ".png"),
          description: e.maintainEndTime ? "".concat(null == r ? void 0 : r.bankMaintenance).concat(ns(e.maintainEndTime)) : "",
          disabled: e.status === Qa.Maintaining
        };
      });
    }
  }, {
    key: "getFormatThemeMap",
    value: function value() {
      var e = this.props.theme;
      return {
        footer: {
          iconColor: null == e ? void 0 : e.footerIconColor,
          fontColor: null == e ? void 0 : e.footerFontColor,
          linkColor: (null == e ? void 0 : e.footerLinkColor) || "#356DFF"
        },
        hint: {
          fontColor: (null == e ? void 0 : e.nextStepTipFontColor) || "rgba(44, 44, 44, 0.75)"
        },
        select: ls(ls({}, e), {}, {
          optionsDescriptionFontColor: (null == e ? void 0 : e.maintainTimeFontColor) || "#F86140"
        }),
        layout: {
          itemGutter: null == e ? void 0 : e.itemGutter,
          selectHeight: null == e ? void 0 : e.selectHeight,
          skeleton: {
            background: null == e ? void 0 : e.selectSkeletonBackground,
            borderRadius: null == e ? void 0 : e.selectBorderRadius
          }
        }
      };
    }
  }, {
    key: "selectBank",
    value: function value(e) {
      this.props.onSelectBank(e), this.setState({
        displayOption: e
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          t = this.state,
          n = t.isLoaded,
          r = t.language,
          o = this.getFormatThemeMap();
      return fr(cs, {
        isLoaded: n,
        theme: o.layout,
        select: fr(na, {
          ref: this.selectRef,
          optionList: this.getOptionList(),
          placeholder: null == r ? void 0 : r.placeholder,
          onChange: function onChange(t) {
            return e.selectBank(t);
          },
          theme: o.select,
          needAdaptive: this.props.needAdaptive
        }),
        hint: fr(wo, {
          text: null == r ? void 0 : r.hint,
          theme: o.hint
        }),
        footer: fr(ui, {
          message: null == r ? void 0 : r.footer,
          theme: o.footer
        })
      });
    }
  }]), o;
}();

function fs(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function hs(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var vs = function (e) {
  h(o, yi);
  var t,
      n = hs(o);

  function o(e) {
    var t;
    return r(this, o), _a2(d(t = n.call(this)), "componentRef", {
      current: null
    }), _a2(d(t), "component", null), t.component = fr(ds, function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? fs(Object(n), !0).forEach(function (t) {
          _a2(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fs(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({
      ref: t.componentRef
    }, e)), t;
  }

  return i(o, [{
    key: "validate",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.componentRef.current.validate());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), o;
}(),
    ys = function () {
  function e(t, n, o) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "container", void 0), _a2(this, "bankCode", void 0), _a2(this, "initData", void 0), _a2(this, "paymentMethodInfo", void 0), _a2(this, "FPXComp", void 0), this.env = t, this.initData = n, this.paymentMethodInfo = o;
  }

  var t;
  return i(e, [{
    key: "render",
    value: (t = c(l.mark(function e(t) {
      var n,
          r,
          o,
          i,
          a = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.container = t, i = new Jn(this.initData.language, {
                env: this.env.slI18nEnv
              }), this.FPXComp = new vs({
                bankList: this.paymentMethodInfo.banks,
                imgHost: this.env.host,
                i18n: i,
                guideI18nKey: null === (n = this.paymentMethodInfo.cashierNotice) || void 0 === n ? void 0 : n.guideI18nKey,
                footerI18nKey: null === (r = this.paymentMethodInfo.cashierNotice) || void 0 === r ? void 0 : r.footerI18nKey,
                theme: null === (o = this.initData.theme) || void 0 === o ? void 0 : o.FPX,
                needAdaptive: this.initData.needAdaptive,
                onSelectBank: function onSelectBank(e) {
                  return a.bankCode = e.value;
                }
              }), e.next = 5, this.FPXComp.render(this.container);

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: function value() {
      return this.FPXComp.validate();
    }
  }, {
    key: "destroy",
    value: function value() {
      this.FPXComp && this.FPXComp.destroy();
    }
  }]), e;
}(),
    ms = function () {
  function e(t, n) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "containerElement", void 0), _a2(this, "FPXUI", void 0), _a2(this, "reporter", void 0), this.env = t, this.initData = n, this.reporter = new ve(n);
  }

  var t, n, o, s;
  return i(e, [{
    key: "validate",
    value: (s = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.FPXUI) {
                e.next = 2;
                break;
              }

              return e.abrupt("return", !1);

            case 2:
              return e.abrupt("return", this.FPXUI.validate());

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return s.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (o = c(l.mark(function e(t, n) {
      var r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return t && (this.containerElement = t), this.FPXUI = new ys(this.env, this.initData, n.paymentMethodInfo), e.next = 6, this.FPXUI.render(this.containerElement)["catch"](function (e) {
                return r.reporter.handleError(e, "fpx_render_error");
              });

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Dn(t, {
                payOptions: n,
                paymentMethod: this.initData.paymentMethod,
                subPaymentMethod: this.FPXUI.bankCode
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.FPXUI && (this.FPXUI.destroy(), this.FPXUI = null);
    }
  }, {
    key: "needRenderWidget",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}(),
    gs = ["cashiers-prev1.myshopline.com", "cashiers-prev2.myshopline.com", "cashiers-prev3.myshopline.com", "cashiers.myshopline.com", "cashiers-sg.myshopline.com", "cashiers-us.myshopline.com", "payment-fe-yapi.duowan.com"];

function _s(e) {
  for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : gs, n = 0, r = t.length; n < r; n++) {
    if (e.indexOf(t[n]) > -1) return !0;
  }

  return !1;
}

function bs(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function ws(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? bs(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bs(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Cs,
    xs = ["channel-cashiers-prev.myshopline.com", "channel-cashiers-prev2.myshopline.com", "channel-cashiers-prev3.myshopline.com", "channel-cashiers.myshopline.com", "channel-cashiers-sg.myshopline.com", "channel-cashiers-us.myshopline.com", "payment-fe-yapi.duowan.com"],
    ks = function () {
  var e = c(l.mark(function e(t, n) {
    var r;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            if (_s(t, xs)) {
              e.next = 2;
              break;
            }

            throw new R("invalid upload token url ".concat(t));

          case 2:
            return r = {
              "x-requester": "cashierSDK"
            }, e.abrupt("return", we.post(t, n, {
              headers: r
            })["catch"](function (e) {
              var n = R.handleAPIErrorData(null == e ? void 0 : e.data, {
                code: v.AbnormalTrade,
                msg: y.AbnormalTrade
              });
              he.handleError(e, "upload_order_status_error", ws({
                url: t,
                response: {
                  error: e
                }
              }, n));
            }));

          case 4:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, n) {
    return e.apply(this, arguments);
  };
}(),
    Os = function () {
  var e = c(l.mark(function e(t, n) {
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.abrupt("return", ks(t, {
              actionType: "uploadChannelError",
              data: JSON.stringify(n)
            }));

          case 1:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, n) {
    return e.apply(this, arguments);
  };
}(),
    Ps = function () {
  var e = c(l.mark(function e(t, n) {
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.abrupt("return", ks(t, {
              actionType: "uploadToken",
              data: JSON.stringify(n)
            }));

          case 1:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t, n) {
    return e.apply(this, arguments);
  };
}(),
    Is = function Is(e) {
  if (e) {
    var t;
    if (void 0 === k(e.statusCode)) return !1;
    var n = 400 === e.statusCode && (null === (t = e.data) || void 0 === t ? void 0 : t.code) === v.FrequentRequest;
    return 400 !== e.statusCode || n;
  }

  return !1;
},
    Es = yn(Os, Is, {
  maxCount: 5,
  interval: 1e3
}),
    Rs = yn(Ps, Is, {
  maxCount: 5,
  interval: 1e3
});

!function (e) {
  e.Create = "create", e.ValidateMerchant = "validate_merchant", e.SelectPaymentMethod = "select_paymentMethod", e.Authorize = "authorize", e.Cancel = "cancel";
}(Cs || (Cs = {}));

var Ds = function () {
  function e(t, n) {
    r(this, e), _a2(this, "payClient", void 0);
    var o = window.ApplePaySession;
    if (!o) throw new Error(y.DeviceNotSupportPaymentMethod);
    this.reportData("constructor_start", {
      version: t,
      requestData: n
    }), this.payClient = new o(t, n), this.reportData("constructor_end");
  }

  var t, n, o;
  return i(e, [{
    key: "reportData",
    value: function value(e, t) {
      he.reportData("apple_pay_client_".concat(e), t);
    }
  }, {
    key: "pay",
    value: (o = c(l.mark(function e(t, n) {
      var r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", new Promise(function () {
                var e = c(l.mark(function e(o, i) {
                  var s, u, p, d, f, h, m, g, _, b;

                  return l.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (s = function s(e) {
                            i({
                              data: e
                            });
                          }, t.url) {
                            e.next = 3;
                            break;
                          }

                          return e.abrupt("return", s({
                            code: v.InvalidNextAction,
                            msg: y.InvalidNextAction
                          }));

                        case 3:
                          u = t.url, p = function () {
                            var e = c(l.mark(function e(t, n, o) {
                              var i, a;
                              return l.wrap(function (e) {
                                for (;;) {
                                  switch (e.prev = e.next) {
                                    case 0:
                                      return i = {
                                        statusCode: v[n],
                                        statusMessage: y[n]
                                      }, r.reportData(t, {
                                        url: u,
                                        request: i,
                                        originError: o,
                                        originErrorMsg: null == o ? void 0 : o.message
                                      }), e.next = 4, r.uploadError(u, i);

                                    case 4:
                                      a = e.sent, s(a);

                                    case 6:
                                    case "end":
                                      return e.stop();
                                  }
                                }
                              }, e);
                            }));
                            return function (t, n, r) {
                              return e.apply(this, arguments);
                            };
                          }(), t.type !== ze.CreatePayClient && p(Cs.Create, "InvalidNextAction"), d = Cs.Create, f = function f(e, t) {
                            d = e, console.log(e, t), r.reportData(e, t);
                          }, h = function h(e) {
                            var t = null == n ? void 0 : n[e],
                                o = "fireEvent_".concat(e);
                            console.log(o), r.reportData(o), "function" == typeof t && function () {
                              var e = c(l.mark(function e() {
                                return l.wrap(function (e) {
                                  for (;;) {
                                    switch (e.prev = e.next) {
                                      case 0:
                                        return e.abrupt("return", t());

                                      case 1:
                                      case "end":
                                        return e.stop();
                                    }
                                  }
                                }, e);
                              }));
                              return function () {
                                return e.apply(this, arguments);
                              };
                            }()().then(function () {
                              r.reportData("".concat(o, "_after"));
                            })["catch"](function (e) {
                              r.reportData("".concat(o, "_error"), {
                                error: e
                              });
                            });
                          };

                          try {
                            h("onPayClientCreate"), m = t.data.paymentSession.data, g = t.data.paymentRequestUpdate, _ = r.payClient, b = JSON.parse(window.atob(m)), _.onvalidatemerchant = function (e) {
                              f(Cs.ValidateMerchant, {
                                event: e,
                                decodeMerchantSession: b
                              }), _.completeMerchantValidation(b), h("afterPayClientCreate");
                            }, _.onpaymentmethodselected = function (e) {
                              f(Cs.SelectPaymentMethod, {
                                event: e,
                                paymentRequestUpdate: g
                              }), _.completePaymentMethodSelection(g);
                            }, _.onpaymentauthorized = function () {
                              var e = c(l.mark(function e(t) {
                                var i;
                                return l.wrap(function (e) {
                                  for (;;) {
                                    switch (e.prev = e.next) {
                                      case 0:
                                        return f(Cs.Authorize), h("onPayClientAuthorize"), i = {
                                          status: window.ApplePaySession.STATUS_SUCCESS
                                        }, _.completePayment(i), e.next = 6, r.uploadToken(u, t.payment, n).then(function () {
                                          r.reportData("upload_token_success_without_redirect"), o();
                                        })["catch"](function (e) {
                                          r.reportData("upload_token_error", {
                                            errorMsg: e.message,
                                            error: e
                                          }), s(e.data);
                                        });

                                      case 6:
                                      case "end":
                                        return e.stop();
                                    }
                                  }
                                }, e);
                              }));
                              return function (t) {
                                return e.apply(this, arguments);
                              };
                            }(), _.oncancel = function (e) {
                              var t;

                              if (d !== Cs.Authorize) {
                                var n = (_a2(t = {}, Cs.ValidateMerchant, "ValidateMerchantFail"), _a2(t, "default", "CancelPayClient"), t),
                                    r = n[d] || n["default"];
                                f(Cs.Cancel, {
                                  preEvent: d
                                }), p("on_cancel", r);
                              } else console.warn("拿到token后无法再取消支付");
                            }, _.begin();
                          } catch (e) {
                            console.log("session catch error", e), p("catch_error", "CreatePayClientFail", e);
                          }

                        case 10:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));
                return function (t, n) {
                  return e.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function (e, t) {
      return o.apply(this, arguments);
    })
  }, {
    key: "uploadError",
    value: (n = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Es(t, n)["catch"](function (e) {
                return he.reportError(e, "apple_pay_client_uploadOrderError"), R.handleAPIErrorData(null == e ? void 0 : e.data, {
                  code: v.AbnormalTrade,
                  msg: y.AbnormalTrade
                });
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "uploadToken",
    value: (t = c(l.mark(function e(t, n, r) {
      var o;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, Rs(t, n);

            case 2:
              return o = e.sent, this.reportData("upload_order_token_success", {
                url: t,
                response: o
              }), e.abrupt("return", jn(o, r));

            case 5:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, n, r) {
      return t.apply(this, arguments);
    })
  }]), e;
}();

function Ss(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function js(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Ss(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ss(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Ls = function () {
  function e(t, n) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "initResult", void 0), _a2(this, "containerElement", void 0), _a2(this, "simpleRender", void 0), _a2(this, "payClient", void 0), this.env = t, this.initData = n;
  }

  var t, n, o, s, u, p;
  return i(e, [{
    key: "beforeRender",
    value: (p = c(l.mark(function e(t, n) {
      var r, o, i, a, s;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return i = function i(e) {
                var t = new R(y.DeviceNotSupportPaymentMethod);
                throw t.setAPIErrorData({
                  code: v[e],
                  msg: y[e]
                }), t;
              }, this.initResult = n, (a = null === (r = this.initResult.channelInfo) || void 0 === r || null === (o = r[this.initData.paymentMethod]) || void 0 === o ? void 0 : o.data) && a.version || i("InitResultError"), e.prev = 4, e.next = 7, Ba();

            case 7:
              e.next = 14;
              break;

            case 9:
              e.prev = 9, e.t0 = e["catch"](4), s = e.t0.message || "DeviceNotSupportPaymentMethod", !v[s] && e.t0.message.indexOf("insecure document") > -1 && (s = "HTTPSRequired"), i(s);

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[4, 9]]);
    })), function (e, t) {
      return p.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (u = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t || this.containerElement) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return t && (this.containerElement = t), this.simpleRender = new Ra(this.env, this.initData, n.paymentMethodInfo), e.next = 6, this.simpleRender.render(this.containerElement);

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return u.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (s = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return s.apply(this, arguments);
    })
  }, {
    key: "afterSubmit",
    value: (o = c(l.mark(function e() {
      var t, n, r, o, i;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (r = null === (t = this.initResult.channelInfo) || void 0 === t || null === (n = t[this.initData.paymentMethod]) || void 0 === n ? void 0 : n.data) {
                e.next = 3;
                break;
              }

              throw new R(y.InitResultError, v.InitResultError, "AfterSubmitFail");

            case 3:
              e.prev = 3, this.payClient = new Ds(r.version, r.paymentRequest), e.next = 14;
              break;

            case 7:
              throw e.prev = 7, e.t0 = e["catch"](3), o = "UnknownChannelClientError", (i = e.t0.message) && (i.indexOf(y.DeviceNotSupportPaymentMethod) > -1 ? o = "DeviceNotSupportPaymentMethod" : i.indexOf("gesture handler") > -1 && (o = "NotInUserGesture")), he.reportError(e.t0, "create_pay_client_error"), new R(y[o], v[o], "AfterSubmitFail");

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[3, 7]]);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      var r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (this.payClient) {
                e.next = 2;
                break;
              }

              throw new R(y.InvalidChannelClient, v.InvalidChannelClient);

            case 2:
              return e.abrupt("return", Dn(t, {
                paymentMethod: this.initData.paymentMethod,
                payOptions: js(js({}, n), {}, {
                  hooks: {
                    extendConfirmParams: function () {
                      var e = c(l.mark(function e() {
                        return l.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return e.abrupt("return", An(r.initData.channelId));

                              case 1:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function () {
                        return e.apply(this, arguments);
                      };
                    }(),
                    handlePayAction: function handlePayAction(e) {
                      if (e.type === ze.CreatePayClient) return r.payClient.pay(e, n);
                    }
                  }
                })
              }));

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.simpleRender && (this.simpleRender.destroy(), this.simpleRender = null);
    }
  }, {
    key: "needRenderWidget",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

function Bs(e) {
  return !(null == e || (t = e, "[object Array]" === Object.prototype.toString.call(t) && !e.length));
  var t;
}

var Ts = "Header_module_label__25c3192c";

function Ns(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".Header_module_label__25c3192c {\n  font-size: 12px;\n  color: rgba(44, 44, 44, 0.75);\n}\n", {});

var As = function (e) {
  h(n, yr);
  var t = Ns(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.language,
          n = e.theme;
      return fr("div", {
        className: Ts,
        style: {
          color: (void 0 === n ? {} : n).checkoutTipColor
        }
      }, t.instrumentCheckout);
    }
  }]), n;
}(),
    Ms = "Layout_module_gutter__b3918210";

function Fs(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".Layout_module_gutter__b3918210 {\n  margin-bottom: 12px;\n}\n", {});

var Hs = function Hs(e) {
  var t = e.height,
      n = e.radius,
      r = {
    height: "".concat(t, "px"),
    borderRadius: n || "4px"
  };
  return fr(sa, {
    theme: r
  });
},
    Ws = function (e) {
  h(n, yr);
  var t = Fs(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e,
          t,
          n = this.props,
          r = n.isLoaded,
          o = n.theme,
          i = void 0 === o ? {} : o,
          a = n.initResult,
          s = n.header,
          c = n.list,
          u = n.pci,
          l = n.footer,
          p = i.formItemGutter,
          d = i.optionsBorderRadius,
          f = i.optionsHeight,
          h = parseFloat(f),
          v = /px/.test(f) && "number" == typeof (t = h) && window.isFinite(t) ? h : 52,
          y = null == a || null === (e = a.paymentMethodInfo) || void 0 === e ? void 0 : e.paymentInstruments,
          m = !(null == y || !y.length) ? ((null == y ? void 0 : y.length) + 1) * v : v;
      return fr("div", null, s && fr("div", {
        className: Ms,
        style: {
          marginBottom: p
        }
      }, r ? s : fr(Hs, {
        height: 18
      })), c && fr("div", {
        className: Ms,
        style: {
          marginBottom: p
        }
      }, r ? c : fr(Hs, {
        height: m,
        radius: d
      })), u && fr("div", null, u), l && fr("div", null, r ? l : fr(Hs, {
        height: 54
      })));
    }
  }]), n;
}(),
    Vs = "index_module_wrap__6fdf3932",
    Us = "index_module_item__6fdf3932",
    zs = "index_module_imgWrapper__6fdf3932",
    qs = "index_module_label__6fdf3932",
    Gs = "index_module_footer__6fdf3932";

Hr(".index_module_wrap__6fdf3932{\n  border: 1px solid rgba(44, 44, 44, 0.15);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.index_module_item__6fdf3932{\n  height: 52px;\n  padding: 0 16px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  background: #fff;\n  cursor: pointer;\n}\n\n.index_module_item__6fdf3932 + .index_module_item__6fdf3932{\n    border-top: 1px solid rgba(44, 44, 44, 0.15);\n  }\n\n.index_module_imgWrapper__6fdf3932{\n  width: 38px;\n  height: 24px;\n}\n\n.index_module_imgWrapper__6fdf3932 img{\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n.index_module_label__6fdf3932{\n  flex: 1;\n  padding: 0 8px;\n  font-size: 14px;\n  color: rgba(44, 44, 44, 0.75);\n}\n\n.index_module_footer__6fdf3932{\n  color: #276eaf;\n}", {});

var Zs = function Zs(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.02191 10.2404L4.29182 8.35794L4.18294 8.23948L4.1765 8.23238C3.92533 7.95152 3.9442 7.51867 4.22052 7.26114C4.49919 7.00143 4.93416 7.01837 5.19207 7.29898L5.19855 7.30604L5.31369 7.43131L6.08897 8.27484L7.0238 9.29198L7.03753 9.30692L7.05199 9.29222L8.02074 8.3078L10.9489 5.33225L11.0674 5.21185L11.0742 5.205C11.3414 4.93341 11.7767 4.93142 12.0464 5.20056C12.3139 5.46742 12.318 5.90066 12.0575 6.17272L12.0508 6.17962L11.9389 6.29341L8.02094 10.2747L7.5089 10.795C7.37693 10.9291 7.1963 11.0031 7.00884 10.9999C6.82137 10.9967 6.64335 10.9165 6.516 10.7779L6.02191 10.2404Z",
    fill: "currentColor"
  }));
};

function Xs(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var Ks = function (e) {
  h(n, yr);
  var t = Xs(n);

  function n() {
    var e;
    r(this, n);

    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = t.call.apply(t, [this].concat(i))), "onChange", function (t) {
      e.props.onChange && e.props.onChange(t);
    }), e;
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.value,
          r = t.dataSource,
          o = t.theme,
          i = void 0 === o ? {} : o;
      return null != r && r.length ? fr("div", {
        className: Vs,
        style: {
          borderColor: i.optionsBorderColor,
          borderRadius: i.optionsBorderRadius
        }
      }, r.map(function (t) {
        return fr("div", {
          className: Us,
          key: t.value,
          onClick: function onClick() {
            e.onChange(t.value);
          },
          style: {
            height: i.optionsHeight,
            background: i.optionsBackground,
            borderColor: i.optionsBorderColor
          }
        }, !!t.img && fr("div", {
          className: zs
        }, "string" == typeof t.img ? fr("img", {
          src: t.img,
          alt: ""
        }) : t.img), fr("div", {
          className: qs,
          style: {
            color: i.optionsFontColor
          }
        }, t.label), fr("div", {
          className: Gs
        }, t.value === n && fr("div", {
          style: {
            color: i.optionsIconColor
          }
        }, fr(Zs, null))));
      })) : null;
    }
  }]), n;
}(),
    $s = {
  mustAccept: !1,
  textType: {
    paymentAgreement: !0,
    subscribeAgreement: !0
  },
  defaultSwitchStatus: !0,
  switchVisible: !1
};

function Ys(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var Js = function (e) {
  h(n, yr);
  var t = Ys(n);

  function n() {
    var e;
    r(this, n);

    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = t.call.apply(t, [this].concat(i))), "state", {
      instrumentId: "",
      dataSource: []
    }), _a2(d(e), "getOptionList", function () {
      var t = e.props,
          n = t.language,
          r = t.initResult.paymentMethodInfo,
          o = (r = void 0 === r ? {} : r).paymentInstruments,
          i = t.env,
          a = t.onListChange;

      if (null != o && o.length) {
        var s = o.reduce(function (t, n) {
          var r = {
            value: n.instrumentId,
            label: "**** **** **** ".concat(n.instrumentCard.last),
            img: e.getIcon(n.instrumentCard.brand, i.imageHost)
          };
          return t.push(r), t;
        }, []);
        s.push({
          value: "IS_ADD_CARD",
          label: n.instrumentChoose
        });
        var c = o[0].instrumentId;
        e.setState({
          instrumentId: c,
          dataSource: s
        }), a && a({
          value: c,
          isAddCard: !1
        });
      }
    }), _a2(d(e), "getIcon", function (e, t) {
      var n = "card",
          r = Kr(e || n, t),
          o = Kr(n, t),
          i = 0;
      return fr("img", {
        src: r,
        onError: function onError(e) {
          var t;
          ++i <= 3 ? e.target.setAttribute("src", o) : Ee(null === (t = e.target) || void 0 === t ? void 0 : t.parentNode);
        }
      });
    }), _a2(d(e), "onChange", function (t) {
      var n = e.props.onListChange;
      e.setState({
        instrumentId: t
      });
      var r = "IS_ADD_CARD" === t;
      n && n({
        value: r ? "" : t,
        isAddCard: r
      });
    }), e;
  }

  return i(n, [{
    key: "componentDidMount",
    value: function value() {
      this.getOptionList();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props.theme,
          t = void 0 === e ? {} : e,
          n = this.state,
          r = n.instrumentId,
          o = n.dataSource;
      return null != o && o.length ? fr(Ks, {
        theme: t,
        value: r,
        dataSource: o,
        onChange: this.onChange
      }) : null;
    }
  }]), n;
}(),
    Qs = "index_module_wrap__6b4f8a9e",
    ec = "index_module_checkbox__6b4f8a9e",
    tc = "index_module_active__6b4f8a9e",
    nc = "index_module_off__6b4f8a9e",
    rc = "index_module_content__6b4f8a9e";

Hr(".index_module_wrap__6b4f8a9e {\n  display: inline-flex;\n  align-items: baseline;\n  font-size: 11px;\n  line-height: 16px;\n  cursor: pointer;\n}\n\n.index_module_wrap__6b4f8a9e svg {\n  vertical-align: baseline;\n}\n\n.index_module_checkbox__6b4f8a9e {\n  width: 16px;\n  height: 16px;\n  position: relative;\n  top: 4px;\n}\n\n.index_module_active__6b4f8a9e {\n  color: #276eaf;\n}\n\n.index_module_off__6b4f8a9e {\n  color: #ddddd8;\n}\n\n.index_module_content__6b4f8a9e {\n  word-break: break-word;\n  padding: 0 4px;\n}\n", {});

var oc = function oc(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("mask", {
    id: "path-1-inside-1_13143_5720",
    fill: "white"
  }, fr("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM12.0303 6.53033C12.3232 6.23744 12.3232 5.76256 12.0303 5.46967C11.7374 5.17678 11.2626 5.17678 10.9697 5.46967L7 9.43934L5.03033 7.46967C4.73744 7.17678 4.26256 7.17678 3.96967 7.46967C3.67678 7.76256 3.67678 8.23744 3.96967 8.53033L6.46967 11.0303C6.76256 11.3232 7.23744 11.3232 7.53033 11.0303L12.0303 6.53033Z"
  })), fr("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM12.0303 6.53033C12.3232 6.23744 12.3232 5.76256 12.0303 5.46967C11.7374 5.17678 11.2626 5.17678 10.9697 5.46967L7 9.43934L5.03033 7.46967C4.73744 7.17678 4.26256 7.17678 3.96967 7.46967C3.67678 7.76256 3.67678 8.23744 3.96967 8.53033L6.46967 11.0303C6.76256 11.3232 7.23744 11.3232 7.53033 11.0303L12.0303 6.53033Z",
    fill: "currentColor"
  }), fr("path", {
    d: "M12.0303 5.46967L12.7374 4.76256V4.76256L12.0303 5.46967ZM12.0303 6.53033L11.3232 5.82322L12.0303 6.53033ZM10.9697 5.46967L10.2626 4.76256L10.2626 4.76256L10.9697 5.46967ZM7 9.43934L6.29289 10.1464L7 10.8536L7.70711 10.1464L7 9.43934ZM3.96967 7.46967L4.67678 8.17678L3.96967 7.46967ZM3.96967 8.53033L3.26256 9.23744L3.26256 9.23744L3.96967 8.53033ZM6.46967 11.0303L5.76256 11.7374L5.76256 11.7374L6.46967 11.0303ZM7.53033 11.0303L8.23744 11.7374L8.23744 11.7374L7.53033 11.0303ZM1 2C1 1.44772 1.44772 1 2 1V-1C0.343146 -1 -1 0.343146 -1 2H1ZM1 14V2H-1V14H1ZM2 15C1.44772 15 1 14.5523 1 14H-1C-1 15.6569 0.343146 17 2 17V15ZM14 15H2V17H14V15ZM15 14C15 14.5523 14.5523 15 14 15V17C15.6569 17 17 15.6569 17 14H15ZM15 2V14H17V2H15ZM14 1C14.5523 1 15 1.44772 15 2H17C17 0.343146 15.6569 -1 14 -1V1ZM2 1H14V-1H2V1ZM11.3232 6.17678C11.2256 6.07915 11.2256 5.92085 11.3232 5.82322L12.7374 7.23744C13.4209 6.55402 13.4209 5.44598 12.7374 4.76256L11.3232 6.17678ZM11.6768 6.17678C11.5791 6.27441 11.4209 6.27441 11.3232 6.17678L12.7374 4.76256C12.054 4.07915 10.946 4.07915 10.2626 4.76256L11.6768 6.17678ZM7.70711 10.1464L11.6768 6.17678L10.2626 4.76256L6.29289 8.73223L7.70711 10.1464ZM4.32322 8.17678L6.29289 10.1464L7.70711 8.73223L5.73744 6.76256L4.32322 8.17678ZM4.67678 8.17678C4.57915 8.27441 4.42085 8.27441 4.32322 8.17678L5.73744 6.76256C5.05402 6.07915 3.94598 6.07915 3.26256 6.76256L4.67678 8.17678ZM4.67678 7.82323C4.77441 7.92085 4.77441 8.07914 4.67678 8.17678L3.26256 6.76256C2.57914 7.44598 2.57915 8.55402 3.26256 9.23744L4.67678 7.82323ZM7.17678 10.3232L4.67678 7.82322L3.26256 9.23744L5.76256 11.7374L7.17678 10.3232ZM6.82322 10.3232C6.92086 10.2256 7.07914 10.2256 7.17678 10.3232L5.76256 11.7374C6.44598 12.4209 7.55402 12.4209 8.23744 11.7374L6.82322 10.3232ZM11.3232 5.82322L6.82322 10.3232L8.23744 11.7374L12.7374 7.23744L11.3232 5.82322Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_13143_5720)"
  }));
},
    ic = function ic(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H14C14.8284 0.5 15.5 1.17157 15.5 2V14C15.5 14.8284 14.8284 15.5 14 15.5H2C1.17157 15.5 0.5 14.8284 0.5 14V2Z",
    stroke: "currentColor"
  }));
};

function ac(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function sc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ac(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ac(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function cc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var uc = function (e) {
  h(n, yr);
  var t = cc(n);

  function n() {
    var e;
    r(this, n);

    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = t.call.apply(t, [this].concat(i))), "state", {
      value: !1
    }), _a2(d(e), "onChange", function () {
      var t = e.props.onChange;
      e.setState(function (e) {
        return sc(sc({}, e), {}, {
          value: !e.value
        });
      }, function () {
        t && t(e.state.value);
      });
    }), e;
  }

  return i(n, [{
    key: "componentDidMount",
    value: function value() {
      var e = this.props.defaultChecked;
      "boolean" == typeof e && this.setState({
        value: e
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.theme,
          n = void 0 === t ? {} : t,
          r = e.children,
          o = this.state.value;
      return fr("div", {
        className: Qs,
        onClick: this.onChange
      }, fr("span", {
        className: ec
      }, o ? fr("span", {
        className: tc,
        style: {
          color: n.checkboxActiveColor
        }
      }, fr(oc, null)) : fr("span", {
        className: nc,
        style: {
          color: n.checkboxOffColor
        }
      }, fr(ic, null))), fr("span", {
        className: rc
      }, r));
    }
  }]), n;
}(),
    lc = "index_module_line__3c6da75b",
    pc = "index_module_footer__3c6da75b";

function dc(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function fc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? dc(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dc(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

Hr(".index_module_line__3c6da75b {\n  margin: 12px 0;\n  border-top: 1px solid rgba(44, 44, 44, 0.15);\n}\n\n.index_module_footer__3c6da75b{\n  margin-bottom: 12px;\n}", {});

var hc = function () {
  var e = c(l.mark(function e(t) {
    var n, r, o, i, a, s, c;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            return e.next = 2, t.get(["instrumentCheckout", "instrumentChoose", "instrumentRequireTip", "paymentAgreement", "subscribeAgreement"]);

          case 2:
            return n = e.sent, r = ri(n, 5), o = r[0], i = r[1], a = r[2], s = r[3], c = r[4], e.abrupt("return", {
              instrumentCheckout: o,
              instrumentChoose: i,
              instrumentRequireTip: a,
              paymentAgreement: s,
              subscribeAgreement: c
            });

          case 10:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }));
  return function (t) {
    return e.apply(this, arguments);
  };
}();

function vc(e) {
  var t,
      n,
      r = null == e || null === (t = e.paymentInstrument) || void 0 === t || null === (n = t.bindCard) || void 0 === n ? void 0 : n.protocol;
  return fc(fc({}, $s), r);
}

function yc(e) {
  var t = e.paymentMethodInfo,
      n = (t = void 0 === t ? {} : t).paymentInstruments;
  return !(null == n || !n.length);
}

function mc(e) {
  return {
    iconColor: e.footerIconColor,
    fontColor: e.footerFontColor,
    linkColor: e.footerLinkColor
  };
}

var gc = function gc(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    d: "M3.63093 5.14499C4.63837 3.80183 6.23709 2.95872 8 2.95872C10.4382 2.95872 12.3691 4.46981 13.1245 6.57218H14.3838C13.6283 3.79823 11.1061 1.69946 7.9964 1.69946C5.80998 1.69946 3.87915 2.79079 2.62004 4.47341L1.27673 3.55001V7.75115L4.89019 5.9042L3.63093 5.14499ZM11.1098 10.861L12.453 11.7844C11.4455 13.1275 9.8468 13.9708 8.08389 13.9708C5.64566 13.9708 3.71482 12.4597 2.95935 10.3573H1.6162C2.37167 13.1313 4.89394 15.146 8.0036 15.146C10.1899 15.146 12.1208 14.0547 13.38 12.372L14.7231 13.2954V9.0943L11.1098 10.861Z",
    fill: "currentColor"
  }), fr("path", {
    d: "M7.58024 5.06104C7.24438 5.06104 7.0766 5.31286 7.0766 5.56468V9.17813C7.0766 9.34607 7.16049 9.514 7.24453 9.59789C7.32842 9.68178 7.49635 9.76582 7.66428 9.76582H11.2777C11.6136 9.76582 11.8654 9.514 11.8654 9.17813C11.8654 8.84227 11.6136 8.59045 11.2777 8.59045H8.25182V5.64872C8.25182 5.31286 7.91611 5.06104 7.58024 5.06104Z",
    fill: "currentColor"
  }));
},
    _c = function _c(e) {
  return fr("svg", Qo({}, e, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), fr("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.6 8C13.6 11.0928 11.0928 13.6 8 13.6C4.90721 13.6 2.4 11.0928 2.4 8C2.4 4.90721 4.90721 2.4 8 2.4C11.0928 2.4 13.6 4.90721 13.6 8ZM15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.00005 4C8.44188 4 8.80005 4.35817 8.80005 4.8V9C8.80005 9.44183 8.44188 9.8 8.00005 9.8C7.55822 9.8 7.20005 9.44183 7.20005 9V4.8C7.20005 4.35817 7.55822 4 8.00005 4ZM7.99999 12.45C8.47998 12.45 8.89623 12.0471 8.89998 11.5463C8.89623 11.053 8.47998 10.65 7.99999 10.65C7.505 10.65 7.09625 11.053 7.1 11.5463C7.09625 12.0471 7.505 12.45 7.99999 12.45Z",
    fill: "#F04949"
  }));
};

function bc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var wc = function (e) {
  h(o, yr);
  var t,
      n = bc(o);

  function o() {
    var e;
    r(this, o);

    for (var t = arguments.length, i = new Array(t), s = 0; s < t; s++) {
      i[s] = arguments[s];
    }

    return _a2(d(e = n.call.apply(n, [this].concat(i))), "state", {
      BindCardProtocolConfig: {},
      checked: !0,
      validateResult: !0
    }), _a2(d(e), "onCheckboxChange", function (t) {
      var n = e.props.onCheckboxChange,
          r = e.state.validateResult;
      e.setState({
        checked: t
      }), t && !r && e.setState({
        validateResult: !0
      }), n && n(t);
    }), e;
  }

  return i(o, [{
    key: "componentDidMount",
    value: function value() {
      this.getBindCardProtocolConfig();
    }
  }, {
    key: "getBindCardProtocolConfig",
    value: function value() {
      var e = vc(this.props.initData);
      this.setState({
        BindCardProtocolConfig: e,
        checked: e.defaultSwitchStatus
      });
    }
  }, {
    key: "validate",
    value: (t = c(l.mark(function e() {
      var t, n, r, o;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.state, n = t.BindCardProtocolConfig, r = t.checked, o = n.mustAccept && !r, this.setState({
                validateResult: !o
              }), e.abrupt("return", !o);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.language,
          n = e.theme,
          r = void 0 === n ? {} : n,
          o = this.state,
          i = o.BindCardProtocolConfig,
          a = o.validateResult,
          s = r.formItemGutter,
          c = r.footerDividingLineColor,
          u = mc(r);
      return fr("div", null, i.switchVisible ? fr(uc, {
        defaultChecked: Boolean(i.defaultSwitchStatus),
        onChange: this.onCheckboxChange,
        theme: r
      }, fr(ui, {
        icon: null,
        message: null == t ? void 0 : t.paymentAgreement,
        theme: u
      })) : fr(ui, {
        icon: fr(gc, null),
        message: null == t ? void 0 : t.paymentAgreement,
        theme: u
      }), !a && fr(ui, {
        icon: fr(_c, null),
        message: null == t ? void 0 : t.instrumentRequireTip,
        theme: {
          fontColor: "#f04949",
          linkColor: "#f04949"
        }
      }), fr("div", {
        className: lc,
        style: {
          marginTop: s,
          marginBottom: s,
          borderColor: c
        }
      }));
    }
  }]), o;
}();

function Cc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var xc = function (e) {
  h(n, yr);
  var t = Cc(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e,
          t,
          n = this.props,
          r = n.i18n,
          o = n.initResult,
          i = n.theme,
          a = void 0 === i ? {} : i,
          s = mc(a),
          c = null === (e = o.paymentMethodInfo) || void 0 === e || null === (t = e.cashierNotice) || void 0 === t ? void 0 : t.footerI18nKey;
      return fr("div", {
        className: pc,
        style: {
          marginBottom: a.formItemGutter
        }
      }, fr(pi, {
        i18n: r,
        footerKey: c,
        theme: s
      }));
    }
  }]), n;
}();

function kc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var Oc = function (e) {
  h(n, yr);
  var t = kc(n);

  function n() {
    return r(this, n), t.apply(this, arguments);
  }

  return i(n, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.language,
          n = void 0 === t ? {} : t,
          r = e.theme,
          o = mc(void 0 === r ? {} : r);
      return null != n && n.subscribeAgreement ? fr(ui, {
        icon: fr(gc, null),
        message: null == n ? void 0 : n.subscribeAgreement,
        theme: o
      }) : null;
    }
  }]), n;
}();

function Pc(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Ic(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Pc(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pc(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function Ec(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

Hr(".InstrumentUIComponent_module_hide__186a297d {\n  display: none;\n}\n", {});

var Rc = Vr.bind({
  hide: "InstrumentUIComponent_module_hide__186a297d"
}),
    Dc = function (e) {
  h(f, yr);
  var t,
      n,
      o,
      s,
      u,
      p = Ec(f);

  function f() {
    var e;
    r(this, f);

    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
      n[o] = arguments[o];
    }

    return _a2(d(e = p.call.apply(p, [this].concat(n))), "pciRef", {
      current: null
    }), _a2(d(e), "footerRef", {
      current: null
    }), _a2(d(e), "state", {
      isLoaded: !1,
      language: null,
      isListExist: !1,
      isPaymentAgreementExist: !1,
      isSubscribeAgreementExist: !1,
      selectInstrumentId: "",
      isAddCard: !1,
      savePaymentInstrument: !1
    }), _a2(d(e), "onListChange", function (t) {
      var n = t.value,
          r = t.isAddCard;
      e.setState({
        selectInstrumentId: n,
        isAddCard: r
      });
    }), _a2(d(e), "setFieldError", function (t, n) {
      var r;
      return null === (r = e.pciRef) || void 0 === r ? void 0 : r.current.setFieldError(t, n);
    }), _a2(d(e), "onCheckboxChange", function (t) {
      e.setState({
        savePaymentInstrument: t
      });
    }), e;
  }

  return i(f, [{
    key: "componentDidMount",
    value: function value() {
      this.getLanguage(), this.getListInitializedState(), this.getProtocolExist();
    }
  }, {
    key: "getLanguage",
    value: (u = c(l.mark(function e() {
      var t;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, hc(this.props.i18n);

            case 2:
              t = e.sent, this.setState({
                language: t,
                isLoaded: !0
              });

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "getListInitializedState",
    value: (s = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              yc(this.props.initResult) ? this.setState({
                isListExist: !0
              }) : this.setState({
                isListExist: !1,
                selectInstrumentId: "",
                isAddCard: !0
              });

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return s.apply(this, arguments);
    })
  }, {
    key: "getProtocolExist",
    value: (o = c(l.mark(function e() {
      var t, n, r, o, i;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              t = this.props.initData, n = vc(t), r = n.textType.paymentAgreement || n.switchVisible, o = n.textType.subscribeAgreement, i = Boolean(n.defaultSwitchStatus), this.setState({
                isPaymentAgreementExist: r,
                isSubscribeAgreementExist: o,
                savePaymentInstrument: i
              });

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "getCreditCardForm",
    value: function value() {
      var e,
          t,
          n = this.props,
          r = n.initResult,
          o = n.initData,
          i = n.env,
          a = {
        pciInstance: n.pciInstance,
        channelId: o.channelId,
        theme: zn(o.theme),
        needAdaptive: o.needAdaptive,
        enableCardBinVerification: Boolean(r.cardBinSwitch),
        footerI18nKey: null === (e = r.paymentMethodInfo) || void 0 === e || null === (t = e.cashierNotice) || void 0 === t ? void 0 : t.footerI18nKey,
        language: o.language,
        supportCardBrands: r.brands,
        env: i.env,
        isBindCard: o.isBindCard,
        cardBinVerificationParams: {
          merchantId: o.merchantId,
          paymentMethod: o.paymentMethod,
          currency: o.currency,
          amount: o.amount
        },
        onLoad: function onLoad() {
          console.log("加载instrument pci 完成");
        }
      };
      return fr(vi, Ic(Ic({}, a), {}, {
        ref: this.pciRef,
        footer: null
      }));
    }
  }, {
    key: "validate",
    value: (n = c(l.mark(function e() {
      var t, n, r, o;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t = this.state, n = t.selectInstrumentId, r = t.isAddCard, o = t.isPaymentAgreementExist, r) {
                e.next = 5;
                break;
              }

              if (n) {
                e.next = 4;
                break;
              }

              return e.abrupt("return", Promise.reject("selectInstrumentId is null"));

            case 4:
              return e.abrupt("return", !0);

            case 5:
              if (!o) {
                e.next = 12;
                break;
              }

              return e.next = 8, this.footerRef.current.validate();

            case 8:
              if (e.sent) {
                e.next = 12;
                break;
              }

              return this.pciRef.current.validate(), e.abrupt("return", !1);

            case 12:
              return e.abrupt("return", this.pciRef.current.validate());

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "getPayData",
    value: (t = c(l.mark(function e() {
      var t, n, r, o;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = this.state, n = t.selectInstrumentId, r = t.isAddCard, o = t.savePaymentInstrument, e.abrupt("return", {
                selectInstrumentId: n,
                isAddCard: r,
                savePaymentInstrument: o
              });

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }, {
    key: "render",
    value: function value() {
      var e,
          t = this.props,
          n = t.i18n,
          r = t.initData,
          o = t.env,
          i = t.initResult,
          a = this.state,
          s = a.isLoaded,
          c = a.language,
          u = a.isAddCard,
          l = a.isListExist,
          p = a.isPaymentAgreementExist,
          d = a.isSubscribeAgreementExist,
          f = null == r || null === (e = r.theme) || void 0 === e ? void 0 : e.bindCardProtocol;
      return fr("div", null, fr(Ws, {
        isLoaded: s,
        theme: f,
        initResult: i,
        header: !u && fr(As, {
          theme: f,
          language: c
        }),
        list: l && fr(Js, {
          theme: f,
          language: c,
          initData: r,
          env: o,
          initResult: i,
          onListChange: this.onListChange
        }),
        pci: fr("div", {
          className: Rc({
            hide: !u
          })
        }, (u || this.pciRef.current) && this.getCreditCardForm()),
        footer: fr("div", null, p && fr("div", {
          className: Rc({
            hide: !u
          })
        }, fr(wc, {
          initData: r,
          theme: f,
          language: c,
          onCheckboxChange: this.onCheckboxChange,
          ref: this.footerRef
        })), fr(xc, {
          theme: f,
          i18n: n,
          initResult: i
        }), d && fr(Oc, {
          theme: f,
          language: c
        }))
      }));
    }
  }]), f;
}();

function Sc(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

var jc = function jc(e) {
  return function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Sc(Object(n), !0).forEach(function (t) {
        _a2(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sc(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }({
    client: Nn()
  }, e);
};

function Lc(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Bc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Lc(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Lc(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function Tc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var Nc = function (e) {
  h(f, yi);
  var t,
      n,
      o,
      s,
      u,
      p = Tc(f);

  function f(e, t, n, o) {
    var i;
    r(this, f), _a2(d(i = p.call(this)), "componentRef", {
      current: null
    }), _a2(d(i), "pciInstance", void 0), _a2(d(i), "reporter", void 0), _a2(d(i), "initData", void 0), _a2(d(i), "i18n", void 0), _a2(d(i), "component", null), _a2(d(i), "getPaymentBehavior", function (e, t) {
      if ("boolean" == typeof (null == e ? void 0 : e.onlyStoreCard)) {
        var n = Ue.REGULAR_PAYMENT;
        return n = null != e && e.onlyStoreCard ? Ue.CARD_BINDING_VALIDATE_PAY : Ue.CARD_BINDING_PAY, null != t && t.savePaymentInstrument || (n = Ue.REGULAR_PAYMENT), n;
      }
    }), i.initData = n, i.pciInstance = new hn({
      host: n.host
    }), i.reporter = new ve(n), i.i18n = e;

    var s = function (e) {
      var t = e.paymentMethodInfo,
          n = (t = void 0 === t ? {} : t).paymentInstruments;

      if (null != n && n.length) {
        var r = n.filter(function (e) {
          return !e.expired;
        });
        return fc(fc({}, e), {}, {
          paymentMethodInfo: fc(fc({}, e.paymentMethodInfo), {}, {
            paymentInstruments: r
          })
        });
      }

      return e;
    }(o);

    return i.component = fr(Dc, {
      ref: i.componentRef,
      env: t,
      i18n: e,
      initData: n,
      initResult: s,
      pciInstance: i.pciInstance
    }), i;
  }

  return i(f, [{
    key: "validate",
    value: (u = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.componentRef.current.validate());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (s = c(l.mark(function e(t, n) {
      var r;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.componentRef.current.getPayData();

            case 2:
              if (!(r = e.sent).isAddCard) {
                e.next = 7;
                break;
              }

              return e.abrupt("return", this.pciPay(t, n, r));

            case 7:
              return e.abrupt("return", this.paymentPay(t, n, r));

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return s.apply(this, arguments);
    })
  }, {
    key: "pciPay",
    value: (o = c(l.mark(function e(t, n, r) {
      var o,
          i,
          a,
          s,
          u,
          p = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, o = null != t && t.customerToken ? t.customerToken : this.initData.customerToken, i = this.getPaymentBehavior(t, r), a = {
                savePaymentInstrument: Boolean(r.savePaymentInstrument),
                paymentBehavior: i
              }, s = jc({
                paymentMethod: this.initData.paymentMethod,
                customerToken: o || "",
                paymentInstrumentExtraData: a
              }), e.next = 7, this.pciInstance.pay(t, s)["catch"](function () {
                var e = c(l.mark(function e(n) {
                  var r, o;
                  return l.wrap(function (e) {
                    for (;;) {
                      switch (e.prev = e.next) {
                        case 0:
                          if (400 !== n.statusCode) {
                            e.next = 5;
                            break;
                          }

                          return e.next = 3, er(null === (r = n.data) || void 0 === r ? void 0 : r.code, p.i18n);

                        case 3:
                          (o = e.sent) && p.componentRef.current.setFieldError(o.field, o.message);

                        case 5:
                          return e.abrupt("return", p.reporter.handleError(n, "pci_pay_error", {
                            request: {
                              params: {
                                nextAction: t
                              }
                            },
                            response: {
                              error: n
                            }
                          }));

                        case 6:
                        case "end":
                          return e.stop();
                      }
                    }
                  }, e);
                }));
                return function (t) {
                  return e.apply(this, arguments);
                };
              }());

            case 7:
              return u = e.sent, e.abrupt("return", jn(u, n));

            case 11:
              e.prev = 11, e.t0 = e["catch"](0), this.reporter.handleError(e.t0);

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 11]]);
    })), function (e, t, n) {
      return o.apply(this, arguments);
    })
  }, {
    key: "paymentPay",
    value: (n = c(l.mark(function e(t, n, r) {
      var o = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", Dn(t, {
                paymentMethod: this.initData.paymentMethod,
                payOptions: Bc(Bc({}, n), {}, {
                  hooks: {
                    extendConfirmParams: function () {
                      var e = c(l.mark(function e() {
                        return l.wrap(function (e) {
                          for (;;) {
                            switch (e.prev = e.next) {
                              case 0:
                                return e.abrupt("return", {
                                  customerToken: o.initData.customerToken || "",
                                  paymentInstrumentId: r.selectInstrumentId || "",
                                  paymentInstrument: {
                                    paymentBehavior: Ue.QUICK_PAYMENT
                                  }
                                });

                              case 1:
                              case "end":
                                return e.stop();
                            }
                          }
                        }, e);
                      }));
                      return function () {
                        return e.apply(this, arguments);
                      };
                    }()
                  }
                })
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t, r) {
      return n.apply(this, arguments);
    })
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      var t;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.componentRef.current.getPayData();

            case 2:
              if (null != (t = e.sent) && t.isAddCard) {
                e.next = 5;
                break;
              }

              return e.abrupt("return", null);

            case 5:
              return e.abrupt("return", this.pciInstance.getCurrentCardInfo());

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), f;
}(),
    Ac = function () {
  function e(t, n, o) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "paymentInitData", void 0), _a2(this, "initResult", void 0), _a2(this, "component", void 0), this.env = t, this.paymentInitData = n, this.initResult = o;
  }

  var t, n, o, s;
  return i(e, [{
    key: "render",
    value: (s = c(l.mark(function e(t) {
      var n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return n = new Jn(this.paymentInitData.language, {
                env: this.env.slI18nEnv
              }), this.component = new Nc(n, this.env, this.paymentInitData, this.initResult), e.next = 4, this.component.render(t);

            case 4:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e) {
      return s.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.component && (this.component.destroy(), this.component = null);
    }
  }, {
    key: "validate",
    value: (o = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.component.validate());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.component.pay(t, n));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.component.getCurrentCardInfo());

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}(),
    Mc = function () {
  function e(t, n) {
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "reporter", void 0), _a2(this, "containerElement", void 0), _a2(this, "customerPaymentInstrumentUI", void 0), this.env = t, this.initData = n, this.reporter = new ve(n);
  }

  var t, n, o, s, u, p;
  return i(e, [{
    key: "needRenderWidget",
    value: (p = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", !0);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    })), function () {
      return p.apply(this, arguments);
    })
  }, {
    key: "beforeRender",
    value: (u = c(l.mark(function e() {
      var t, n, r, o;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (t = vc(this.initData), n = (null == t ? void 0 : t.mustAccept) && !(null != t && t.switchVisible) && !(null != t && t.defaultSwitchStatus), r = (null == t ? void 0 : t.switchVisible) && !t.textType.paymentAgreement, !n && !r) {
                e.next = 8;
                break;
              }

              throw (o = new R("check_paymentInstrument_error")).setAPIErrorData({
                code: v.InnerSDKError,
                msg: "Please check the initData.paymentInstrument parameter, the parameter is abnormal"
              }), o;

            case 8:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return u.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (s = c(l.mark(function e(t, n) {
      var r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(!t && !this.containerElement || t && this.containerElement)) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return this.containerElement = t, this.customerPaymentInstrumentUI = new Ac(this.env, this.initData, n), e.next = 6, this.customerPaymentInstrumentUI.render(t)["catch"](function (e) {
                return r.reporter.handleError(e, "customerPaymentInstrumentUI_render_error");
              });

            case 6:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return s.apply(this, arguments);
    })
  }, {
    key: "validate",
    value: (o = c(l.mark(function e() {
      var t = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.customerPaymentInstrumentUI.validate()["catch"](function (e) {
                return t.reporter.handleError(e, "customerPaymentInstrumentUI_validate_error");
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "pay",
    value: (n = c(l.mark(function e(t, n) {
      var r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.customerPaymentInstrumentUI.pay(t, n)["catch"](function (e) {
                return r.reporter.handleError(e, "customerPaymentInstrumentUI_pay_error");
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function (e, t) {
      return n.apply(this, arguments);
    })
  }, {
    key: "destroy",
    value: function value() {
      this.customerPaymentInstrumentUI && (this.customerPaymentInstrumentUI.destroy(), this.customerPaymentInstrumentUI = null);
    }
  }, {
    key: "getCurrentCardInfo",
    value: (t = c(l.mark(function e() {
      var t = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.customerPaymentInstrumentUI.getCurrentCardInfo()["catch"](function (e) {
                return t.reporter.handleError(e, "customerPaymentInstrumentUI_getCurrentCardInfo_error");
              }));

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}(),
    Fc = function Fc(e) {
  if (ts.checkHasPlugin(e)) return ts;
  var t,
      n = e.paymentMethod,
      r = Bs(e.installmentCounts);

  switch (n) {
    case Fe.Paypal:
      t = Wa;
      break;

    case Fe.ChaileaseBNPL:
      t = r ? Oa : Fa;
      break;

    case Fe.CreditCard:
      t = function (e) {
        var t = Bs(e.installmentCounts),
            n = function (e) {
          var t,
              n = e.channelId,
              r = e.paymentInstrument;
          return "SLPayments" === n && (null == r || null === (t = r.bindCard) || void 0 === t ? void 0 : t.enable);
        }(e);

        return t ? Oa : n ? Mc : Pi;
      }(e);

      break;

    case Fe.FPX:
      t = ms;
      break;

    case Fe.ApplePay:
      t = Ls;
      break;

    default:
      t = Fa;
  }

  return t;
},
    Hc = [/Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/, /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/, /MSIE\s(7\.0)/];

function Wc(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function Vc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Wc(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wc(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Uc = function () {
  function e(t, n) {
    var o = this;
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "initResult", void 0), _a2(this, "blockRender", void 0), _a2(this, "reporter", void 0), _a2(this, "renderFail", function () {
      var e = c(l.mark(function e(t) {
        var n, r;
        return l.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return r = new Ya(o.env, null === (n = o.initData.theme) || void 0 === n ? void 0 : n.block), o.blockRender = r, e.next = 4, r.mount(t, o.initData)["catch"](function (e) {
                  o.reporter.handleError(e, "render_fail_error");
                });

              case 4:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), _a2(this, "destroy", function () {
      o.blockRender && (o.blockRender.destroy(), o.blockRender = null);
    }), this.env = t, this.reporter = new ve(n), this.initData = n, this.initResult = this.cashierCheck();
  }

  var t, n;
  return i(e, [{
    key: "getRequestData",
    value: function value() {
      var e = this.initData,
          t = e.merchantId,
          n = e.countryCode,
          r = e.paymentMethod,
          o = e.currency,
          i = e.channelId,
          a = e.installmentCounts,
          s = e.amount,
          c = e.customerToken,
          u = {
        merchantId: t,
        countryCode: n,
        paymentMethod: r,
        currency: o,
        channelId: i,
        amount: s,
        deviceType: Re()
      },
          l = void 0 !== c;
      return Bs(e.installmentCounts) ? u.installmentCounts = a : l && (u.customerToken = c), u;
    }
  }, {
    key: "handleResponse",
    value: function value(e) {
      var t,
          n,
          r = Vc(Vc({}, e.data), {}, {
        status: es.Success
      });

      if (Bs(this.initData.installmentCounts) && ("installments" in r && null !== (t = r.installments) && void 0 !== t && t.length && (r.installments = r.installments.filter(function (e) {
        return !!e.supportCount;
      })), !("installments" in r) || null == r || null === (n = r.installments) || void 0 === n || !n.length)) {
        return this.reporter.reportErrorData("cashier_check_installment_error", {
          installmentCounts: this.initData.installmentCounts,
          amount: this.initData.amount
        }), {
          status: es.Fail
        };
      }

      return r;
    }
  }, {
    key: "cashierCheck",
    value: (n = c(l.mark(function e() {
      var t,
          n,
          r = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return t = "".concat(this.env.host, "/v1/api/cashier/init"), n = this.getRequestData(), e.abrupt("return", we.post(t, n).then(function (e) {
                return r.reporter.reportData("cashier_check_success", {
                  url: t,
                  request: {
                    params: n
                  },
                  response: "SLPayments" === r.initData.channelId ? e.data : Vc(Vc({}, e.data), {}, {
                    channelInfo: null
                  })
                }), r.handleResponse(e);
              })["catch"](function (e) {
                var r = Vc({
                  status: es.Fail
                }, e.data || {});
                return he.reportErrorData("cashier_check_error", {
                  url: t,
                  request: {
                    params: n
                  },
                  response: {
                    error: e
                  }
                }), r;
              }));

            case 3:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "getInitResult",
    value: (t = c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.initResult);

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return t.apply(this, arguments);
    })
  }]), e;
}();

function zc(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }

  return n;
}

function qc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? zc(Object(n), !0).forEach(function (t) {
      _a2(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zc(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

var Gc = function () {
  function e(t, n, o) {
    var i,
        s = this;
    r(this, e), _a2(this, "env", void 0), _a2(this, "initData", void 0), _a2(this, "element", void 0), _a2(this, "paySession", void 0), _a2(this, "scene", void 0), _a2(this, "metaData", void 0), _a2(this, "isNotSupportBrowser", void 0), _a2(this, "reporter", void 0), _a2(this, "renderChecker", void 0), _a2(this, "isRenderFail", void 0), _a2(this, "init", c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, s.reporter.reportData("init_start"), s.check(), e.next = 5, Promise.all([s.initRisk(), s.initRender()])["catch"](s.reporter.handleError);

            case 5:
              return s.reporter.reportData("init_end"), e.abrupt("return", s);

            case 9:
              e.prev = 9, e.t0 = e["catch"](0), s.reporter.handleError(e.t0, "init_error");

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 9]]);
    }))), _a2(this, "renderWidget", function () {
      var e = c(l.mark(function e(t) {
        var n;
        return l.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (e.prev = 0, s.reporter.reportData("renderWidget_start"), n = s.getRenderElement(t), !s.isNotSupportBrowser) {
                  e.next = 6;
                  break;
                }

                return s.reporter.reportData("renderWidget_notSupportBrowser_end"), e.abrupt("return");

              case 6:
                return e.next = 8, s.scene.needRenderWidget()["catch"](s.reporter.handleError);

              case 8:
                if (!e.sent) {
                  e.next = 14;
                  break;
                }

                return e.next = 12, s.render(n);

              case 12:
                e.next = 15;
                break;

              case 14:
                console.warn('支付方式 "'.concat(s.metaData.paymentMethod, '" 不需要渲染控件'));

              case 15:
                s.reporter.reportData("renderWidget_end"), e.next = 21;
                break;

              case 18:
                e.prev = 18, e.t0 = e["catch"](0), s.reporter.handleError(e.t0, "renderWidget_error");

              case 21:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 18]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }()), _a2(this, "getPaySession", c(l.mark(function e() {
      var t, n, r, o;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, s.reporter.reportData("getPaySession_start"), t = {}, !s.scene.extendPaySession) {
                e.next = 7;
                break;
              }

              return e.next = 6, s.scene.extendPaySession()["catch"](s.reporter.handleError);

            case 6:
              t = e.sent;

            case 7:
              return e.next = 9, s.paySession;

            case 9:
              return n = e.sent, e.next = 12, s.renderChecker.getInitResult()["catch"](s.reporter.handleError);

            case 12:
              return (r = e.sent).status === es.Success && r.recommendSubPaymentMethod && (n.recommendSubPaymentMethod = r.recommendSubPaymentMethod), o = JSON.stringify(Object.assign({}, t, n)), s.reporter.reportData("getPaySession_end", {
                paySession: o
              }), e.abrupt("return", o);

            case 19:
              e.prev = 19, e.t0 = e["catch"](0), s.reporter.handleError(e.t0, "getPaySession_error");

            case 22:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 19]]);
    }))), _a2(this, "needRenderWidget", c(l.mark(function e() {
      var t;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, s.reporter.reportData("needRenderWidget_start"), e.next = 4, s.renderChecker.getInitResult()["catch"](s.reporter.handleError);

            case 4:
              if (e.sent.status !== es.Fail) {
                e.next = 8;
                break;
              }

              return s.reporter.reportData("needRenderWidget_checkResult_fail_end"), e.abrupt("return", !0);

            case 8:
              if (!s.isNotSupportBrowser) {
                e.next = 11;
                break;
              }

              return s.reporter.reportData("needRenderWidget_notSupportBrowser_fail_end"), e.abrupt("return", !1);

            case 11:
              return e.next = 13, s.scene.needRenderWidget();

            case 13:
              return t = e.sent, s.reporter.reportData("needRenderWidget_end", {
                needRenderWidget: t
              }), e.abrupt("return", t);

            case 18:
              e.prev = 18, e.t0 = e["catch"](0), s.reporter.handleError(e.t0, "needRenderWidget_error");

            case 21:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 18]]);
    }))), _a2(this, "validate", c(l.mark(function e() {
      var t, n;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, s.reporter.reportData("validate_start"), e.next = 4, s.renderChecker.getInitResult()["catch"](s.reporter.handleError);

            case 4:
              if (t = e.sent, !s.isRenderFail && t.status !== es.Fail) {
                e.next = 8;
                break;
              }

              return s.reporter.reportData("validate_checkResult_fail_end"), e.abrupt("return", !1);

            case 8:
              return e.next = 10, s.scene.validate();

            case 10:
              return n = e.sent, s.reporter.reportData("validate_end", {
                validateResult: n
              }), e.abrupt("return", n);

            case 15:
              e.prev = 15, e.t0 = e["catch"](0), s.reporter.handleError(e.t0, "validate_error");

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 15]]);
    }))), _a2(this, "afterSubmit", c(l.mark(function e() {
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, !s.scene.afterSubmit) {
                e.next = 6;
                break;
              }

              return s.reporter.reportData("afterSubmit_start"), e.next = 5, s.scene.afterSubmit();

            case 5:
              s.reporter.reportData("afterSubmit_end");

            case 6:
              e.next = 11;
              break;

            case 8:
              e.prev = 8, e.t0 = e["catch"](0), s.reporter.handleError(e.t0, "afterSubmit_error");

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 8]]);
    }))), _a2(this, "pay", function () {
      var e = c(l.mark(function e(t, n) {
        var r, o, i, a, u;
        return l.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, (null == (r = t) ? void 0 : r.type) === ze.Confirm && (p = null == r ? void 0 : r.url, o = p && "string" == typeof p ? p.split("/").pop() : "", s.reporter.addReportData({
                  orderId: o
                })), s.reporter.reportData("call_pay_start", {
                  nextAction: t
                }), e.next = 6, s.paySession;

              case 6:
                return i = e.sent, e.next = 9, s.scene.pay(t, qc(qc({}, n), {}, {
                  beforeRedirect: function () {
                    var e = c(l.mark(function e(r) {
                      return l.wrap(function (e) {
                        for (;;) {
                          switch (e.prev = e.next) {
                            case 0:
                              if (s.reporter.reportData("call_pay_end_with_redirect", {
                                nextAction: t
                              }), !n || null == n || !n.beforeRedirect) {
                                e.next = 3;
                                break;
                              }

                              return e.abrupt("return", n.beforeRedirect(r));

                            case 3:
                            case "end":
                              return e.stop();
                          }
                        }
                      }, e);
                    }));
                    return function (t) {
                      return e.apply(this, arguments);
                    };
                  }(),
                  sessionId: i.sessionId
                }))["catch"](function (e) {
                  return s.reporter.handleError(e, "scene_pay_error", {
                    nextAction: t
                  });
                });

              case 9:
                s.reporter.reportData("call_pay_end_no_error"), e.next = 19;
                break;

              case 12:
                return e.prev = 12, e.t0 = e["catch"](0), a = "call_pay_end_with_error", u = {
                  paymentError: R.handleAPIErrorData(e.t0.data)
                }, s.reporter.reportData(a, {
                  payResult: u
                }), s.reporter.reportError(e.t0, a, {
                  payResult: u,
                  nextAction: t
                }), e.abrupt("return", u);

              case 19:
              case "end":
                return e.stop();
            }
          }

          var p;
        }, e, null, [[0, 12]]);
      }));
      return function (t, n) {
        return e.apply(this, arguments);
      };
    }()), _a2(this, "getCurrentCardInfo", c(l.mark(function e() {
      var t;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, s.reporter.reportData("getCurrentCardInfo_start"), s.initData.paymentMethod === Fe.CreditCard) {
                e.next = 4;
                break;
              }

              throw new R("The API does not support the payment method", v.NotSupportApi, "NotSupportApi");

            case 4:
              return e.next = 6, s.scene.getCurrentCardInfo()["catch"](function (e) {
                return s.reporter.handleError(e, "getCurrentCardInfo_error");
              });

            case 6:
              return t = e.sent, s.reporter.reportData("getCurrentCardInfo_end", {
                cardInfo: t
              }), e.abrupt("return", t);

            case 11:
              e.prev = 11, e.t0 = e["catch"](0), s.reporter.handleError(e.t0, "getCurrentCardInfo_error");

            case 14:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 11]]);
    }))), _a2(this, "destroy", function () {
      try {
        s.reporter.reportData("destroy_start"), s.isRenderFail ? (s.reporter.reportData("destroy_checkResult_fail"), s.renderChecker.destroy()) : s.scene.destroy(), s.reporter.reportData("destroy_end");
      } catch (e) {
        s.reporter.handleError(e, "destroy_error");
      }
    }), this.initReporter(t);

    try {
      this.reporter.reportData("constructor_start", t);
      var u = qc({}, t);
      this.env = function (e) {
        e.env = e.env && Ge[e.env] ? e.env : qe;
        var t = Me({}, Ge[e.env]);
        return e.env === qe ? e.host = void 0 : t && (t.host = e.host || t.host, e.host = t.host), Object.freeze(t);
      }(u), u.channelId = void 0 !== u.channelId ? u.channelId : "SLPayments", ue.setTag("host", this.env.host), ue.setTag("channelId", u.channelId), ue.setTag("paymentMethod", u.paymentMethod), ue.setTag("merchantId", u.merchantId), ue.setTag("clientId", u.clientId), u.host = Xe(u.host), this.initData = Object.freeze(u), this.isNotSupportBrowser = (i = navigator.userAgent, Hc.every(function (e) {
        var t = e.exec(i);
        return !!(t && Number(t[1]) < 11);
      })), this.reporter.addReportData(this.initData), this.isRenderFail = !1, this.check(), this.metaData = Object.freeze(O(this.initData, ["currency", "countryCode", "channelId", "paymentMethod", "merchantId"])), this.element = o, this.scene = new n(this.env, this.initData), this.renderChecker = new Uc(this.env, this.initData), this.reporter.reportData("constructor_end", u);
    } catch (e) {
      this.reporter.handleError(e, "constructor_error");
    }
  }

  var t, n, o;
  return i(e, [{
    key: "check",
    value: function value() {
      if (this.isNotSupportBrowser) throw new R("Not support browser", v.NotSupportBrowser, "NotSupportBrowser");
      if ([Fe.CreditCard, Fe.FPX].indexOf(this.initData.paymentMethod) > -1 && Ja()) throw this.reporter.reportData("init_not_support_browser"), new R(v.NotSupportBrowser, v.NotSupportBrowser, "NotSupportBrowser");
    }
  }, {
    key: "initReporter",
    value: function value(e) {
      try {
        he.init(e), this.reporter = new ve(e);
      } catch (e) {
        he.handleError(e, "init_reporter_error");
      }
    }
  }, {
    key: "parseLanguage",
    value: function value() {
      var e = this.initData.language,
          t = void 0 === e ? "en" : e;
      return "string" == typeof t ? t : (null == t ? void 0 : t.extend) || "en";
    }
  }, {
    key: "initRisk",
    value: (o = c(l.mark(function e() {
      var t = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return this.reporter.reportData("init_risk_start"), e.abrupt("return", (this.paySession = new Ne(this.env, this.initData.host).init().then(function (e) {
                t.reporter.addReportData({
                  sessionId: e.sessionId
                });
                var n = qc(qc({}, e), {}, {
                  paymentMethod: t.initData.paymentMethod,
                  channelId: t.initData.channelId,
                  language: t.parseLanguage()
                });
                return t.reporter.reportData("init_risk_end", {
                  paySession: n
                }), n;
              }))["catch"](this.reporter.handleError));

            case 2:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return o.apply(this, arguments);
    })
  }, {
    key: "initRender",
    value: (n = c(l.mark(function e() {
      var t;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.renderChecker.getInitResult()["catch"](this.reporter.handleError);

            case 2:
              if (t = e.sent, e.t0 = this.scene.afterInit, !e.t0) {
                e.next = 7;
                break;
              }

              return e.next = 7, this.scene.afterInit(t);

            case 7:
              if (e.t1 = this.element, !e.t1) {
                e.next = 11;
                break;
              }

              return e.next = 11, this.renderWidget(this.element);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, this);
    })), function () {
      return n.apply(this, arguments);
    })
  }, {
    key: "render",
    value: (t = c(l.mark(function e(t) {
      var n,
          r,
          o,
          i = this;
      return l.wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, this.renderChecker.getInitResult()["catch"](this.reporter.handleError);

            case 3:
              if ((n = e.sent).status !== es.Success) {
                e.next = 14;
                break;
              }

              if (e.t0 = this.scene.beforeRender, !e.t0) {
                e.next = 9;
                break;
              }

              return e.next = 9, this.scene.beforeRender(t, n)["catch"](function (e) {
                return i.reporter.handleError(e, "scene_before_render_error");
              });

            case 9:
              return e.next = 11, this.scene.render(t, n)["catch"](function (e) {
                return i.reporter.handleError(e, "scene_render_error");
              });

            case 11:
              this.reporter.reportData("render_success"), e.next = 18;
              break;

            case 14:
              if (n.status !== es.Fail) {
                e.next = 18;
                break;
              }

              throw (r = new R(n.msg)).data = n, r;

            case 18:
              e.next = 29;
              break;

            case 20:
              return e.prev = 20, e.t1 = e["catch"](0), e.next = 24, this.renderChecker.renderFail(t)["catch"](this.reporter.handleError);

            case 24:
              throw this.isRenderFail = !0, this.reporter.reportData("render_fail"), (o = new D(e.t1.message, v.RenderFail, "RenderFail")).setAPIErrorData(e.t1.data), o;

            case 29:
            case "end":
              return e.stop();
          }
        }
      }, e, this, [[0, 20]]);
    })), function (e) {
      return t.apply(this, arguments);
    })
  }, {
    key: "getRenderElement",
    value: function value(e) {
      var t = e;
      return "string" == typeof e && (t = document.querySelector(e), console.assert(t, "请检查元素 ".concat(e, " 是否存在, 注意: id 需要加 '#' 前缀, class 需要加 '.' 前缀"))), t || he.reportError(new R("render element does not exist"), "getRenderElement_error"), t;
    }
  }]), e;
}();

function Zc(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();

  return function () {
    var n,
        r = b(e);

    if (t) {
      var o = b(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);

    return _(this, n);
  };
}

var Xc = function (e) {
  h(n, Gc);
  var t = Zc(n);

  function n(e, o) {
    r(this, n);
    var i = Fc(e);
    return t.call(this, e, i, o);
  }

  return n;
}();

function Kc(e) {
  return $c.apply(this, arguments);
}

function $c() {
  return ($c = c(l.mark(function e(t) {
    var n;
    return l.wrap(function (e) {
      for (;;) {
        switch (e.prev = e.next) {
          case 0:
            he.reportData("isSupportPaymentMethod_start", {
              paymentMethod: t
            }), n = !0, e.t0 = t, e.next = e.t0 === Fe.WeChatPay ? 5 : e.t0 === Fe.ApplePay ? 7 : 11;
            break;

          case 5:
            return n = Ma(), e.abrupt("break", 12);

          case 7:
            return e.next = 9, Na();

          case 9:
            return n = e.sent, e.abrupt("break", 12);

          case 11:
            return e.abrupt("break", 12);

          case 12:
            return he.reportData("isSupportPaymentMethod_end", {
              paymentMethod: t,
              result: n
            }), e.abrupt("return", n);

          case 14:
          case "end":
            return e.stop();
        }
      }
    }, e);
  }))).apply(this, arguments);
}

export { Xc as Payment, Fe as PaymentMethod, Ye as PaymentSDKPlugin, Ke as PluginScene, $e as initRisk, Kc as isSupportPaymentMethod, n as version };